// src/i18n/index.js
// Use dynamic imports to avoid MIME type issues with JSON files
const messages_en = {
  "auth.signInPrompt.closeLabel": "Close",
  "auth.signInPrompt.description": "Create a free account to save jobs, sync progress, and pick up your search on any device.",
  "auth.signInPrompt.primaryAction": "Sign in now",
  "auth.signInPrompt.secondaryAction": "Maybe later",
  "auth.signInPrompt.title": "Sign in to save jobs",
  "autocomplete.filters": "Filter matches",
  "autocomplete.noMatches": "No filter matches found",
  "autocomplete.scrollHint": "Scroll for more",
  "backoffice.architecture": "Architecture",
  "backoffice.dashboard": "Dashboard",
  "backoffice.testing": "Testing",
  "backoffice.title": "Backoffice",
  "blog.author": "Author",
  "blog.hubArticles": "Articles in this hub:",
  "blog.keywords": "Keywords",
  "breadcrumb.benefits": "Benefits",
  "breadcrumb.company": "Company",
  "breadcrumb.educationLevel": "Education",
  "breadcrumb.industry": "Industry",
  "breadcrumb.isDriversLicenseRequired": "Driver's License",
  "breadcrumb.isOpenApplication": "Open Application",
  "breadcrumb.isSummerJob": "Summer Job",
  "breadcrumb.jobType": "Job Type",
  "breadcrumb.jobs": "Jobs",
  "breadcrumb.language": "Language",
  "breadcrumb.level": "Level",
  "breadcrumb.location": "Location",
  "breadcrumb.peopleManagementTier": "Management",
  "breadcrumb.remote": "Remote",
  "breadcrumb.skillsAndTechnologies": "Skills/Tech",
  "business.conclusion": "Thank you for trusting us with your job search. We're excited to be part of your journey toward finding meaningful employment—and, ultimately, a more empowered future for everyone.",
  "business.empowerment": "We believe jobs are the most empowering tool for personal and social growth. When people are empowered, they become positive agents of change in their communities—and we want to see a better world for everyone.",
  "business.feedback.description": "Help us improve by sharing your thoughts and suggestions.",
  "business.feedback.title": "We Value Your Feedback",
  "business.intro": "Welcome to our ethical job website for Finland, proudly owned and operated by TechTactics Oy. Our goal is simple: to help individuals find meaningful employment opportunities, especially during times of unemployment or career transition.",
  "business.platform": "Our platform is designed with empathy and accessibility in mind. We strive to make the job search process transparent and fair, ensuring that every job listed offers genuine opportunities for growth, security, and stability.",
  "business.proUnion": "We are pro-union and stand firmly against businesses that exploit workers or harm communities. At TechTactics Oy, we only partner with organizations that share our vision: investing in people, their well-being, and the greater good.",
  "business.tagline": "Built by TechTactics Oy to empower fair, transparent hiring in Finland.",
  "business.title": "About Our Ethical Platform",
  "common.workInProgress": "This page is a work in progress. Some features may not be fully functional yet.",
  "company.logoAlt": "{company} logo",
  "companyChart.caption.averaging": "averaging {avg} jobs per month",
  "companyChart.caption.fieldDistributionDouble": "{companyName} focuses mostly on {field1} and {field2}.",
  "companyChart.caption.fieldDistributionSingle": "{companyName} focuses mostly on {field}.",
  "companyChart.caption.fieldDistributionTriple": "{companyName} focuses mostly on {field1}, {field2}, and {field3}.",
  "companyChart.caption.hiringDeclining": "{companyName}'s hiring is declining",
  "companyChart.caption.hiringGrowing": "{companyName}'s hiring is growing",
  "companyChart.caption.hiringRapidlyDeclining": "{companyName}'s hiring is rapidly declining",
  "companyChart.caption.hiringRapidlyGrowing": "{companyName}'s hiring is rapidly growing",
  "companyChart.caption.hiringStable": "{companyName}'s hiring is stable",
  "companyChart.caption.languageRequirementsDouble": "{companyName} typically requires {language1} and {language2}.",
  "companyChart.caption.languageRequirementsSingle": "{companyName} typically requires {language}.",
  "companyChart.caption.languageRequirementsTriple": "{companyName} typically requires {language1}, {language2}, and {language3}.",
  "companyChart.caption.levelDistributionDouble": "{companyName} hires mostly at the {level1} and {level2} levels.",
  "companyChart.caption.levelDistributionSingle": "{companyName} hires mostly at the {level} level.",
  "companyChart.caption.levelDistributionTriple": "{companyName} hires mostly at the {level1}, {level2}, and {level3} levels.",
  "companyChart.caption.locationDistributionDouble": "{companyName} hires mostly in {location1} and {location2}.",
  "companyChart.caption.locationDistributionSingle": "{companyName} hires mostly in {location}.",
  "companyChart.caption.locationDistributionTriple": "{companyName} hires mostly in {location1}, {location2}, and {location3}.",
  "companyChart.caption.margin": "and a profit margin of {margin}",
  "companyChart.caption.marginOnly": "{companyName} had a profit margin of {margin} in 2024",
  "companyChart.caption.profitable": "{companyName} was profitable in 2024",
  "companyChart.caption.remotenessHybrid": "{companyName} hires mostly hybrid positions.",
  "companyChart.caption.remotenessOnsite": "{companyName} hires mostly onsite positions.",
  "companyChart.caption.remotenessRemote": "{companyName} hires mostly remote positions.",
  "companyChart.caption.revenue": "{companyName} had revenue of {revenue} in 2024",
  "companyChart.caption.revenueWith": "with revenue of {revenue}",
  "companyChart.caption.roleDistributionDouble": "{companyName} hires mostly {role1} and {role2} roles.",
  "companyChart.caption.roleDistributionSingle": "{companyName} hires mostly {role} roles.",
  "companyChart.caption.roleDistributionTriple": "{companyName} hires mostly {role1}, {role2}, and {role3} roles.",
  "companyChart.caption.unprofitable": "{companyName} was unprofitable in 2024",
  "companyChart.caption.workforceRate": "({rate}% of their workforce)",
  "companyChart.financialOverview": "Financial Overview (2024)",
  "companyChart.insufficientData": "Limited data available - trends require at least 3 months of data",
  "companyChart.monthlyHiringTrends": "Monthly Hiring Trends",
  "companyChart.profit": "Profit",
  "companyChart.profitMargin": "Profit Margin",
  "companyChart.revenue": "Revenue",
  "companyChart.trend.declining": "Declining",
  "companyChart.trend.growing": "Growing",
  "companyChart.trend.insufficientData": "Limited Data",
  "companyChart.trend.rapidlyDeclining": "Rapidly Declining",
  "companyChart.trend.rapidlyGrowing": "Rapidly Growing",
  "companyChart.trend.stable": "Stable",
  "companyChart.trendDescription.declining": "Hiring {avg} jobs/month ({rate}% of workforce)",
  "companyChart.trendDescription.growing": "Hiring {avg} jobs/month ({rate}% of workforce)",
  "companyChart.trendDescription.rapidlyDeclining": "Hiring {avg} jobs/month ({rate}% of workforce)",
  "companyChart.trendDescription.rapidlyGrowing": "Hiring {avg} jobs/month ({rate}% of workforce)",
  "companyChart.trendDescription.simpleDeclining": "Hiring {avg} jobs/month on average",
  "companyChart.trendDescription.simpleGrowing": "Hiring {avg} jobs/month on average",
  "companyChart.trendDescription.simpleStable": "Hiring {avg} jobs/month on average",
  "companyChart.trendDescription.stable": "Hiring {avg} jobs/month ({rate}% of workforce)",
  "companyHeader.jobCount": "{count, plural, one {# open position} other {# open positions}}",
  "companyHeader.locationCount": "{count, plural, one {# location} other {# locations}}",
  "dashboard.actions": "Actions",
  "dashboard.addComment": "Add Comment",
  "dashboard.addComment.placeholder": "Add a comment...",
  "dashboard.adding": "Adding...",
  "dashboard.address": "Address",
  "dashboard.algoliaIndexingErrors": "Algolia Indexing Errors ({count})",
  "dashboard.all": "All",
  "dashboard.allAts": "All ATS",
  "dashboard.allCompanies": "All Companies",
  "dashboard.allStatus": "All Status",
  "dashboard.ats": "ATS",
  "dashboard.atsSystem": "ATS System",
  "dashboard.businessId": "Business ID",
  "dashboard.careersUrl": "Careers URL",
  "dashboard.check": "Mark as checked",
  "dashboard.clearDlq": "Clear DLQ",
  "dashboard.clearFilters": "Clear Filters",
  "dashboard.clearLogoFailures": "Clear Logo Failures ({count})",
  "dashboard.comments": "Comments",
  "dashboard.companiesHeader": "Companies ({count} of {total})",
  "dashboard.companyAttributes": "Company Attributes",
  "dashboard.companyBasic": "Company Basic",
  "dashboard.companyBasic.short": "Basic Info",
  "dashboard.companyBusiness": "Business Info",
  "dashboard.companyContact": "Contact",
  "dashboard.companyCrawl": "Crawl Settings",
  "dashboard.companyFinancial": "Financial",
  "dashboard.companyId": "Company ID",
  "dashboard.companyIndustry": "Industry",
  "dashboard.companyInformation": "Company Information",
  "dashboard.companyLocation": "Location",
  "dashboard.companyName": "Company Name",
  "dashboard.companyRegistry": "Registry",
  "dashboard.companySocial": "Social Media",
  "dashboard.companyUrl": "Company URL",
  "dashboard.coordinates": "Coordinates",
  "dashboard.crawlDlq": "Crawl DLQ",
  "dashboard.crawlKey": "Crawl Key",
  "dashboard.crawlRecords": "Crawl Records",
  "dashboard.crawlStatistics": "Crawl Statistics",
  "dashboard.crawlType": "Crawl Type",
  "dashboard.crawlingInformation": "Crawling Information",
  "dashboard.deleteComment": "Delete comment",
  "dashboard.detailPages": "Detail Pages",
  "dashboard.details": "Details",
  "dashboard.dlqEmpty": "DLQ is empty - no failed messages",
  "dashboard.dlqMessageCount": "{count} {count, plural, one {message} other {messages}} in DLQ",
  "dashboard.dlqViewer": "Dead Letter Queue Viewer",
  "dashboard.duration": "Duration",
  "dashboard.enqueueUrlPattern": "Enqueue URL Pattern",
  "dashboard.error": "Error",
  "dashboard.failed": "Failed",
  "dashboard.failedToLoadCompanySettings": "Failed to load company settings: {error}",
  "dashboard.filterByField": "Filter by Field",
  "dashboard.filterValue": "Filter value... (use __NOT_EMPTY__ for non-empty)",
  "dashboard.filters": "Filters",
  "dashboard.greenSuccess": "Green (Success)",
  "dashboard.groupBy": "Group By",
  "dashboard.groupCrawlCount": "Crawl Count",
  "dashboard.groupJobsCount": "Jobs Count",
  "dashboard.groupLogoFailed": "Logo Status",
  "dashboard.groupMetrics": "Metrics",
  "dashboard.groupNone": "None",
  "dashboard.groupPaginationIssue": "Pagination Issues",
  "dashboard.groupStatus": "Status (Red/Yellow/Green)",
  "dashboard.groupStatusIssues": "Status & Issues",
  "dashboard.groupSuccessRate": "Success Rate",
  "dashboard.hasComments": "Has Comments",
  "dashboard.hasCrawlData.label": "Crawl Data",
  "dashboard.hasCrawlData.option": "Has Data",
  "dashboard.heroImage": "Hero Image",
  "dashboard.howToRunCrawl": "How to Run a Crawl",
  "dashboard.html": "HTML",
  "dashboard.industry": "Industry",
  "dashboard.isChecked": "Checked",
  "dashboard.isSaved": "Saved",
  "dashboard.issuesOnly": "Issues Only",
  "dashboard.itemsPerPage": "Items per page",
  "dashboard.jobsEnqueued": "{count} jobs enqueued",
  "dashboard.jobsExtracted": "Jobs Extracted",
  "dashboard.jobsFound": "Jobs Found",
  "dashboard.listPages": "List Pages",
  "dashboard.listPagesEnqueued": "{count} list pages",
  "dashboard.loadAllCompanies": "Load all companies (86k)",
  "dashboard.loadedCompanies": "Loaded: {current} of {total} companies",
  "dashboard.loadedCompaniesUnknown": "Loaded: {current} companies",
  "dashboard.loadingAllCompanies": "Loading all companies - slower initial load",
  "dashboard.loadingBatch": "Processing batch {current} of approximately {total}",
  "dashboard.loadingCompanies": "Loading Company Data",
  "dashboard.loadingCompaniesWithUrls": "Loading only companies with website URLs - faster",
  "dashboard.loadingNote": "This may take a few minutes. Please keep this page open.",
  "dashboard.logoFailed": "Logo Failed",
  "dashboard.logoOk": "Logo OK",
  "dashboard.logs": "Logs",
  "dashboard.map": "Map",
  "dashboard.mostRecent": "Most Recent",
  "dashboard.next": "Next",
  "dashboard.noCrawlData.message": "No crawl data available yet. Expand the \"How to Run a Crawl\" section above for instructions on running a crawl and exporting the data.",
  "dashboard.noCrawlData.option": "No Data",
  "dashboard.noFieldFilter": "No Field Filter",
  "dashboard.noIssues": "No Issues",
  "dashboard.notSent": "Not sent",
  "dashboard.pageInfo": "Page {current} of {total}",
  "dashboard.pageType": "Page Type",
  "dashboard.paginationIssueDescription": "Exactly {count} jobs sent - may indicate incomplete pagination.",
  "dashboard.potentialPaginationIssue": "Potential Pagination Issue",
  "dashboard.previous": "Previous",
  "dashboard.processDlq": "Process DLQ",
  "dashboard.recordCount": "{count} {count, plural, one {record} other {records}}",
  "dashboard.recrawl": "Recrawl",
  "dashboard.recrawlTriggered": "Recrawl triggered for {companyName}",
  "dashboard.redFailed": "Red (Failed)",
  "dashboard.refreshCompanies": "Refresh Companies",
  "dashboard.refreshCrawlData": "Refresh Crawl Data",
  "dashboard.refreshing": "Refreshing...",
  "dashboard.registryInformation": "Registry Information",
  "dashboard.result": "Result",
  "dashboard.runMaintainer": "Run Maintainer",
  "dashboard.running": "Running...",
  "dashboard.save": "Save for later",
  "dashboard.scanningDatabase": "Scanning database and loading companies...",
  "dashboard.searchCompanies": "Search companies...",
  "dashboard.sentForProcessing": "✓ Sent for processing",
  "dashboard.sentToProcessor": "Sent to Processor",
  "dashboard.showing": "Showing {filtered} of {total} companies",
  "dashboard.skipped": "Skipped",
  "dashboard.skippedJobExists": "Skipped - job already exists",
  "dashboard.socialMedia": "Social Media",
  "dashboard.sortAscending": "Ascending",
  "dashboard.sortBasic": "Basic",
  "dashboard.sortBy": "Sort By",
  "dashboard.sortCrawls": "Crawls",
  "dashboard.sortDescending": "Descending",
  "dashboard.sortDetailPages": "Detail Pages",
  "dashboard.sortDirection": "Sort {direction}",
  "dashboard.sortFailed": "Failed Crawls",
  "dashboard.sortJobs": "Jobs",
  "dashboard.sortJobsExtracted": "Total Jobs Extracted",
  "dashboard.sortJobsFound": "Total Jobs Found",
  "dashboard.sortJobsSent": "Jobs Sent to Processor",
  "dashboard.sortLastCrawl": "Last Crawl Date",
  "dashboard.sortListPages": "List Pages",
  "dashboard.sortMostRecentJobs": "Most Recent Jobs Found",
  "dashboard.sortName": "Company Name",
  "dashboard.sortPages": "Pages",
  "dashboard.sortStatus": "Status",
  "dashboard.sortSuccessRate": "Success Rate",
  "dashboard.sortSuccessful": "Successful Crawls",
  "dashboard.status": "Status",
  "dashboard.successRate": "Success Rate",
  "dashboard.successful": "Successful",
  "dashboard.syncingCompanySettings": "Syncing company settings...",
  "dashboard.time": "Time",
  "dashboard.title": "Crawl Dashboard",
  "dashboard.totalCrawls": "Total Crawls",
  "dashboard.uncheck": "Uncheck",
  "dashboard.unsave": "Remove from saved",
  "dashboard.url": "URL",
  "dashboard.viewAttributes": "View Attributes",
  "dashboard.viewCloudWatchLogs": "View CloudWatch logs for this crawl",
  "dashboard.viewHtml": "View HTML",
  "dashboard.viewJobs": "View",
  "dashboard.viewMessageBody": "View Message Body",
  "dashboard.viewOnGoogleMaps": "View on Google Maps",
  "dashboard.yellowNoJobs": "Yellow (No Jobs)",
  "error.404.message": "Sorry, we couldn't find the page you're looking for. It might have been moved, deleted, or you entered the wrong URL.",
  "error.404.title": "Page Not Found",
  "error.500.message": "We're experiencing some technical difficulties. Please try again later or contact support if the problem persists.",
  "error.500.title": "Something Went Wrong",
  "error.actions.goBack": "Go Back",
  "error.actions.goHome": "Go Home",
  "error.actions.searchJobs": "Search Jobs",
  "error.jobNotFound.message": "The job you're looking for doesn't exist or has been removed.",
  "error.jobNotFound.title": "Job Not Found",
  "facets.benefits": "Benefit",
  "facets.company": "Company",
  "facets.companyIndustry": "Industry",
  "facets.education": "Education",
  "facets.field": "Field",
  "facets.jobType": "Job type",
  "facets.language": "Language",
  "facets.location": "Location",
  "facets.management": "Leadership",
  "facets.remoteness": "Work setup",
  "facets.role": "Role",
  "facets.roleLevel": "Role level",
  "facets.skills": "Skill",
  "feedback.button.label": "Give us feedback",
  "feedback.cancel": "Cancel",
  "feedback.error": "Failed to submit feedback. Please try again.",
  "feedback.label": "Your Feedback",
  "feedback.modal.close": "Close",
  "feedback.modal.description": "We'd love to hear your thoughts. Share your feedback to help us improve.",
  "feedback.modal.title": "Send Feedback",
  "feedback.page.anonymous": "Anonymous",
  "feedback.page.delete": "Delete feedback",
  "feedback.page.deleteConfirm": "Are you sure you want to delete this feedback?",
  "feedback.page.deleteError": "Failed to delete feedback. Please try again.",
  "feedback.page.description": "View and manage user feedback",
  "feedback.page.listTitle": "All Feedback",
  "feedback.page.noFeedback": "No feedback yet",
  "feedback.page.refresh": "Refresh",
  "feedback.page.submitTitle": "Submit Feedback",
  "feedback.page.title": "Feedback",
  "feedback.page.viewMetadata": "View metadata",
  "feedback.placeholder": "Tell us what we should change or add...",
  "feedback.submit": "Submit",
  "feedback.submitting": "Submitting...",
  "feedback.success": "Thank you! Your feedback has been submitted.",
  "filters.allFilters.navigation": "All filter options",
  "filters.connector.and": "AND",
  "filters.connector.or": "OR",
  "filters.navigation": "Filter options",
  "footer.aiTranslationDisclaimer": "Note: Some content on this website contains machine-translations using AI and may contain errors.",
  "footer.business": "For Employers",
  "footer.copyright": "© 2025 {company} All rights reserved.",
  "footer.fromTheBlog": "From the blog",
  "footer.jobcrawlsEn": "JobCrawls (English)",
  "footer.jobcrawlsFi": "JobCrawls (Finnish)",
  "footer.jobcrawlsSv": "JobCrawls (Swedish)",
  "footer.jobsInEspoo": "Jobs in Espoo",
  "footer.jobsInEurope": "Jobs in Europe",
  "footer.jobsInFinland": "Jobs in Finland",
  "footer.jobsInHelsinki": "Jobs in Helsinki",
  "footer.jobsInJyvaskyla": "Jobs in Jyväskylä",
  "footer.jobsInKuopio": "Jobs in Kuopio",
  "footer.jobsInLahti": "Jobs in Lahti",
  "footer.jobsInLappeenranta": "Jobs in Lappeenranta",
  "footer.jobsInOulu": "Jobs in Oulu",
  "footer.jobsInPori": "Jobs in Pori",
  "footer.jobsInTampere": "Jobs in Tampere",
  "footer.jobsInTurku": "Jobs in Turku",
  "footer.jobsInVaasa": "Jobs in Vaasa",
  "footer.jobsInVantaa": "Jobs in Vantaa",
  "footer.locationsHub": "Explore location hubs",
  "footer.majorFinnishCities": "Major Finnish Cities",
  "footer.moreFinnishCities": "More Finnish Cities",
  "footer.privacy": "Privacy Policy",
  "footer.remoteEuropeJobs": "Remote - Europe Jobs",
  "footer.remoteGlobalJobs": "Remote - Global Jobs",
  "footer.remoteMENAJobs": "Remote - MENA Jobs",
  "footer.remoteWorkAndCountries": "Remote Work & Countries",
  "footer.resources": "Resources",
  "footer.terms": "Terms of Service",
  "hit.applicationDeadline": "Deadline: {date}",
  "hit.applicationDeadline.detail": "Deadline: {date}",
  "hit.applied": "Applied",
  "hit.companyLinkTitle": "Search for jobs at {company}",
  "hit.driversLicenseRequired": "Driver's Licence Required",
  "hit.hidden": "Hidden",
  "hit.hide": "Hide job",
  "hit.hide.button": "Hide",
  "hit.hide.menu": "Hide",
  "hit.jobTitle": "Job",
  "hit.jobTypeLinkAria": "Search for {jobType} jobs",
  "hit.jobTypeLinkTitle": "Search for {jobType} jobs",
  "hit.linkCopied": "Link copied to clipboard!",
  "hit.locationLinkAria": "Search for jobs in {location}",
  "hit.locationLinkTitle": "Search for jobs in {location}",
  "hit.locationNotAvailable": "Location not available",
  "hit.markAsApplied": "Mark as applied",
  "hit.markAsApplied.menu": "Mark as Applied",
  "hit.markAsState": "Mark as {state}",
  "hit.moreLocations": "+{count} more",
  "hit.moreOptions": "More options",
  "hit.noBenefitsBanner.login": "Log in and add your current job details to see how your salary compares",
  "hit.noBenefitsBanner.save": "Save jobs you are interested in to compare salaries and benefits side-by-side.",
  "hit.openApplication": "Open Application",
  "hit.postedDate": "Posted: {date}",
  "hit.postedDate.detail": "Posted: {date}",
  "hit.remotenessLinkAria": "Search for {remoteness} jobs",
  "hit.remotenessLinkTitle": "Search for {remoteness} jobs",
  "hit.removeApplied": "Remove from applied",
  "hit.roleLevelLinkAria": "Search for {roleLevel} jobs",
  "hit.roleLevelLinkLabel": "{roleLevel} jobs",
  "hit.roleLevelLinkTitle": "Search for {roleLevel} jobs",
  "hit.salaryNotSpecified": "Salary not specified",
  "hit.salaryNotSpecified.card": "Salary not specified",
  "hit.save": "Save",
  "hit.save.detail": "Save",
  "hit.saved": "Saved",
  "hit.saved.detail": "Saved",
  "hit.seeAd": "Details",
  "hit.share": "Share",
  "hit.share.detail": "Share",
  "hit.shareError": "Something went wrong while trying to share this job.",
  "hit.summerJob": "Summer Job",
  "hit.toast.applied": "Marked as applied",
  "hit.toast.hidden": "Job hidden",
  "hit.toast.saved": "Job saved",
  "hit.toast.shared": "Link copied to clipboard",
  "hit.toast.unapplied": "Removed from applied",
  "hit.toast.unhidden": "Job unhidden",
  "hit.toast.unsaved": "Job removed from saved",
  "hit.toast.viewed": "Marked as viewed",
  "hit.tooltip.details": "View full job details and description",
  "hit.tooltip.filterByCompany": "Filter jobs by this company",
  "hit.tooltip.filterByJobType": "Filter jobs by type: {jobType}",
  "hit.tooltip.filterByLanguages": "Filter jobs by required languages: {languages}",
  "hit.tooltip.filterByLevel": "Filter jobs by level: {level}",
  "hit.tooltip.filterByLocation": "Filter jobs in: {locations}",
  "hit.tooltip.filterByRemoteness": "Filter jobs by remoteness: {remoteness}",
  "hit.tooltip.moreOptions": "More options",
  "hit.tooltip.save": "Save this job to compare with others",
  "hit.tooltip.saved": "Remove from saved jobs",
  "hit.tooltip.share": "Share this job",
  "hit.tooltip.viewJob": "View full job details",
  "hit.lastSeen.minutesAgo": "{value, plural, one {{value} minute ago} other {{value} minutes ago}}",
  "hit.lastSeen.hoursAgo": "{value, plural, one {{value} hour ago} other {{value} hours ago}}",
  "hit.lastSeen.daysAgo": "{value, plural, one {{value} day ago} other {{value} days ago}}",
  "hit.unhide": "Unhide job",
  "instantsearch.searchBoxLink.placeholder": "Search for jobs",
  "instantsearch.searchbox.placeholder": "Search jobs, language, or city",
  "job.copyCompanyName": "Copy company name",
  "job.viewDetails": "View Details",
  "jobDetail.similarJobs.description": "Discover more opportunities that match your interests and skills",
  "jobDetail.similarJobs.title": "Related Opportunities",
  "jobDetailPage.404.backHome": "Back to Home",
  "jobDetailPage.404.description": "Sorry, we couldn't find this job. It may have been removed or the link is incorrect.",
  "jobDetailPage.404.heading": "This page is not found",
  "jobDetailPage.aboutCompany": "About",
  "jobDetailPage.applicationDeadline": "Application Deadline",
  "jobDetailPage.applied": "Applied ✓",
  "jobDetailPage.applyNavigation": "Apply to job",
  "jobDetailPage.applyNow": "Apply on Company Website",
  "jobDetailPage.availableLanguages": "Available in:",
  "jobDetailPage.breadcrumb": "Breadcrumb navigation",
  "jobDetailPage.businessId": "Business ID",
  "jobDetailPage.byRemoteness": "By Remoteness",
  "jobDetailPage.chartsDataRange": "Data shown is based on historical job postings from our database.",
  "jobDetailPage.collapseCompensation": "Collapse compensation details",
  "jobDetailPage.companiesHiringInLocation": "Companies Hiring in {location}",
  "jobDetailPage.companyAge": "Company Age",
  "jobDetailPage.companyDistributionDescription": "Showing top {count} companies by number of job postings",
  "jobDetailPage.compensation": "Compensation",
  "jobDetailPage.contact": "Contact:",
  "jobDetailPage.description": "Job Description",
  "jobDetailPage.estimatedExpiry": "Estimated Expiry",
  "jobDetailPage.expandCompensation": "Expand compensation details",
  "jobDetailPage.experience": "Experience",
  "jobDetailPage.field": "Field",
  "jobDetailPage.headcount": "Headcount",
  "jobDetailPage.hideCharts": "Hide Charts",
  "jobDetailPage.hideOriginalJobText": "Hide",
  "jobDetailPage.jobActions": "Job actions",
  "jobDetailPage.jobType": "Job Type",
  "jobDetailPage.languageNavigation": "Available languages",
  "jobDetailPage.languageRequirements": "Language Requirements",
  "jobDetailPage.loadingMap": "Loading map...",
  "jobDetailPage.location": "Location",
  "jobDetailPage.locationAndRemotenessDistribution": "Location & Remoteness Distribution",
  "jobDetailPage.locationDistribution": "Location Distribution",
  "jobDetailPage.mapError": "Unable to load map",
  "jobDetailPage.matchBreakdown.benefits": "Benefits",
  "jobDetailPage.matchBreakdown.jobType": "Job Type",
  "jobDetailPage.matchBreakdown.location": "Location",
  "jobDetailPage.matchBreakdown.remoteness": "Remoteness",
  "jobDetailPage.matchBreakdown.roleLevel": "Role Level",
  "jobDetailPage.matchBreakdown.salary": "Salary",
  "jobDetailPage.matchBreakdown.title": "How this job matches your profile",
  "jobDetailPage.matchBreakdown.titleMatch": "Title",
  "jobDetailPage.matchBreakdown.vacation": "Vacation",
  "jobDetailPage.minimumYearsOfExperience": "{years} {years, plural, one {year} other {years}}",
  "jobDetailPage.minimumYearsOfExperience.title": "Minimum Years of Experience",
  "jobDetailPage.minimumYearsOfExperience.value": "{years} {years, plural, one {year} other {years}}",
  "jobDetailPage.noItems": "No items to show.",
  "jobDetailPage.noLocation": "No location",
  "jobDetailPage.noRemoteness": "Not specified",
  "jobDetailPage.notFound.backHome": "Back to Home",
  "jobDetailPage.notFound.description": "We couldn't find the job you're looking for. It may have been removed or the URL might be incorrect.",
  "jobDetailPage.notFound.title": "Job Not Found",
  "jobDetailPage.optionalLanguages": "Optional Languages",
  "jobDetailPage.originalJobText": "Original Job Text",
  "jobDetailPage.originalLanguage": "Original",
  "jobDetailPage.peopleManagementTier": "Management Tier",
  "jobDetailPage.period.day": "day",
  "jobDetailPage.period.hour": "hour",
  "jobDetailPage.period.month": "month",
  "jobDetailPage.period.year": "year",
  "jobDetailPage.perks": "Perks",
  "jobDetailPage.remoteness": "Remoteness",
  "jobDetailPage.remotenessDistribution": "Remoteness Distribution",
  "jobDetailPage.remotenessDistribution.short": "Remoteness",
  "jobDetailPage.requiredLanguages": "Required Languages",
  "jobDetailPage.requirements": "Requirements",
  "jobDetailPage.responsibilities": "Responsibilities",
  "jobDetailPage.roleAndRoleLevelDistribution": "Role & Role Level Distribution",
  "jobDetailPage.roleDistribution": "Role Distribution",
  "jobDetailPage.roleLevel": "Role Level",
  "jobDetailPage.roleLevelDistribution": "Role Level Distribution",
  "jobDetailPage.salaryDetails": "Salary Details",
  "jobDetailPage.salaryStatistics": "Salary Statistics",
  "jobDetailPage.section.company": "Company Information",
  "jobDetailPage.section.jobDetails": "Job Details",
  "jobDetailPage.section.overview": "Overview",
  "jobDetailPage.seeLocation": "See Location",
  "jobDetailPage.seeOriginal": "See original",
  "jobDetailPage.showCharts": "Show Charts",
  "jobDetailPage.showCompanyContact": "Show Company Contact",
  "jobDetailPage.showContact": "Show Contact Email",
  "jobDetailPage.showConverted": "Show EUR/month",
  "jobDetailPage.showOriginalJobText": "Show Original Job Text",
  "jobDetailPage.showingItemsAboveThreshold": "Showing only items above {percentage}%",
  "jobDetailPage.specialisations": "Specialisations",
  "jobDetailPage.vacationWeeks": "Vacation: {weeks} weeks",
  "jobDetailPage.viewBenefits": "View benefits",
  "jobDetailPage.visa": "Visa",
  "jobDetailPage.visaSponsor": "✓ Sponsorship available",
  "jobDetailPage.visaSponsor.available": "✓ Visa sponsorship is available for this position",
  "jobDetailPage.visaSponsor.title": "Visa Sponsorship",
  "jobDetailPage.watchCompanyVideo": "Watch Company Video",
  "locationCharts.languages.description": "Languages companies in {location} typically require",
  "locationCharts.languages.title": "Language Requirements",
  "locationCharts.remoteness.description": "Remote work support in {location}",
  "locationCharts.remoteness.title": "Work Arrangements",
  "locationCharts.salary.allTitles": "All Roles",
  "locationCharts.salary.description": "Salary ranges in {location} (based on {sampleSize} salaries)",
  "locationCharts.salary.descriptionWithTitle": "Salary ranges for {title} in {location}",
  "locationCharts.salary.max": "Max",
  "locationCharts.salary.median": "Median",
  "locationCharts.salary.min": "Min",
  "locationCharts.salary.title": "Salary Ranges",
  "locationCharts.topCompanies.description": "Companies with most job postings in {location} over the last year",
  "locationCharts.topCompanies.title": "Top Companies Hiring",
  "locationHeader.clearLocation": "Clear location filter",
  "locationHeader.companyCount": "{count, plural, one {# company} other {# companies}}",
  "locationHeader.industryCount": "{count, plural, one {# industry} other {# industries}}",
  "locationHeader.title": "Open jobs in {location}",
  "locationHeader.trends.loading": "Loading location insights...",
  "locationHub.activeJobs": "Jobs",
  "locationHub.avgSalary": "Salary",
  "locationHub.hero.description": "Explore major Finnish cities with real-time job counts, salary insights, and market data. Discover your next opportunity in Finland's thriving tech ecosystem.",
  "locationHub.hero.subtitle": "Curated city guides and job searches across Finland",
  "locationHub.hero.title": "Finland Job Market",
  "locationHub.hero.title.breadcrumb": "Explore Jobs by Location",
  "locationHub.languages": "Languages",
  "locationHub.metropolitan.seo": "The Helsinki Metropolitan area, including Espoo and Vantaa, is Finland's primary economic engine, offering the highest density of English-speaking and remote roles with excellent transport connectivity (HSL).",
  "locationHub.overview.description": "Explore Finland's leading technology and innovation centers with real-time job market data, salary insights, and industry trends.",
  "locationHub.overview.title": "Major Tech Hubs",
  "locationHub.quickJump.overview": "Overview",
  "locationHub.resourcesLink": "Explore Job Market Insights & Career Tips",
  "locationHub.structuredData.collectionPage.description": "Discover job opportunities in major Finnish cities with salary insights and market data",
  "locationHub.structuredData.collectionPage.name": "Finland Locations Hub",
  "locationHub.structuredData.itemList.description": "Explore job opportunities across major cities in Finland",
  "locationHub.structuredData.itemList.name": "Finland Job Locations",
  "locationHub.table.activeJobs": "Active Jobs",
  "locationHub.table.avgSalary": "Avg Salary",
  "locationHub.table.city": "City",
  "locationHub.table.specialty": "Specialty",
  "locationHub.workModel": "Work Model",
  "map.jobs": "jobs",
  "map.jobsInView": "Jobs in view",
  "map.loading": "Loading map...",
  "map.noJobs": "No jobs in this area",
  "map.noLocations": "No jobs with location data to display on map",
  "map.tokenMissing": "Map view requires Mapbox access token",
  "marketHeader.collapsed.subtitle": "Click to expand and see market details about {location}",
  "marketHeader.filter.english": "English Only",
  "marketHeader.filter.highSalary": "High Salary",
  "marketHeader.filter.remote": "Remote Jobs",
  "marketHeader.filterNavigation": "Location filters",
  "marketHeader.language.chartDescription": "Language requirement distribution chart for {location} showing {englishPercent}% English and {localPercent}% local language requirements.",
  "marketHeader.language.english": "English",
  "marketHeader.language.finlandComparison": "Finland: {finlandEnglish}% English",
  "marketHeader.language.label": "Language Demand",
  "marketHeader.language.mixed": "Mixed",
  "marketHeader.qa.languageQuestion": "What languages are required in {location}?",
  "marketHeader.qa.remoteAnswer": "Yes, {answer}",
  "marketHeader.qa.remoteQuestion": "Is {location} remote-friendly?",
  "marketHeader.qa.salaryQuestion": "What is the average salary in {location}?",
  "marketHeader.salary.finlandComparison": "Finland avg: {finlandAvg}",
  "marketHeader.salary.label": "Salary Trends",
  "marketHeader.salary.range": "Salary range",
  "marketHeader.salary.rangePercentile": "25th-75th percentile range",
  "marketHeader.samples": "{count} samples",
  "marketHeader.table.activeJobs": "Active Jobs",
  "marketHeader.table.avgSalary": "Avg Salary",
  "marketHeader.table.englishLanguageRequirementPercent": "English Language Requirement %",
  "marketHeader.table.location": "Location",
  "marketHeader.table.metric": "Metric",
  "marketHeader.table.remoteWorkPercent": "Remote Work %",
  "marketHeader.table.topHiringCompany": "Top Hiring Company",
  "marketHeader.table.value": "Value",
  "marketHeader.title": "Open jobs in {location}",
  "marketHeader.toggle": "Toggle market header",
  "marketHeader.updated": "Updated:",
  "marketHeader.viewLocationHub": "View location hub",
  "marketHeader.workModel.breakdown.hybrid": "{percent}% hybrid",
  "marketHeader.workModel.breakdown.onsite": "{percent}% onsite",
  "marketHeader.workModel.breakdown.remote": "{percent}% remote",
  "marketHeader.workModel.chartDescription": "Work model distribution chart for {location} showing {onsitePercent}% onsite, {hybridPercent}% hybrid, and {remotePercent}% remote positions.",
  "marketHeader.workModel.finlandComparison": "Finland: {finlandRemote}% remote/hybrid",
  "marketHeader.workModel.hybridPercent": "{percent}% Hybrid",
  "marketHeader.workModel.label": "Work Model",
  "marketHeader.workModel.noData": "Flexible",
  "marketHeader.workModel.onsitePercent": "{percent}% Onsite",
  "marketHeader.workModel.remotePercent": "{percent}% Remote",
  "matchDonut.ariaLabel": "Match score: {score}%",
  "matchDonut.breakdown.benefits": "Benefits",
  "matchDonut.breakdown.remoteness": "Remoteness",
  "matchDonut.breakdown.salary": "Salary",
  "matchDonut.breakdown.title": "Match Score Breakdown",
  "matchDonut.breakdown.vacation": "Vacation",
  "matchDonut.loginPrompt.description": "Create a profile and add your current job details to see how well jobs match your preferences",
  "matchDonut.loginPrompt.title": "Login to see your match score",
  "matchDonut.loginPromptAria": "Log in to see your match score",
  "modal.close": "Close",
  "navigation.blog": "Resources",
  "navigation.home": "Home",
  "navigation.home.breadcrumb": "Home",
  "navigation.language": "Language",
  "navigation.language.label": "Language",
  "navigation.locations": "Locations",
  "navigation.locations.menu": "Locations Hub",
  "navigation.menu": "Menu",
  "navigation.menu.heading": "Menu",
  "navigation.search": "Search Jobs",
  "navigation.search.menu": "Find Jobs",
  "numberSelector.any": "Any",
  "pagination.ariaLabel": "Job search results pagination",
  "pagination.first": "First",
  "pagination.last": "Last",
  "pagination.next": "Next",
  "pagination.previous": "Previous",
  "privacy.analytics.description": "We may use third-party analytics tools to collect information about how you use our website, including the pages you visit and the time you spend on them. This data is used solely for improving our services.",
  "privacy.analytics.title": "Analytics",
  "privacy.changes.description": "We may update this Privacy Policy from time to time. Changes will be posted on this page and become effective immediately upon posting. If you have any questions or concerns, please contact us at the email above.",
  "privacy.changes.title": "Changes to This Policy",
  "privacy.dataCollection.description": "The primary purpose of collecting your data is for analytics, helping us understand how users interact with our site in order to enhance your experience. We only collect data that is necessary to improve our website and services.",
  "privacy.dataCollection.title": "Data Collection and Use",
  "privacy.dataProtection.description": "We implement appropriate security measures to protect your data from unauthorized access, alteration, disclosure, or destruction. We retain data as long as it is necessary to fulfill the purposes described in this policy or as required by law.",
  "privacy.dataProtection.title": "Data Protection and Retention",
  "privacy.intro": "Your privacy is important to us. This policy explains how we handle your data.",
  "privacy.title": "Privacy Policy",
  "privacy.yourRights.description": "As a user in the EU, you have the right to request access to, correction, or deletion of your personal data, as well as the right to restrict or object to certain types of processing. For more information or to exercise these rights, please contact us at",
  "privacy.yourRights.title": "Your Rights",
  "profile.aiPolish": "AI Polish",
  "profile.benefits": "Benefits",
  "profile.benefitsWeight": "Benefits Weight: {weight}%",
  "profile.company": "Company Information",
  "profile.companyIndustry": "Industry",
  "profile.companyName": "Company Name",
  "profile.companyNamePlaceholder": "e.g., Acme Inc.",
  "profile.currentJob": "Current Job",
  "profile.currentJobTooltip": "Tell us about your current position. This helps us understand your background and compare opportunities.",
  "profile.cvUploadError": "Please upload a PDF file",
  "profile.cvUploadFailed": "Failed to upload CV. Please try again.",
  "profile.cvUploadSizeError": "File size must be less than 5MB",
  "profile.desiredBenefits": "Desired Benefits",
  "profile.desiredIndustries": "Company Industries",
  "profile.desiredJob": "Desired Job",
  "profile.desiredJobTooltip": "Tell us what you're looking for. You can select multiple options for each field to broaden your search.",
  "profile.desiredJobTypes": "Job Types",
  "profile.desiredLocations": "Locations",
  "profile.desiredRemoteness": "Remoteness Options",
  "profile.desiredRoleLevels": "Role Levels",
  "profile.desiredSalaryMin": "Minimum Salary",
  "profile.desiredTitles": "Job Titles",
  "profile.desiredVacationWeeks": "Minimum Vacation Weeks",
  "profile.exportCV": "Export CV",
  "profile.jobType": "Job Type",
  "profile.loading": "Loading...",
  "profile.locations": "Locations",
  "profile.matchPreferences": "Match Preferences",
  "profile.matchPreferencesDescription": "Adjust the importance of different factors when calculating your job match score. The total must equal 100%.",
  "profile.monthlyEuros": "monthly €",
  "profile.preview": "Preview",
  "profile.remoteness": "Remoteness",
  "profile.remotenessWeight": "Remoteness Weight: {weight}%",
  "profile.reset": "Reset",
  "profile.roleLevel": "Role Level",
  "profile.salary": "Salary",
  "profile.salaryWeight": "Salary Weight: {weight}%",
  "profile.selectIndustry": "Select industry",
  "profile.selectJobType": "Select job type",
  "profile.selectLocations": "Select locations",
  "profile.selectMultipleIndustries": "Select one or more industries",
  "profile.selectMultipleJobTypes": "Select one or more job types",
  "profile.selectMultipleLocations": "Select one or more locations",
  "profile.selectMultipleRemoteness": "Select one or more remoteness options",
  "profile.selectMultipleRoleLevels": "Select one or more role levels",
  "profile.selectMultipleTitles": "Select one or more job titles",
  "profile.selectRemoteness": "Select remoteness",
  "profile.selectRoleLevel": "Select your role level",
  "profile.title": "Job Title",
  "profile.titlePlaceholder": "e.g., Software Engineer",
  "profile.totalWeight": "Total",
  "profile.vacationWeeks": "Vacation Weeks",
  "profile.vacationWeight": "Vacation Weight: {weight}%",
  "profile.weeks": "weeks",
  "recentSearches.delete": "Delete",
  "recentSearches.noSearches": "You haven't performed any searches yet.",
  "recentSearches.recentSearchesTitle": "Recent Searches",
  "recentSearches.savedSearchesTitle": "Saved Searches",
  "recentSearches.viewResults": "View Results",
  "route.description.appliedJobs": "Here you can find all the jobs you've applied for.",
  "route.description.hiddenJobs": "Here you can find all the jobs you have hidden.",
  "route.description.hiredJobs": "Here you can find all the jobs you were hired for.",
  "route.description.interviewingJobs": "Here you can find all the jobs you are interviewing for.",
  "route.description.offerJobs": "Here you can find all the jobs you have received offers for.",
  "route.description.rejectedJobs": "Here you can find all the jobs you were rejected from.",
  "route.description.savedJobs": "Here you can find all the jobs you have saved for later.",
  "route.description.viewedJobs": "Here you can find all the jobs you have viewed.",
  "route.title.appliedJobs": "Applied Jobs",
  "route.title.hiddenJobs": "Hidden Jobs",
  "route.title.hiredJobs": "Hired Jobs",
  "route.title.interviewingJobs": "Interviewing Jobs",
  "route.title.offerJobs": "Offer Jobs",
  "route.title.recentSearches": "Recent Searches",
  "route.title.rejectedJobs": "Rejected Jobs",
  "route.title.savedJobs": "Saved Jobs",
  "route.title.viewedJobs": "Viewed Jobs",
  "salaryChart.companyLocation": "Company in {location}",
  "salaryChart.estimatedOffer": "Estimated Offer",
  "salaryChart.locationAverage": "In {location}: {title}",
  "salaryChart.marketAverage": "Market Average: {title}",
  "salaryChart.marketAverageRoleLevel": "Market Average: {roleLevel} Level",
  "salaryChart.salaryContext": "Salary Context: {title}",
  "salaryChart.specificOffer": "This Offer ({roleLevel})",
  "salaryChart.specificOfferNoLevel": "This Offer",
  "salaryChart.thisRole": "this role",
  "salaryChart.thisRoleLevel": "this role level",
  "salaryStats.aboveMarket": "This salary is above the market median",
  "salaryStats.accuracy.exact": "Based on similar roles at this company",
  "salaryStats.accuracy.general": "Based on market data",
  "salaryStats.accuracy.location": "Based on salaries in {location}",
  "salaryStats.atMarket": "This salary is competitive with the market median",
  "salaryStats.average": "Average",
  "salaryStats.belowMarket": "This salary is below the market median",
  "salaryStats.jobSalary": "This job",
  "salaryStats.marketRange": "Market range: {min} - {max} (median: {median})",
  "salaryStats.median": "Median",
  "salaryStats.noJobSalary": "No salary range provided for this job. Chart shows market distribution.",
  "salaryStats.noValidValues": "Salary statistics are available ({sampleSize} {samples}) but all values are zero. This may indicate the data needs to be regenerated.",
  "salaryStats.perDay": "per day",
  "salaryStats.perHour": "per hour",
  "salaryStats.perMonth": "per month",
  "salaryStats.perYear": "per year",
  "salaryStats.percentiles": "25th-75th percentile",
  "salaryStats.samples": "samples",
  "salaryStats.smallSampleWarning": "Note: Based on a small sample size ({sampleSize} {samples}). Results may not be representative.",
  "search.clear": "Clear Search",
  "search.controls.navigation": "Search controls and filters",
  "search.noresults.browseAll": "Browse All Jobs",
  "search.noresults.clearAllParameters": "Clear all search parameters",
  "search.noresults.clearSearch": "Clear Search",
  "search.noresults.description": "Try adjusting your search or filters to find more opportunities.",
  "search.noresults.filtersLabel": "Filters:",
  "search.noresults.goToFirstPage": "Go to page 1",
  "search.noresults.industries": "Industries",
  "search.noresults.jobRoles": "Job Roles",
  "search.noresults.locations": "Locations",
  "search.noresults.pageLabel": "Page:",
  "search.noresults.popularCategories": "Popular Categories",
  "search.noresults.queryLabel": "Query:",
  "search.noresults.removeQuery": "Remove",
  "search.noresults.searchParameters": "Your Search Parameters",
  "search.noresults.searchTips": "Search Tips",
  "search.noresults.tip1": "Try using broader search terms or remove some filters",
  "search.noresults.tip2": "Check your spelling or try alternative keywords",
  "search.noresults.tip3": "Browse popular categories above to discover new opportunities",
  "search.noresults.title": "No results found",
  "search.noresults.trySearches": "Try these searches:",
  "search.refinements.allFilters": "All Filters",
  "search.refinements.allFilters.aria": "All Filters",
  "search.refinements.benefits": "Benefits",
  "search.refinements.benefits.label": "Benefits",
  "search.refinements.benefits.modal": "Benefits",
  "search.refinements.company": "Company",
  "search.refinements.company.heading": "Company",
  "search.refinements.company.label": "Company",
  "search.refinements.company.modal": "Company",
  "search.refinements.company.searchPlaceholder": "Search companies...",
  "search.refinements.company.section": "Company",
  "search.refinements.educationLevel": "Education Level",
  "search.refinements.educationLevel.detail": "Education Level",
  "search.refinements.educationLevel.heading": "Education Level",
  "search.refinements.educationLevel.label": "Education Level",
  "search.refinements.educationLevel.modal": "Education Level",
  "search.refinements.excludeApplied.checkbox": "Exclude Applied Jobs",
  "search.refinements.excludeApplied.label": "Exclude Applied Jobs",
  "search.refinements.excludeSaved.checkbox": "Exclude Saved Jobs",
  "search.refinements.excludeSaved.label": "Exclude Saved Jobs",
  "search.refinements.excludeViewed.checkbox": "Exclude Viewed Jobs",
  "search.refinements.excludeViewed.label": "Exclude Viewed Jobs",
  "search.refinements.field": "Field",
  "search.refinements.field.label": "Field",
  "search.refinements.field.modal": "Field",
  "search.refinements.headcount": "Company Headcount (max)",
  "search.refinements.headcount.max": "Max Headcount",
  "search.refinements.industry": "Industry",
  "search.refinements.industry.heading": "Industry",
  "search.refinements.industry.label": "Industry",
  "search.refinements.industry.modal": "Industry",
  "search.refinements.isDriversLicenseRequired.filter": "Driver's Licence Required",
  "search.refinements.isDriversLicenseRequired.toggle": "Driver's Licence Required",
  "search.refinements.isOpenApplication.filter": "Open Application",
  "search.refinements.isOpenApplication.toggle": "Open Application",
  "search.refinements.isSummerJob.filter": "Summer Job",
  "search.refinements.isSummerJob.toggle": "Summer Job",
  "search.refinements.job": "Job",
  "search.refinements.job.modal": "Job Filters",
  "search.refinements.job.section": "Job",
  "search.refinements.jobTitle": "Job Title",
  "search.refinements.jobType": "Job Type",
  "search.refinements.jobType.label": "Job Type",
  "search.refinements.jobType.modal": "Job Type",
  "search.refinements.languages": "Languages",
  "search.refinements.languages.label": "Languages",
  "search.refinements.languages.modal": "Languages",
  "search.refinements.lastSeen": "Last Seen",
  "search.refinements.lastSeen.aria": "Last Seen",
  "search.refinements.lastSeen.all": "All",
  "search.refinements.lastSeen.past6Hours": "Past 6 hours",
  "search.refinements.lastSeen.past24Hours": "Past 24 hours",
  "search.refinements.lastSeen.past3Days": "Past 3 days",
  "search.refinements.lastSeen.past1Week": "Past 1 week",
  "search.refinements.lastSeen.past2Weeks": "Past 2 weeks",
  "search.refinements.lastSeen.past1Month": "Past 1 month",
  "search.refinements.location": "Location",
  "search.refinements.location.finland": "Finland",
  "search.refinements.location.modal": "Location",
  "search.refinements.location.remote": "Remote",
  "search.refinements.location.searchPlaceholder": "Search locations...",
  "search.refinements.location.section": "Location",
  "search.refinements.peopleManagementTier": "People Management Tier",
  "search.refinements.peopleManagementTier.label": "People Management Tier",
  "search.refinements.peopleManagementTier.modal": "People Management Tier",
  "search.refinements.remoteness.heading": "Remoteness",
  "search.refinements.remoteness.label": "Remoteness",
  "search.refinements.remoteness.modal": "Remoteness",
  "search.refinements.roleLevel": "Role Level",
  "search.refinements.roleLevel.label": "Role Level",
  "search.refinements.roleLevel.modal": "Role Level",
  "search.refinements.salary": "Salary",
  "search.refinements.salary.heading": "Salary",
  "search.refinements.salary.label": "Salary",
  "search.refinements.salary.min": "Minimum Salary",
  "search.refinements.salary.modal": "Salary",
  "search.refinements.salary.section": "Salary",
  "search.refinements.showJobsInFinlandOnly": "Show jobs in Finland only",
  "search.refinements.showLess": "Show less",
  "search.refinements.showMore": "Show more",
  "search.refinements.skillsAndTechnologies": "Skills & Technologies",
  "search.refinements.skillsAndTechnologies.label": "Skills & Technologies",
  "search.refinements.skillsAndTechnologies.modal": "Skills & Technologies",
  "search.refinements.vacationWeeks": "Vacation Weeks",
  "search.refinements.vacationWeeks.heading": "Vacation Weeks",
  "search.refinements.vacationWeeks.label": "Vacation Weeks",
  "search.refinements.vacationWeeks.modal": "Vacation Weeks",
  "search.results.title": "Job Search Results",
  "search.save": "Save Search",
  "search.signInCta.badge": "Sync your search",
  "search.signInCta.button": "Sign in to sync progress",
  "search.signInCta.description": "Sign in to keep saved jobs, searches, and progress synced across every device.",
  "search.signInCta.title": "Save your job hunt everywhere",
  "search.toast.saved": "Search saved",
  "search.toast.unsaved": "Search removed",
  "search.unsave": "Remove Saved Search",
  "sort.ariaLabel": "Sort results",
  "sort.newest": "Newest",
  "sort.relevance": "Relevance",
  "sort.salary": "Highest Salary",
  "stats.appliedJobs": "{count} applied jobs",
  "stats.finlandJobsSubtitle": "Jobs available in Finnish or remotely to Finnish residents",
  "stats.savedJobs": "{count} saved jobs",
  "stats.viewedJobs": "{count} viewed jobs",
  "studentsAndGraduates.description": "Kickstart your career with entry-level positions, internships, and graduate programs in Finland. Perfect for students, recent graduates, and those looking to start their professional journey.",
  "studentsAndGraduates.tip": "💡 Tip: These positions are specifically designed for those starting their careers. Look for keywords like 'intern', 'junior', 'graduate', or 'trainee' in job titles.",
  "studentsAndGraduates.title": "Jobs for Students & Graduates",
  "studentsAndGraduates.title.breadcrumb": "Students & Graduates",
  "summerJobs.description": "Find the perfect summer job opportunity in Finland. Whether you're a student looking for seasonal work or someone seeking a summer career change, discover positions across various industries.",
  "summerJobs.tip": "💡 Tip: Summer jobs in Finland typically run from May to August, with many positions posted in early spring. Start your search early to secure the best opportunities!",
  "summerJobs.title": "Summer Jobs in Finland",
  "summerJobs.title.breadcrumb": "Summer Jobs",
  "terms.acceptance.description": "By using our website and services, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service, as well as our Privacy Policy. If you do not agree with any part of these terms, you should discontinue use of our services.",
  "terms.acceptance.title": "1. Acceptance of Terms",
  "terms.changes.description": "We may update these Terms of Service from time to time. When we do, we will post the revised terms on this page. Your continued use of our site after any changes constitutes your acceptance of the new terms.",
  "terms.changes.title": "7. Changes to These Terms",
  "terms.contact.description": "If you have any questions about these Terms of Service, please contact us at:",
  "terms.contact.title": "8. Contact Us",
  "terms.intellectualProperty.description": "All content, trademarks, and data on this site, including text, graphics, images, and software, are owned by JobCrawls or its licensors. You may not use or reproduce any portion of the site's content without written permission from us.",
  "terms.intellectualProperty.title": "3. Intellectual Property",
  "terms.intro": "Welcome to JobCrawls! By accessing and using our website, you agree to be bound by these Terms of Service. Please read them carefully before using our platform. We are a Finnish company, and these terms are governed by applicable Finnish and EU laws.",
  "terms.limitationOfLiability.description": "JobCrawls and its affiliates will not be liable for any indirect, incidental, special, or consequential damages arising out of or in any way connected with the use of our website or services. In all cases, our liability is limited to the maximum extent permitted by Finnish and EU law.",
  "terms.limitationOfLiability.title": "4. Limitation of Liability",
  "terms.modifications.description": "We reserve the right to modify, suspend, or discontinue any aspect of our service at any time without prior notice. We will not be liable should we exercise this right.",
  "terms.modifications.title": "5. Modifications to the Service",
  "terms.termination.description": "We may terminate or suspend your access to our website immediately, without prior notice, if we determine that you have breached these Terms of Service or for any other reason deemed necessary.",
  "terms.termination.title": "6. Termination",
  "terms.title": "Terms of Service",
  "terms.userObligations.description": "You agree to use JobCrawls in compliance with all applicable laws and regulations. You must not use our site in a way that violates the rights of others or restricts or inhibits anyone else's use and enjoyment of the site.",
  "terms.userObligations.title": "2. User Obligations",
  "tools.applicationState.applied": "Applied",
  "tools.applicationState.hidden": "Hidden",
  "tools.applicationState.label": "State:",
  "tools.applicationState.updated": "State updated to {state}",
  "tools.appliedJobs": "Applied Jobs",
  "tools.appliedJobs.link": "Applied Jobs",
  "tools.hiddenJobs": "Hidden Jobs",
  "tools.hiddenJobs.link": "Hidden Jobs",
  "tools.hiredJobs": "Hired Jobs",
  "tools.hiredJobs.link": "Hired Jobs",
  "tools.interviewingJobs": "Interviewing Jobs",
  "tools.interviewingJobs.link": "Interviewing Jobs",
  "tools.jobFlow": "Job Flow",
  "tools.jobFlow.link": "Job Flow",
  "tools.jobFlowSankey.applied": "Applied",
  "tools.jobFlowSankey.browsed": "Browsed",
  "tools.jobFlowSankey.description": "Visualize your job application journey from browsed to applied",
  "tools.jobFlowSankey.hired": "Hired",
  "tools.jobFlowSankey.interviewing": "Interviewing",
  "tools.jobFlowSankey.offer": "Offer",
  "tools.jobFlowSankey.rejected": "Rejected",
  "tools.jobFlowSankey.saved": "Saved",
  "tools.jobFlowSankey.title": "Job Application Flow",
  "tools.jobFlowSankey.viewed": "Viewed",
  "tools.offerJobs": "Offer Jobs",
  "tools.offerJobs.link": "Offer Jobs",
  "tools.recentSearches": "Recent Searches",
  "tools.recentSearches.link": "Recent Searches",
  "tools.rejectedJobs": "Rejected Jobs",
  "tools.rejectedJobs.link": "Rejected Jobs",
  "tools.savedJobs": "Saved Jobs",
  "tools.savedJobs.link": "Saved Jobs",
  "tools.title": "Tools",
  "tools.title.aria": "Tools",
  "tools.title.button": "Tools",
  "tools.viewedJobs": "Viewed Jobs",
  "tools.viewedJobs.link": "Viewed Jobs",
  "tooltip.allFilters": "Open all filters to refine your job search by location, salary, work type, and more",
  "tooltip.filter.category": "Filter jobs by {category}",
  "tooltip.filter.english": "Filter to show only jobs that require English language",
  "tooltip.filter.highSalary": "Filter to show only jobs with high salary (€5000+/month)",
  "tooltip.filter.remote": "Filter to show only remote or hybrid work opportunities",
  "tooltip.language": "Change website language (English, Finnish, Swedish)",
  "tooltip.logo": "Go to homepage and clear search",
  "tooltip.menu": "Open menu to access saved jobs, profile, and settings",
  "tooltip.nav.home": "Return to the homepage",
  "tooltip.nav.locations": "Explore job markets by city and region",
  "tooltip.nav.resources": "Browse articles and guides about working in Finland",
  "tooltip.nav.search": "Search and filter job listings",
  "tooltip.toggleHeader": "Toggle market header",
  "tooltip.tools": "Access job search tools and utilities",
  "tooltip.view.grid": "Switch to grid view to see job cards in a grid layout",
  "tooltip.view.list": "Switch to list view to see jobs in a compact list format",
  "tooltip.view.map": "Switch to map view to see job locations on a map",
  "usermenu.appliedJobs": "Applied Jobs",
  "usermenu.blog": "Resources & Blog",
  "usermenu.blog.link": "Resources",
  "usermenu.installPwa": "Install App",
  "usermenu.jobFlow": "Your Activity",
  "usermenu.login": "Login",
  "usermenu.logout": "Log Out",
  "usermenu.profile": "My Profile",
  "usermenu.recentSearches": "Recent Searches",
  "usermenu.savedJobs": "Saved Jobs",
  "usermenu.theme": "Theme",
  "usermenu.theme.light": "Light",
  "usermenu.theme.dark": "Dark",
  "usermenu.theme.auto": "Auto",
  "usermenu.viewedJobs": "Viewed Jobs",
  "view.grid": "Grid view",
  "view.list": "List view",
  "view.map": "Map view",
  "translation.test": "Translation Test: English"
};

const messages_sv = {
  ...messages_en, // Use English as fallback
  "auth.signInPrompt.closeLabel": "Stäng",
  "auth.signInPrompt.description": "Skapa ett gratis konto för att spara jobb, synka dina framsteg och fortsätta din sökning på valfri enhet.",
  "auth.signInPrompt.primaryAction": "Logga in nu",
  "auth.signInPrompt.secondaryAction": "Kanske senare",
  "auth.signInPrompt.title": "Logga in för att spara jobb",
  "autocomplete.filters": "Matchande filter",
  "autocomplete.noMatches": "Inga matchande filter hittades",
  "autocomplete.scrollHint": "Scrolla för fler",
  "backoffice.architecture": "Arkitektur",
  "backoffice.dashboard": "Instrumentpanel",
  "backoffice.testing": "Testning",
  "blog.author": "Författare",
  "blog.hubArticles": "Artiklar i den här hubben:",
  "blog.keywords": "Nyckelord",
  "breadcrumb.benefits": "Förmåner",
  "breadcrumb.company": "Företag",
  "breadcrumb.educationLevel": "Utbildning",
  "breadcrumb.industry": "Bransch",
  "breadcrumb.isDriversLicenseRequired": "Körkort",
  "breadcrumb.isOpenApplication": "Öppen ansökan",
  "breadcrumb.isSummerJob": "Sommarjobb",
  "breadcrumb.jobType": "Anställningstyp",
  "breadcrumb.jobs": "Jobb",
  "breadcrumb.language": "Språk",
  "breadcrumb.level": "Nivå",
  "breadcrumb.location": "Plats",
  "breadcrumb.peopleManagementTier": "Ledarskap",
  "breadcrumb.remote": "Distans",
  "breadcrumb.skillsAndTechnologies": "Kompetenser/Tech",
  "business.conclusion": "Tack för att du anförtrott oss din jobbsökning. Vi ser fram emot att få vara en del av din resa mot att hitta ett meningsfullt arbete – och i slutändan en mer stärkt framtid för alla.",
  "business.empowerment": "Vi tror att jobb är det mest stärkande verktyget för personlig och social utveckling. När människor får kraft och möjligheter blir de positiva förändringsaktörer i sina samhällen – och vi vill se en bättre värld för alla.",
  "business.feedback.description": "Hjälp oss att bli bättre genom att dela med dig av dina tankar och förslag.",
  "business.feedback.title": "Vi värdesätter din feedback",
  "business.intro": "Välkommen till vår etiska jobbsajt för Finland, stolt ägd och driven av TechTactics Oy. Vårt mål är enkelt: att hjälpa människor att hitta meningsfulla jobbmöjligheter, särskilt under perioder av arbetslöshet eller karriärbyte.",
  "business.platform": "Vår plattform är utformad med empati och tillgänglighet i åtanke. Vi strävar efter att göra jobbsökningsprocessen transparent och rättvis, och säkerställer att varje jobb som listas erbjuder genuina möjligheter till utveckling, trygghet och stabilitet.",
  "business.proUnion": "Vi är fackligt positiva och tar tydligt avstånd från företag som utnyttjar arbetstagare eller skadar samhällen. På TechTactics Oy samarbetar vi bara med organisationer som delar vår vision: att investera i människor, deras välmående och det gemensamma bästa.",
  "business.tagline": "Byggd av TechTactics Oy för att stärka rättvis och transparent rekrytering i Finland.",
  "business.title": "Om vår etiska plattform",
  "common.workInProgress": "Den här sidan är under utveckling. Vissa funktioner kanske inte fungerar fullt ut ännu.",
  "company.logoAlt": "{company}-logotypen",
  "companyChart.caption.averaging": "i genomsnitt {avg} jobb per månad",
  "companyChart.caption.fieldDistributionDouble": "{companyName} fokuserar främst på {field1} och {field2}.",
  "companyChart.caption.fieldDistributionSingle": "{companyName} fokuserar främst på {field}.",
  "companyChart.caption.fieldDistributionTriple": "{companyName} fokuserar främst på {field1}, {field2} och {field3}.",
  "companyChart.caption.hiringDeclining": "{companyName}s rekrytering minskar",
  "companyChart.caption.hiringGrowing": "{companyName}s rekrytering ökar",
  "companyChart.caption.hiringRapidlyDeclining": "{companyName}s rekrytering minskar snabbt",
  "companyChart.caption.hiringRapidlyGrowing": "{companyName}s rekrytering ökar snabbt",
  "companyChart.caption.hiringStable": "{companyName}s rekrytering är stabil",
  "companyChart.caption.languageRequirementsDouble": "{companyName} kräver vanligtvis {language1} och {language2}.",
  "companyChart.caption.languageRequirementsSingle": "{companyName} kräver vanligtvis {language}.",
  "companyChart.caption.languageRequirementsTriple": "{companyName} kräver vanligtvis {language1}, {language2} och {language3}.",
  "companyChart.caption.levelDistributionDouble": "{companyName} anställer främst på nivåerna {level1} och {level2}.",
  "companyChart.caption.levelDistributionSingle": "{companyName} anställer främst på nivån {level}.",
  "companyChart.caption.levelDistributionTriple": "{companyName} anställer främst på nivåerna {level1}, {level2} och {level3}.",
  "companyChart.caption.locationDistributionDouble": "{companyName} anställer främst i {location1} och {location2}.",
  "companyChart.caption.locationDistributionSingle": "{companyName} anställer främst i {location}.",
  "companyChart.caption.locationDistributionTriple": "{companyName} anställer främst i {location1}, {location2} och {location3}.",
  "companyChart.caption.margin": "och en vinstmarginal på {margin}",
  "companyChart.caption.marginOnly": "{companyName} hade en vinstmarginal på {margin} under 2024",
  "companyChart.caption.profitable": "{companyName} var lönsamt 2024",
  "companyChart.caption.remotenessHybrid": "{companyName} anställer främst för hybridtjänster.",
  "companyChart.caption.remotenessOnsite": "{companyName} anställer främst för tjänster på plats.",
  "companyChart.caption.remotenessRemote": "{companyName} anställer främst för distanstjänster.",
  "companyChart.caption.revenue": "{companyName} hade en omsättning på {revenue} 2024",
  "companyChart.caption.revenueWith": "med en omsättning på {revenue}",
  "companyChart.caption.roleDistributionDouble": "{companyName} anställer främst för roller inom {role1} och {role2}.",
  "companyChart.caption.roleDistributionSingle": "{companyName} anställer främst för roller inom {role}.",
  "companyChart.caption.roleDistributionTriple": "{companyName} anställer främst för roller inom {role1}, {role2} och {role3}.",
  "companyChart.caption.unprofitable": "{companyName} var olönsamt 2024",
  "companyChart.caption.workforceRate": "({rate}% av deras arbetsstyrka)",
  "companyChart.financialOverview": "Finansiell översikt (2024)",
  "companyChart.insufficientData": "Begränsat med data – trender kräver minst 3 månaders data",
  "companyChart.monthlyHiringTrends": "Månatliga rekryteringstrender",
  "companyChart.profit": "Vinst",
  "companyChart.profitMargin": "Vinstmarginal",
  "companyChart.revenue": "Omsättning",
  "companyChart.trend.declining": "Minskande",
  "companyChart.trend.growing": "Växande",
  "companyChart.trend.insufficientData": "Begränsat med data",
  "companyChart.trend.rapidlyDeclining": "Minskar snabbt",
  "companyChart.trend.rapidlyGrowing": "Växer snabbt",
  "companyChart.trend.stable": "Stabil",
  "companyChart.trendDescription.declining": "Anställer {avg} jobb/månad ({rate}% av arbetsstyrkan)",
  "companyChart.trendDescription.growing": "Anställer {avg} jobb/månad ({rate}% av arbetsstyrkan)",
  "companyChart.trendDescription.rapidlyDeclining": "Anställer {avg} jobb/månad ({rate}% av arbetsstyrkan)",
  "companyChart.trendDescription.rapidlyGrowing": "Anställer {avg} jobb/månad ({rate}% av arbetsstyrkan)",
  "companyChart.trendDescription.simpleDeclining": "Anställer i genomsnitt {avg} jobb/månad",
  "companyChart.trendDescription.simpleGrowing": "Anställer i genomsnitt {avg} jobb/månad",
  "companyChart.trendDescription.simpleStable": "Anställer i genomsnitt {avg} jobb/månad",
  "companyChart.trendDescription.stable": "Anställer {avg} jobb/månad ({rate}% av arbetsstyrkan)",
  "companyHeader.jobCount": "{count, plural, one {# ledig tjänst} other {# lediga tjänster}}",
  "companyHeader.locationCount": "{count, plural, one {# plats} other {# platser}}",
  "dashboard.actions": "Åtgärder",
  "dashboard.addComment": "Lägg till kommentar",
  "dashboard.addComment.placeholder": "Lägg till en kommentar...",
  "dashboard.adding": "Lägger till...",
  "dashboard.address": "Adress",
  "dashboard.algoliaIndexingErrors": "Algolia-indexeringsfel ({count})",
  "dashboard.all": "Alla",
  "dashboard.allAts": "Alla ATS",
  "dashboard.allCompanies": "Alla företag",
  "dashboard.allStatus": "Alla statusar",
  "dashboard.atsSystem": "ATS-system",
  "dashboard.businessId": "Organisationsnummer",
  "dashboard.careersUrl": "Karriär-URL",
  "dashboard.check": "Markera som kontrollerad",
  "dashboard.clearDlq": "Rensa DLQ",
  "dashboard.clearFilters": "Rensa filter",
  "dashboard.clearLogoFailures": "Rensa logomisslyckanden ({count})",
  "dashboard.comments": "Kommentarer",
  "dashboard.companiesHeader": "Företag ({count} av {total})",
  "dashboard.companyAttributes": "Företagsattribut",
  "dashboard.companyBasic": "Grundläggande företagsinfo",
  "dashboard.companyBasic.short": "Grundläggande info",
  "dashboard.companyBusiness": "Företagsinfo",
  "dashboard.companyContact": "Kontakt",
  "dashboard.companyCrawl": "Crawl-inställningar",
  "dashboard.companyFinancial": "Finansiellt",
  "dashboard.companyId": "Företags-ID",
  "dashboard.companyIndustry": "Bransch",
  "dashboard.companyInformation": "Företagsinformation",
  "dashboard.companyLocation": "Plats",
  "dashboard.companyName": "Företagsnamn",
  "dashboard.companyRegistry": "Register",
  "dashboard.companySocial": "Sociala medier",
  "dashboard.companyUrl": "Företags-URL",
  "dashboard.coordinates": "Koordinater",
  "dashboard.crawlKey": "Crawl-nyckel",
  "dashboard.crawlRecords": "Crawlposter",
  "dashboard.crawlStatistics": "Crawlstatistik",
  "dashboard.crawlType": "Crawltyp",
  "dashboard.crawlingInformation": "Crawlinformation",
  "dashboard.deleteComment": "Ta bort kommentar",
  "dashboard.detailPages": "Detaljsidor",
  "dashboard.details": "Detaljer",
  "dashboard.dlqEmpty": "DLQ är tom – inga misslyckade meddelanden",
  "dashboard.dlqMessageCount": "{count} {count, plural, one {meddelande} other {meddelanden}} i DLQ",
  "dashboard.dlqViewer": "Dead Letter Queue-visare",
  "dashboard.duration": "Varaktighet",
  "dashboard.enqueueUrlPattern": "Köa URL-mönster",
  "dashboard.error": "Fel",
  "dashboard.failed": "Misslyckade",
  "dashboard.failedToLoadCompanySettings": "Det gick inte att läsa in företagsinställningarna: {error}",
  "dashboard.filterByField": "Filtrera efter fält",
  "dashboard.filterValue": "Filtervärde... (använd __NOT_EMPTY__ för icke-tomt)",
  "dashboard.filters": "Filter",
  "dashboard.greenSuccess": "Grön (Lyckad)",
  "dashboard.groupBy": "Gruppera efter",
  "dashboard.groupCrawlCount": "Antal genomsökningar",
  "dashboard.groupJobsCount": "Antal jobb",
  "dashboard.groupLogoFailed": "Logostatus",
  "dashboard.groupMetrics": "Mått",
  "dashboard.groupNone": "Ingen",
  "dashboard.groupPaginationIssue": "Pagineringproblem",
  "dashboard.groupStatus": "Status (Röd/Gul/Grön)",
  "dashboard.groupStatusIssues": "Status och problem",
  "dashboard.groupSuccessRate": "Framgångsgrad",
  "dashboard.hasComments": "Har kommentarer",
  "dashboard.hasCrawlData.label": "Crawl-data",
  "dashboard.hasCrawlData.option": "Har data",
  "dashboard.heroImage": "Hero-bild",
  "dashboard.howToRunCrawl": "Så här kör du en crawl",
  "dashboard.industry": "Bransch",
  "dashboard.isChecked": "Kontrollerad",
  "dashboard.isSaved": "Sparad",
  "dashboard.issuesOnly": "Endast problem",
  "dashboard.itemsPerPage": "Objekt per sida",
  "dashboard.jobsEnqueued": "{count} jobb i kö",
  "dashboard.jobsExtracted": "Extraherade jobb",
  "dashboard.jobsFound": "Hittade jobb",
  "dashboard.listPages": "Listningssidor",
  "dashboard.listPagesEnqueued": "{count} listningssidor",
  "dashboard.loadAllCompanies": "Ladda alla företag (86k)",
  "dashboard.loadedCompanies": "Laddade: {current} av {total} företag",
  "dashboard.loadedCompaniesUnknown": "Laddade: {current} företag",
  "dashboard.loadingAllCompanies": "Laddar alla företag – långsammare initial inläsning",
  "dashboard.loadingBatch": "Bearbetar batch {current} av cirka {total}",
  "dashboard.loadingCompanies": "Laddar företagsdata",
  "dashboard.loadingCompaniesWithUrls": "Laddar endast företag med webbplats-URL:er – snabbare",
  "dashboard.loadingNote": "Detta kan ta några minuter. Låt den här sidan vara öppen.",
  "dashboard.logoFailed": "Logotypen kunde inte laddas",
  "dashboard.logoOk": "Logotyp OK",
  "dashboard.logs": "Loggar",
  "dashboard.map": "Karta",
  "dashboard.mostRecent": "Senaste",
  "dashboard.next": "Nästa",
  "dashboard.noCrawlData.message": "Inga crawl-data tillgängliga ännu. Expandera avsnittet ”How to Run a Crawl” ovan för instruktioner om hur du kör en crawl och exporterar data.",
  "dashboard.noCrawlData.option": "Inga data",
  "dashboard.noFieldFilter": "Inget fältfilter",
  "dashboard.noIssues": "Inga problem",
  "dashboard.notSent": "Inte skickad",
  "dashboard.pageInfo": "Sida {current} av {total}",
  "dashboard.pageType": "Sidtyp",
  "dashboard.paginationIssueDescription": "Exakt {count} jobb skickade – kan tyda på ofullständig paginering.",
  "dashboard.potentialPaginationIssue": "Möjligt pagineringsproblem",
  "dashboard.previous": "Föregående",
  "dashboard.processDlq": "Bearbeta DLQ",
  "dashboard.recordCount": "{count} {count, plural, one {post} other {poster}}",
  "dashboard.recrawl": "Kör om crawl",
  "dashboard.recrawlTriggered": "Omkörning av crawl har startats för {companyName}",
  "dashboard.redFailed": "Röd (Misslyckad)",
  "dashboard.refreshCompanies": "Uppdatera företag",
  "dashboard.refreshCrawlData": "Uppdatera crawldata",
  "dashboard.refreshing": "Uppdaterar...",
  "dashboard.registryInformation": "Registerinformation",
  "dashboard.result": "Resultat",
  "dashboard.runMaintainer": "Kör underhåll",
  "dashboard.running": "Körs...",
  "dashboard.save": "Spara till senare",
  "dashboard.scanningDatabase": "Skannar databasen och laddar företag...",
  "dashboard.searchCompanies": "Sök företag...",
  "dashboard.sentForProcessing": "✓ Skickat för bearbetning",
  "dashboard.sentToProcessor": "Skickat till Processor",
  "dashboard.showing": "Visar {filtered} av {total} företag",
  "dashboard.skipped": "Hoppades över",
  "dashboard.skippedJobExists": "Hoppades över – jobbet finns redan",
  "dashboard.socialMedia": "Sociala medier",
  "dashboard.sortAscending": "Stigande",
  "dashboard.sortBasic": "Grundläggande",
  "dashboard.sortBy": "Sortera efter",
  "dashboard.sortDescending": "Fallande",
  "dashboard.sortDetailPages": "Detaljsidor",
  "dashboard.sortDirection": "Sortera {direction}",
  "dashboard.sortFailed": "Misslyckade crawls",
  "dashboard.sortJobs": "Jobb",
  "dashboard.sortJobsExtracted": "Totalt antal extraherade jobb",
  "dashboard.sortJobsFound": "Totalt antal hittade jobb",
  "dashboard.sortJobsSent": "Jobb skickade till processorn",
  "dashboard.sortLastCrawl": "Senaste crawldatum",
  "dashboard.sortListPages": "Listningssidor",
  "dashboard.sortMostRecentJobs": "Senast hittade jobb",
  "dashboard.sortName": "Företagsnamn",
  "dashboard.sortPages": "Sidor",
  "dashboard.sortSuccessRate": "Lyckandefrekvens",
  "dashboard.sortSuccessful": "Lyckade genomsökningar",
  "dashboard.successRate": "Lyckandefrekvens",
  "dashboard.successful": "Lyckade",
  "dashboard.syncingCompanySettings": "Synkroniserar företagsinställningar...",
  "dashboard.time": "Tid",
  "dashboard.title": "Genomsökningsdashboard",
  "dashboard.totalCrawls": "Totalt antal genomsökningar",
  "dashboard.uncheck": "Avmarkera",
  "dashboard.unsave": "Ta bort från sparade",
  "dashboard.viewAttributes": "Visa attribut",
  "dashboard.viewCloudWatchLogs": "Visa CloudWatch-loggar för den här crawlningen",
  "dashboard.viewHtml": "Visa HTML",
  "dashboard.viewJobs": "Visa",
  "dashboard.viewMessageBody": "Visa meddelandetext",
  "dashboard.viewOnGoogleMaps": "Visa på Google Maps",
  "dashboard.yellowNoJobs": "Gul (Inga jobb)",
  "error.404.message": "Tyvärr kunde vi inte hitta sidan du letar efter. Den kan ha flyttats, tagits bort eller så angav du fel URL.",
  "error.404.title": "Sidan hittades inte",
  "error.500.message": "Vi har för närvarande tekniska problem. Försök igen senare eller kontakta supporten om problemet kvarstår.",
  "error.500.title": "Något gick fel",
  "error.actions.goBack": "Gå tillbaka",
  "error.actions.goHome": "Gå till startsidan",
  "error.actions.searchJobs": "Sök jobb",
  "error.jobNotFound.message": "Jobbet du söker finns inte eller har tagits bort.",
  "error.jobNotFound.title": "Jobb hittades inte",
  "facets.benefits": "Förmån",
  "facets.company": "Företag",
  "facets.companyIndustry": "Bransch",
  "facets.education": "Utbildning",
  "facets.field": "Område",
  "facets.jobType": "Anställningstyp",
  "facets.language": "Språk",
  "facets.location": "Plats",
  "facets.management": "Ledarskap",
  "facets.remoteness": "Arbetsupplägg",
  "facets.role": "Roll",
  "facets.roleLevel": "Rollnivå",
  "facets.skills": "Kompetens",
  "feedback.button.label": "Ge oss feedback",
  "feedback.cancel": "Avbryt",
  "feedback.error": "Det gick inte att skicka feedback. Försök igen.",
  "feedback.label": "Din feedback",
  "feedback.modal.close": "Stäng",
  "feedback.modal.description": "Vi vill gärna höra vad du tycker. Dela din feedback för att hjälpa oss att bli bättre.",
  "feedback.modal.title": "Skicka feedback",
  "feedback.page.anonymous": "Anonym",
  "feedback.page.delete": "Ta bort feedback",
  "feedback.page.deleteConfirm": "Är du säker på att du vill ta bort den här feedbacken?",
  "feedback.page.deleteError": "Det gick inte att ta bort feedback. Försök igen.",
  "feedback.page.description": "Visa och hantera användarfeedback",
  "feedback.page.listTitle": "All feedback",
  "feedback.page.noFeedback": "Ingen feedback än",
  "feedback.page.refresh": "Uppdatera",
  "feedback.page.submitTitle": "Skicka feedback",
  "feedback.page.viewMetadata": "Visa metadata",
  "feedback.placeholder": "Berätta vad vi borde ändra eller lägga till...",
  "feedback.submit": "Skicka",
  "feedback.submitting": "Skickar...",
  "feedback.success": "Tack! Din feedback har skickats in.",
  "filters.allFilters.navigation": "Alla filteralternativ",
  "filters.connector.and": "OCH",
  "filters.connector.or": "ELLER",
  "filters.navigation": "Filteralternativ",
  "footer.aiTranslationDisclaimer": "Obs: Viss information på den här webbplatsen innehåller maskinöversättningar med hjälp av AI och kan innehålla fel.",
  "footer.business": "För arbetsgivare",
  "footer.copyright": "© 2025 {company} Alla rättigheter förbehållna.",
  "footer.fromTheBlog": "Från bloggen",
  "footer.jobcrawlsEn": "JobCrawls (engelska)",
  "footer.jobcrawlsFi": "JobCrawls (finska)",
  "footer.jobcrawlsSv": "JobCrawls (svenska)",
  "footer.jobsInEspoo": "Jobb i Esbo",
  "footer.jobsInEurope": "Jobb i Europa",
  "footer.jobsInFinland": "Jobb i Finland",
  "footer.jobsInHelsinki": "Jobb i Helsingfors",
  "footer.jobsInJyvaskyla": "Jobb i Jyväskylä",
  "footer.jobsInKuopio": "Jobb i Kuopio",
  "footer.jobsInLahti": "Jobb i Lahtis",
  "footer.jobsInLappeenranta": "Jobb i Lappeenranta",
  "footer.jobsInOulu": "Jobb i Uleåborg",
  "footer.jobsInPori": "Jobb i Björneborg",
  "footer.jobsInTampere": "Jobb i Tammerfors",
  "footer.jobsInTurku": "Jobb i Åbo",
  "footer.jobsInVaasa": "Jobb i Vasa",
  "footer.jobsInVantaa": "Jobb i Vanda",
  "footer.locationsHub": "Utforska platsnav",
  "footer.majorFinnishCities": "Större finländska städer",
  "footer.moreFinnishCities": "Fler finländska städer",
  "footer.privacy": "Integritetspolicy",
  "footer.remoteEuropeJobs": "Distans – jobb i Europa",
  "footer.remoteGlobalJobs": "Distans – globala jobb",
  "footer.remoteMENAJobs": "Distans – jobb i MENA",
  "footer.remoteWorkAndCountries": "Distansarbete och länder",
  "footer.resources": "Resurser",
  "footer.terms": "Användarvillkor",
  "hit.applicationDeadline": "Sista ansökningsdag: {date}",
  "hit.applicationDeadline.detail": "Sista ansökningsdag: {date}",
  "hit.applied": "Ansökt",
  "hit.companyLinkTitle": "Sök efter jobb hos {company}",
  "hit.driversLicenseRequired": "Körkort krävs",
  "hit.hidden": "Dold",
  "hit.hide": "Dölj jobb",
  "hit.hide.button": "Dölj",
  "hit.hide.menu": "Dölj",
  "hit.jobTitle": "Jobb",
  "hit.jobTypeLinkAria": "Sök efter {jobType}-jobb",
  "hit.jobTypeLinkTitle": "Sök efter {jobType}-jobb",
  "hit.linkCopied": "Länken har kopierats till urklipp!",
  "hit.locationLinkAria": "Sök efter jobb i {location}",
  "hit.locationLinkTitle": "Sök efter jobb i {location}",
  "hit.locationNotAvailable": "Plats ej tillgänglig",
  "hit.markAsApplied": "Markera som ansökt",
  "hit.markAsApplied.menu": "Markera som ansökt",
  "hit.markAsState": "Markera som {state}",
  "hit.moreLocations": "+{count} till",
  "hit.moreOptions": "Fler alternativ",
  "hit.noBenefitsBanner.login": "Logga in och lägg till uppgifter om ditt nuvarande jobb för att se hur din lön står sig i jämförelse",
  "hit.noBenefitsBanner.save": "Spara jobb du är intresserad av för att jämföra löner och förmåner sida vid sida.",
  "hit.openApplication": "Öppen ansökan",
  "hit.postedDate": "Publicerad: {date}",
  "hit.postedDate.detail": "Publicerad: {date}",
  "hit.remotenessLinkAria": "Sök efter {remoteness}-jobb",
  "hit.remotenessLinkTitle": "Sök efter {remoteness}-jobb",
  "hit.removeApplied": "Ta bort från ansökta",
  "hit.roleLevelLinkAria": "Sök efter {roleLevel}-jobb",
  "hit.roleLevelLinkLabel": "{roleLevel}-jobb",
  "hit.roleLevelLinkTitle": "Sök efter {roleLevel}-jobb",
  "hit.salaryNotSpecified": "Lön ej angiven",
  "hit.salaryNotSpecified.card": "Lön ej angiven",
  "hit.save": "Spara",
  "hit.save.detail": "Spara",
  "hit.saved": "Sparad",
  "hit.saved.detail": "Sparad",
  "hit.seeAd": "Detaljer",
  "hit.share": "Dela",
  "hit.share.detail": "Dela",
  "hit.shareError": "Något gick fel när du försökte dela det här jobbet.",
  "hit.summerJob": "Sommarjobb",
  "hit.toast.applied": "Markerad som ansökt",
  "hit.toast.hidden": "Jobb dolt",
  "hit.toast.saved": "Jobb sparat",
  "hit.toast.shared": "Länk kopierad till urklipp",
  "hit.toast.unapplied": "Togs bort från ansökta",
  "hit.toast.unhidden": "Jobb visat",
  "hit.toast.unsaved": "Jobb borttaget från sparade",
  "hit.toast.viewed": "Markerad som visad",
  "hit.tooltip.details": "Visa fullständiga jobbdetaljer och beskrivning",
  "hit.tooltip.filterByCompany": "Filtrera jobb efter det här företaget",
  "hit.tooltip.filterByJobType": "Filtrera jobb efter typ: {jobType}",
  "hit.tooltip.filterByLanguages": "Filtrera jobb efter språkkrav: {languages}",
  "hit.tooltip.filterByLevel": "Filtrera jobb efter nivå: {level}",
  "hit.tooltip.filterByLocation": "Filtrera jobb i: {locations}",
  "hit.tooltip.filterByRemoteness": "Filtrera jobb efter distansläge: {remoteness}",
  "hit.tooltip.moreOptions": "Fler alternativ",
  "hit.tooltip.save": "Spara det här jobbet för att jämföra med andra",
  "hit.tooltip.saved": "Ta bort från sparade jobb",
  "hit.tooltip.share": "Dela det här jobbet",
  "hit.tooltip.viewJob": "Visa fullständig jobbinformation",
  "hit.lastSeen.minutesAgo": "{value, plural, one {{value} minut sedan} other {{value} minuter sedan}}",
  "hit.lastSeen.hoursAgo": "{value, plural, one {{value} timme sedan} other {{value} timmar sedan}}",
  "hit.lastSeen.daysAgo": "{value, plural, one {{value} dag sedan} other {{value} dagar sedan}}",
  "hit.unhide": "Visa jobb",
  "instantsearch.searchBoxLink.placeholder": "Sök efter jobb",
  "instantsearch.searchbox.placeholder": "Sök jobb, språk eller stad",
  "job.copyCompanyName": "Kopiera företagsnamn",
  "job.viewDetails": "Visa detaljer",
  "jobDetail.similarJobs.description": "Upptäck fler möjligheter som matchar dina intressen och färdigheter",
  "jobDetail.similarJobs.title": "Relaterade möjligheter",
  "jobDetailPage.404.backHome": "Tillbaka till startsidan",
  "jobDetailPage.404.description": "Tyvärr kunde vi inte hitta det här jobbet. Det kan ha tagits bort eller så är länken felaktig.",
  "jobDetailPage.404.heading": "Den här sidan hittades inte",
  "jobDetailPage.aboutCompany": "Om",
  "jobDetailPage.applicationDeadline": "Sista ansökningsdag",
  "jobDetailPage.applied": "Ansökt ✓",
  "jobDetailPage.applyNavigation": "Ansök till jobbet",
  "jobDetailPage.applyNow": "Ansök på företagets webbplats",
  "jobDetailPage.availableLanguages": "Tillgänglig på:",
  "jobDetailPage.breadcrumb": "Brödsmulenavigering",
  "jobDetailPage.businessId": "Organisationsnummer",
  "jobDetailPage.byRemoteness": "Efter distansarbete",
  "jobDetailPage.chartsDataRange": "Visade data baseras på historiska jobbannonser från vår databas.",
  "jobDetailPage.collapseCompensation": "Dölj kompensationsdetaljer",
  "jobDetailPage.companiesHiringInLocation": "Företag som anställer i {location}",
  "jobDetailPage.companyAge": "Företagets ålder",
  "jobDetailPage.companyDistributionDescription": "Visar de {count} främsta företagen efter antal jobbannonser",
  "jobDetailPage.compensation": "Ersättning",
  "jobDetailPage.contact": "Kontakt:",
  "jobDetailPage.description": "Jobbeskrivning",
  "jobDetailPage.estimatedExpiry": "Beräknat utgångsdatum",
  "jobDetailPage.expandCompensation": "Visa kompensationsdetaljer",
  "jobDetailPage.experience": "Erfarenhet",
  "jobDetailPage.field": "Område",
  "jobDetailPage.headcount": "Antal anställda",
  "jobDetailPage.hideCharts": "Dölj diagram",
  "jobDetailPage.hideOriginalJobText": "Dölj",
  "jobDetailPage.jobActions": "Jobbåtgärder",
  "jobDetailPage.jobType": "Anställningsform",
  "jobDetailPage.languageNavigation": "Tillgängliga språk",
  "jobDetailPage.languageRequirements": "Språkkrav",
  "jobDetailPage.loadingMap": "Laddar karta...",
  "jobDetailPage.location": "Plats",
  "jobDetailPage.locationAndRemotenessDistribution": "Plats- och distansfördelning",
  "jobDetailPage.locationDistribution": "Platsfördelning",
  "jobDetailPage.mapError": "Det gick inte att läsa in kartan",
  "jobDetailPage.matchBreakdown.benefits": "Förmåner",
  "jobDetailPage.matchBreakdown.jobType": "Anställningsform",
  "jobDetailPage.matchBreakdown.location": "Plats",
  "jobDetailPage.matchBreakdown.remoteness": "Distans",
  "jobDetailPage.matchBreakdown.roleLevel": "Rollnivå",
  "jobDetailPage.matchBreakdown.salary": "Lön",
  "jobDetailPage.matchBreakdown.title": "Hur det här jobbet matchar din profil",
  "jobDetailPage.matchBreakdown.titleMatch": "Titel",
  "jobDetailPage.matchBreakdown.vacation": "Semester",
  "jobDetailPage.minimumYearsOfExperience.title": "Minsta antal års erfarenhet",
  "jobDetailPage.noItems": "Inga objekt att visa.",
  "jobDetailPage.noLocation": "Ingen plats",
  "jobDetailPage.noRemoteness": "Inte angivet",
  "jobDetailPage.notFound.backHome": "Tillbaka till startsidan",
  "jobDetailPage.notFound.description": "Vi kunde inte hitta jobbet du letar efter. Det kan ha tagits bort eller så kan webbadressen vara felaktig.",
  "jobDetailPage.notFound.title": "Jobbet hittades inte",
  "jobDetailPage.optionalLanguages": "Valfria språk",
  "jobDetailPage.originalJobText": "Ursprunglig jobbtext",
  "jobDetailPage.originalLanguage": "Ursprungligt språk",
  "jobDetailPage.peopleManagementTier": "Ledningsnivå",
  "jobDetailPage.period.day": "dag",
  "jobDetailPage.period.hour": "timme",
  "jobDetailPage.period.month": "månad",
  "jobDetailPage.period.year": "år",
  "jobDetailPage.perks": "Förmåner",
  "jobDetailPage.remoteness": "Distansarbete",
  "jobDetailPage.remotenessDistribution": "Fördelning av distansarbete",
  "jobDetailPage.remotenessDistribution.short": "Distansarbete",
  "jobDetailPage.requiredLanguages": "Obligatoriska språk",
  "jobDetailPage.requirements": "Krav",
  "jobDetailPage.responsibilities": "Ansvarsområden",
  "jobDetailPage.roleAndRoleLevelDistribution": "Fördelning av roll och rollnivå",
  "jobDetailPage.roleDistribution": "Rollfördelning",
  "jobDetailPage.roleLevel": "Rollnivå",
  "jobDetailPage.roleLevelDistribution": "Fördelning av rollnivå",
  "jobDetailPage.salaryDetails": "Löneuppgifter",
  "jobDetailPage.salaryStatistics": "Lönestatistik",
  "jobDetailPage.section.company": "Företagsinformation",
  "jobDetailPage.section.jobDetails": "Jobbdetaljer",
  "jobDetailPage.section.overview": "Översikt",
  "jobDetailPage.seeLocation": "Se plats",
  "jobDetailPage.seeOriginal": "Se original",
  "jobDetailPage.showCharts": "Visa diagram",
  "jobDetailPage.showCompanyContact": "Visa företagets kontaktuppgifter",
  "jobDetailPage.showContact": "Visa kontaktens e-postadress",
  "jobDetailPage.showConverted": "Visa EUR/månad",
  "jobDetailPage.showOriginalJobText": "Visa original jobbtext",
  "jobDetailPage.showingItemsAboveThreshold": "Visar endast objekt över {percentage}%",
  "jobDetailPage.specialisations": "Specialiseringar",
  "jobDetailPage.vacationWeeks": "Semester: {weeks} veckor",
  "jobDetailPage.viewBenefits": "Visa förmåner",
  "jobDetailPage.visa": "Visum",
  "jobDetailPage.visaSponsor": "✓ Sponsring tillgänglig",
  "jobDetailPage.visaSponsor.available": "✓ Visumsponsring är tillgänglig för den här tjänsten",
  "jobDetailPage.visaSponsor.title": "Visumsponsring",
  "jobDetailPage.watchCompanyVideo": "Se företagsvideo",
  "locationCharts.languages.description": "Språk som företag i {location} vanligtvis kräver",
  "locationCharts.languages.title": "Språkkrav",
  "locationCharts.remoteness.description": "Stöd för distansarbete i {location}",
  "locationCharts.remoteness.title": "Arbetsformer",
  "locationCharts.salary.allTitles": "Alla roller",
  "locationCharts.salary.description": "Lönespann i {location} (baserat på {sampleSize} löner)",
  "locationCharts.salary.descriptionWithTitle": "Lönespann för {title} i {location}",
  "locationCharts.salary.title": "Löneintervall",
  "locationCharts.topCompanies.description": "Företag med flest jobbannonser i {location} under det senaste året",
  "locationCharts.topCompanies.title": "Företag som anställer mest",
  "locationHeader.clearLocation": "Rensa platsfilter",
  "locationHeader.companyCount": "{count, plural, one {# företag} other {# företag}}",
  "locationHeader.industryCount": "{count, plural, one {# bransch} other {# branscher}}",
  "locationHeader.title": "Lediga jobb i {location}",
  "locationHeader.trends.loading": "Läser in platsinsikter...",
  "locationHub.activeJobs": "Jobb",
  "locationHub.avgSalary": "Lön",
  "locationHub.hero.description": "Utforska stora finländska städer med jobbsiffror i realtid, löneinsikter och marknadsdata. Hitta din nästa möjlighet i Finlands blomstrande tech-ekosystem.",
  "locationHub.hero.subtitle": "Kurerade stadsguider och jobbsökningar i hela Finland",
  "locationHub.hero.title": "Finlands arbetsmarknad",
  "locationHub.hero.title.breadcrumb": "Utforska jobb efter plats",
  "locationHub.languages": "Språk",
  "locationHub.metropolitan.seo": "Helsingforsregionen, inklusive Esbo och Vanda, är Finlands främsta ekonomiska motor och erbjuder den högsta koncentrationen av engelskspråkiga och distansroller, med utmärkta transportförbindelser (HSL).",
  "locationHub.overview.description": "Utforska Finlands ledande teknik- och innovationscentrum med jobbsmarknadsdata i realtid, löneinsikter och branschtrender.",
  "locationHub.overview.title": "Större techhubbar",
  "locationHub.quickJump.overview": "Översikt",
  "locationHub.resourcesLink": "Utforska insikter om arbetsmarknaden och karriärtips",
  "locationHub.structuredData.collectionPage.description": "Upptäck jobbmöjligheter i stora finska städer med löneinsikter och marknadsdata",
  "locationHub.structuredData.collectionPage.name": "Finlands platsnav",
  "locationHub.structuredData.itemList.description": "Utforska jobbmöjligheter i stora städer i Finland",
  "locationHub.structuredData.itemList.name": "Jobbplatser i Finland",
  "locationHub.table.activeJobs": "Aktiva jobb",
  "locationHub.table.avgSalary": "Genomsnittlig lön",
  "locationHub.table.city": "Stad",
  "locationHub.table.specialty": "Specialitet",
  "locationHub.workModel": "Arbetsmodell",
  "map.jobs": "jobb",
  "map.jobsInView": "Jobb i vyn",
  "map.loading": "Laddar karta...",
  "map.noJobs": "Inga jobb i det här området",
  "map.noLocations": "Inga jobb med platsdata att visa på kartan",
  "map.tokenMissing": "Kartvyn kräver Mapbox-åtkomsttoken",
  "marketHeader.collapsed.subtitle": "Klicka för att expandera och se marknadsdetaljer om {location}",
  "marketHeader.filter.english": "Endast engelska",
  "marketHeader.filter.highSalary": "Hög lön",
  "marketHeader.filter.remote": "Distansjobb",
  "marketHeader.filterNavigation": "Platsfilter",
  "marketHeader.language.chartDescription": "Diagram över fördelningen av språkkrav för {location} som visar {englishPercent}% engelska och {localPercent}% lokala språkkrav.",
  "marketHeader.language.english": "Engelska",
  "marketHeader.language.finlandComparison": "Finland: {finlandEnglish}% engelska",
  "marketHeader.language.label": "Språkefterfrågan",
  "marketHeader.language.mixed": "Blandat",
  "marketHeader.qa.languageQuestion": "Vilka språk krävs i {location}?",
  "marketHeader.qa.remoteAnswer": "Ja, {answer}",
  "marketHeader.qa.remoteQuestion": "Är {location} distansvänligt?",
  "marketHeader.qa.salaryQuestion": "Vad är den genomsnittliga lönen i {location}?",
  "marketHeader.salary.finlandComparison": "Finland genomsnitt: {finlandAvg}",
  "marketHeader.salary.label": "Lönetrender",
  "marketHeader.salary.range": "Löneintervall",
  "marketHeader.salary.rangePercentile": "Intervall för 25:e–75:e percentilen",
  "marketHeader.samples": "{count} exempel",
  "marketHeader.table.activeJobs": "Aktiva jobb",
  "marketHeader.table.avgSalary": "Genomsnittslön",
  "marketHeader.table.englishLanguageRequirementPercent": "Krav på engelska språket %",
  "marketHeader.table.location": "Plats",
  "marketHeader.table.metric": "Mått",
  "marketHeader.table.remoteWorkPercent": "Distansarbete %",
  "marketHeader.table.topHiringCompany": "Företag som anställer mest",
  "marketHeader.table.value": "Värde",
  "marketHeader.title": "Lediga jobb i {location}",
  "marketHeader.toggle": "Växla marknadsrubrik",
  "marketHeader.updated": "Uppdaterad:",
  "marketHeader.viewLocationHub": "Visa platsöversikt",
  "marketHeader.workModel.breakdown.onsite": "{percent}% på plats",
  "marketHeader.workModel.breakdown.remote": "{percent}% på distans",
  "marketHeader.workModel.chartDescription": "Diagram över fördelning av arbetsmodell för {location} som visar {onsitePercent}% på plats, {hybridPercent}% hybrid och {remotePercent}% distanspositioner.",
  "marketHeader.workModel.finlandComparison": "Finland: {finlandRemote}% distans/hybrid",
  "marketHeader.workModel.label": "Arbetsmodell",
  "marketHeader.workModel.noData": "Flexibelt",
  "marketHeader.workModel.onsitePercent": "{percent}% På plats",
  "marketHeader.workModel.remotePercent": "{percent}% Distans",
  "matchDonut.ariaLabel": "Matchningspoäng: {score}%",
  "matchDonut.breakdown.benefits": "Förmåner",
  "matchDonut.breakdown.remoteness": "Distansarbete",
  "matchDonut.breakdown.salary": "Lön",
  "matchDonut.breakdown.title": "Uppdelning av matchningspoäng",
  "matchDonut.breakdown.vacation": "Semester",
  "matchDonut.loginPrompt.description": "Skapa en profil och lägg till dina nuvarande jobbdetaljer för att se hur väl jobb matchar dina preferenser",
  "matchDonut.loginPrompt.title": "Logga in för att se din matchningspoäng",
  "matchDonut.loginPromptAria": "Logga in för att se din matchningspoäng",
  "modal.close": "Stäng",
  "navigation.blog": "Resurser",
  "navigation.home": "Hem",
  "navigation.home.breadcrumb": "Hem",
  "navigation.language": "Språk",
  "navigation.language.label": "Språk",
  "navigation.locations": "Platser",
  "navigation.locations.menu": "Platsöversikt",
  "navigation.menu": "Meny",
  "navigation.menu.heading": "Meny",
  "navigation.search": "Sök jobb",
  "navigation.search.menu": "Hitta jobb",
  "numberSelector.any": "Valfritt",
  "pagination.ariaLabel": "Sidnavigering för jobbsökresultat",
  "pagination.first": "Första",
  "pagination.last": "Sista",
  "pagination.next": "Nästa",
  "pagination.previous": "Föregående",
  "privacy.analytics.description": "Vi kan använda analysverktyg från tredje part för att samla in information om hur du använder vår webbplats, inklusive vilka sidor du besöker och hur lång tid du tillbringar på dem. Dessa uppgifter används enbart för att förbättra våra tjänster.",
  "privacy.analytics.title": "Analys",
  "privacy.changes.description": "Vi kan uppdatera denna integritetspolicy från tid till annan. Ändringar publiceras på denna sida och träder i kraft omedelbart vid publicering. Om du har några frågor eller funderingar, vänligen kontakta oss via e-postadressen ovan.",
  "privacy.changes.title": "Ändringar i denna policy",
  "privacy.dataCollection.description": "Det primära syftet med att samla in dina uppgifter är analys, vilket hjälper oss att förstå hur användare interagerar med vår webbplats för att förbättra din upplevelse. Vi samlar endast in uppgifter som är nödvändiga för att förbättra vår webbplats och våra tjänster.",
  "privacy.dataCollection.title": "Insamling och användning av data",
  "privacy.dataProtection.description": "Vi vidtar lämpliga säkerhetsåtgärder för att skydda dina uppgifter mot obehörig åtkomst, ändring, utlämnande eller förstöring. Vi sparar uppgifter så länge det är nödvändigt för att uppfylla de syften som beskrivs i denna policy eller enligt vad som krävs enligt lag.",
  "privacy.dataProtection.title": "Dataskydd och lagring",
  "privacy.intro": "Din integritet är viktig för oss. Denna policy förklarar hur vi hanterar dina uppgifter.",
  "privacy.title": "Integritetspolicy",
  "privacy.yourRights.description": "Som användare i EU har du rätt att begära tillgång till, rättelse av eller radering av dina personuppgifter, samt rätt att begränsa eller invända mot vissa typer av behandling. För mer information eller för att utöva dessa rättigheter, vänligen kontakta oss på",
  "privacy.yourRights.title": "Dina rättigheter",
  "profile.aiPolish": "AI-förbättra",
  "profile.benefits": "Förmåner",
  "profile.benefitsWeight": "Förmåners vikt: {weight}%",
  "profile.company": "Företagsinformation",
  "profile.companyIndustry": "Bransch",
  "profile.companyName": "Företagsnamn",
  "profile.companyNamePlaceholder": "t.ex. Acme Inc.",
  "profile.currentJob": "Nuvarande jobb",
  "profile.currentJobTooltip": "Berätta om din nuvarande tjänst. Det hjälper oss att förstå din bakgrund och jämföra möjligheter.",
  "profile.cvUploadError": "Ladda upp en PDF-fil",
  "profile.cvUploadFailed": "Det gick inte att ladda upp CV:t. Försök igen.",
  "profile.cvUploadSizeError": "Filstorleken måste vara mindre än 5 MB",
  "profile.desiredBenefits": "Önskade förmåner",
  "profile.desiredIndustries": "Företagsbranscher",
  "profile.desiredJob": "Önskat jobb",
  "profile.desiredJobTooltip": "Berätta vad du letar efter. Du kan välja flera alternativ för varje fält för att bredda din sökning.",
  "profile.desiredJobTypes": "Jobbtyper",
  "profile.desiredLocations": "Platser",
  "profile.desiredRemoteness": "Distansalternativ",
  "profile.desiredRoleLevels": "Rollnivåer",
  "profile.desiredSalaryMin": "Lägsta lön",
  "profile.desiredTitles": "Jobbtitlar",
  "profile.desiredVacationWeeks": "Minsta antal semesterveckor",
  "profile.exportCV": "Exportera CV",
  "profile.jobType": "Anställningstyp",
  "profile.loading": "Laddar...",
  "profile.locations": "Platser",
  "profile.matchPreferences": "Matchningspreferenser",
  "profile.matchPreferencesDescription": "Justera hur viktiga olika faktorer ska vara när din jobbmatchningspoäng beräknas. Summan måste vara 100 %.",
  "profile.monthlyEuros": "€/månad",
  "profile.preview": "Förhandsgranska",
  "profile.remoteness": "Distansarbete",
  "profile.remotenessWeight": "Viktning för distansarbete: {weight}%",
  "profile.reset": "Återställ",
  "profile.roleLevel": "Rollnivå",
  "profile.salary": "Lön",
  "profile.salaryWeight": "Lönevikting: {weight}%",
  "profile.selectIndustry": "Välj bransch",
  "profile.selectJobType": "Välj anställningsform",
  "profile.selectLocations": "Välj platser",
  "profile.selectMultipleIndustries": "Välj en eller flera branscher",
  "profile.selectMultipleJobTypes": "Välj en eller flera anställningsformer",
  "profile.selectMultipleLocations": "Välj en eller flera platser",
  "profile.selectMultipleRemoteness": "Välj ett eller flera distansalternativ",
  "profile.selectMultipleRoleLevels": "Välj en eller flera rollnivåer",
  "profile.selectMultipleTitles": "Välj en eller flera jobbtitlar",
  "profile.selectRemoteness": "Välj distansarbete",
  "profile.selectRoleLevel": "Välj din rollnivå",
  "profile.title": "Jobbtitel",
  "profile.titlePlaceholder": "t.ex. mjukvaruingenjör",
  "profile.totalWeight": "Totalt",
  "profile.vacationWeeks": "Semesterveckor",
  "profile.vacationWeight": "Semestervikt: {weight}%",
  "profile.weeks": "veckor",
  "recentSearches.delete": "Ta bort",
  "recentSearches.noSearches": "Du har inte gjort några sökningar än.",
  "recentSearches.recentSearchesTitle": "Senaste sökningar",
  "recentSearches.savedSearchesTitle": "Sparade sökningar",
  "recentSearches.viewResults": "Visa resultat",
  "route.description.appliedJobs": "Här hittar du alla jobb du har sökt.",
  "route.description.hiddenJobs": "Här hittar du alla jobb du har dolt.",
  "route.description.hiredJobs": "Här hittar du alla jobb du har blivit anställd för.",
  "route.description.interviewingJobs": "Här hittar du alla jobb du intervjuar för.",
  "route.description.offerJobs": "Här hittar du alla jobb du har fått erbjudanden för.",
  "route.description.rejectedJobs": "Här hittar du alla jobb du har blivit nekad.",
  "route.description.savedJobs": "Här hittar du alla jobb du har sparat till senare.",
  "route.description.viewedJobs": "Här hittar du alla jobb du har tittat på.",
  "route.title.appliedJobs": "Sökta jobb",
  "route.title.hiddenJobs": "Dolda jobb",
  "route.title.hiredJobs": "Jobb du har fått",
  "route.title.interviewingJobs": "Jobb du intervjuar för",
  "route.title.offerJobs": "Jobb med erbjudande",
  "route.title.recentSearches": "Senaste sökningar",
  "route.title.rejectedJobs": "Nekade jobb",
  "route.title.savedJobs": "Sparade jobb",
  "route.title.viewedJobs": "Visade jobb",
  "salaryChart.companyLocation": "Företag i {location}",
  "salaryChart.estimatedOffer": "Uppskattat erbjudande",
  "salaryChart.locationAverage": "I {location}: {title}",
  "salaryChart.marketAverage": "Marknadsgenomsnitt: {title}",
  "salaryChart.marketAverageRoleLevel": "Marknadsgenomsnitt: {roleLevel}-nivå",
  "salaryChart.salaryContext": "Lönekontext: {title}",
  "salaryChart.specificOffer": "Detta erbjudande ({roleLevel})",
  "salaryChart.specificOfferNoLevel": "Detta erbjudande",
  "salaryChart.thisRole": "den här rollen",
  "salaryChart.thisRoleLevel": "den här rollnivån",
  "salaryStats.aboveMarket": "Den här lönen ligger över marknadens median",
  "salaryStats.accuracy.exact": "Baserat på liknande roller på det här företaget",
  "salaryStats.accuracy.general": "Baserat på marknadsdata",
  "salaryStats.accuracy.location": "Baserat på löner i {location}",
  "salaryStats.atMarket": "Den här lönen är konkurrenskraftig jämfört med marknadens median",
  "salaryStats.average": "Genomsnitt",
  "salaryStats.belowMarket": "Den här lönen ligger under marknadens median",
  "salaryStats.jobSalary": "Det här jobbet",
  "salaryStats.marketRange": "Marknadsintervall: {min}–{max} (median: {median})",
  "salaryStats.noJobSalary": "Inget löneintervall angivet för det här jobbet. Diagrammet visar marknadsfördelningen.",
  "salaryStats.noValidValues": "Lönestatistik finns ({sampleSize} {samples}) men alla värden är noll. Det kan tyda på att data behöver genereras om.",
  "salaryStats.perDay": "per dag",
  "salaryStats.perHour": "per timme",
  "salaryStats.perMonth": "per månad",
  "salaryStats.perYear": "per år",
  "salaryStats.percentiles": "25:e–75:e percentilen",
  "salaryStats.samples": "urval",
  "salaryStats.smallSampleWarning": "Obs: Baserat på ett litet urval ({sampleSize} {samples}). Resultaten kanske inte är representativa.",
  "search.clear": "Rensa sökning",
  "search.controls.navigation": "Sökkontroller och filter",
  "search.noresults.browseAll": "Bläddra bland alla jobb",
  "search.noresults.clearAllParameters": "Rensa alla sökparametrar",
  "search.noresults.clearSearch": "Rensa sökning",
  "search.noresults.description": "Prova att justera din sökning eller dina filter för att hitta fler möjligheter.",
  "search.noresults.filtersLabel": "Filter:",
  "search.noresults.goToFirstPage": "Gå till sida 1",
  "search.noresults.industries": "Branscher",
  "search.noresults.jobRoles": "Jobbroller",
  "search.noresults.locations": "Platser",
  "search.noresults.pageLabel": "Sida:",
  "search.noresults.popularCategories": "Populära kategorier",
  "search.noresults.queryLabel": "Sökfråga:",
  "search.noresults.removeQuery": "Ta bort",
  "search.noresults.searchParameters": "Dina sökparametrar",
  "search.noresults.searchTips": "Söktips",
  "search.noresults.tip1": "Prova att använda bredare söktermer eller ta bort några filter",
  "search.noresults.tip2": "Kontrollera stavningen eller prova alternativa sökord",
  "search.noresults.tip3": "Bläddra bland populära kategorier ovan för att upptäcka nya möjligheter",
  "search.noresults.title": "Inga resultat hittades",
  "search.noresults.trySearches": "Prova dessa sökningar:",
  "search.refinements.allFilters": "Alla filter",
  "search.refinements.allFilters.aria": "Alla filter",
  "search.refinements.benefits": "Förmåner",
  "search.refinements.benefits.label": "Förmåner",
  "search.refinements.benefits.modal": "Förmåner",
  "search.refinements.company": "Företag",
  "search.refinements.company.heading": "Företag",
  "search.refinements.company.label": "Företag",
  "search.refinements.company.modal": "Företag",
  "search.refinements.company.searchPlaceholder": "Sök företag...",
  "search.refinements.company.section": "Företag",
  "search.refinements.educationLevel": "Utbildningsnivå",
  "search.refinements.educationLevel.detail": "Utbildningsnivå",
  "search.refinements.educationLevel.heading": "Utbildningsnivå",
  "search.refinements.educationLevel.label": "Utbildningsnivå",
  "search.refinements.educationLevel.modal": "Utbildningsnivå",
  "search.refinements.excludeApplied.checkbox": "Exkludera jobb du redan har sökt",
  "search.refinements.excludeApplied.label": "Exkludera jobb du har sökt",
  "search.refinements.excludeSaved.checkbox": "Exkludera sparade jobb",
  "search.refinements.excludeSaved.label": "Exkludera sparade jobb",
  "search.refinements.excludeViewed.checkbox": "Exkludera visade jobb",
  "search.refinements.excludeViewed.label": "Exkludera visade jobb",
  "search.refinements.field": "Område",
  "search.refinements.field.label": "Område",
  "search.refinements.field.modal": "Område",
  "search.refinements.headcount": "Antal anställda (max)",
  "search.refinements.headcount.max": "Max antal anställda",
  "search.refinements.industry": "Bransch",
  "search.refinements.industry.heading": "Bransch",
  "search.refinements.industry.label": "Bransch",
  "search.refinements.industry.modal": "Bransch",
  "search.refinements.isDriversLicenseRequired.filter": "Körkort krävs",
  "search.refinements.isDriversLicenseRequired.toggle": "Körkort krävs",
  "search.refinements.isOpenApplication.filter": "Spontanansökan",
  "search.refinements.isOpenApplication.toggle": "Spontanansökan",
  "search.refinements.isSummerJob.filter": "Sommarjobb",
  "search.refinements.isSummerJob.toggle": "Sommarjobb",
  "search.refinements.job": "Jobb",
  "search.refinements.job.modal": "Jobbfilter",
  "search.refinements.job.section": "Jobb",
  "search.refinements.jobTitle": "Jobbtitel",
  "search.refinements.jobType": "Anställningsform",
  "search.refinements.jobType.label": "Anställningsform",
  "search.refinements.jobType.modal": "Anställningsform",
  "search.refinements.languages": "Språk",
  "search.refinements.languages.label": "Språk",
  "search.refinements.languages.modal": "Språk",
  "search.refinements.lastSeen": "Senast sedd",
  "search.refinements.lastSeen.aria": "Senast sedd",
  "search.refinements.lastSeen.all": "Alla",
  "search.refinements.lastSeen.past6Hours": "Senaste 6 timmarna",
  "search.refinements.lastSeen.past24Hours": "Senaste 24 timmarna",
  "search.refinements.lastSeen.past3Days": "Senaste 3 dagarna",
  "search.refinements.lastSeen.past1Week": "Senaste veckan",
  "search.refinements.lastSeen.past2Weeks": "Senaste 2 veckorna",
  "search.refinements.lastSeen.past1Month": "Senaste månaden",
  "search.refinements.location": "Plats",
  "search.refinements.location.modal": "Plats",
  "search.refinements.location.remote": "Distans",
  "search.refinements.location.searchPlaceholder": "Sök platser...",
  "search.refinements.location.section": "Plats",
  "search.refinements.peopleManagementTier": "Personalansvarsnivå",
  "search.refinements.peopleManagementTier.label": "Personalansvarsnivå",
  "search.refinements.peopleManagementTier.modal": "Ledarskapsnivå",
  "search.refinements.remoteness.heading": "Distansarbete",
  "search.refinements.remoteness.label": "Distansarbete",
  "search.refinements.remoteness.modal": "Distansarbete",
  "search.refinements.roleLevel": "Rollnivå",
  "search.refinements.roleLevel.label": "Rollnivå",
  "search.refinements.roleLevel.modal": "Rollnivå",
  "search.refinements.salary": "Lön",
  "search.refinements.salary.heading": "Lön",
  "search.refinements.salary.label": "Lön",
  "search.refinements.salary.min": "Minimilön",
  "search.refinements.salary.modal": "Lön",
  "search.refinements.salary.section": "Lön",
  "search.refinements.showJobsInFinlandOnly": "Visa endast jobb i Finland",
  "search.refinements.showLess": "Visa mindre",
  "search.refinements.showMore": "Visa mer",
  "search.refinements.skillsAndTechnologies": "Kompetenser och tekniker",
  "search.refinements.skillsAndTechnologies.label": "Kompetenser och tekniker",
  "search.refinements.skillsAndTechnologies.modal": "Kompetenser och tekniker",
  "search.refinements.vacationWeeks": "Semesterveckor",
  "search.refinements.vacationWeeks.heading": "Semesterveckor",
  "search.refinements.vacationWeeks.label": "Semesterveckor",
  "search.refinements.vacationWeeks.modal": "Semesterveckor",
  "search.results.title": "Jobbsökresultat",
  "search.save": "Spara sökning",
  "search.signInCta.badge": "Synka din sökning",
  "search.signInCta.button": "Logga in för att synka dina framsteg",
  "search.signInCta.description": "Logga in för att hålla sparade jobb, sökningar och framsteg synkade på alla dina enheter.",
  "search.signInCta.title": "Spara din jobbsökning överallt",
  "search.toast.saved": "Sökning sparad",
  "search.toast.unsaved": "Sökning borttagen",
  "search.unsave": "Ta bort sparad sökning",
  "sort.ariaLabel": "Sortera resultat",
  "sort.newest": "Nyast",
  "sort.relevance": "Relevans",
  "sort.salary": "Högst lön",
  "stats.appliedJobs": "{count} jobb du har sökt",
  "stats.finlandJobsSubtitle": "Jobb tillgängliga på finska eller på distans för boende i Finland",
  "stats.savedJobs": "{count} sparade jobb",
  "stats.viewedJobs": "{count} visade jobb",
  "studentsAndGraduates.description": "Kickstarta din karriär med instegsjobb, praktikplatser och trainee- och graduateprogram i Finland. Perfekt för studenter, nyutexaminerade och dig som vill påbörja din professionella resa.",
  "studentsAndGraduates.tip": "💡 Tips: Dessa tjänster är särskilt utformade för dig som är i början av din karriär. Leta efter nyckelord som ”intern”, ”junior”, ”graduate” eller ”trainee” i jobbtitlarna.",
  "studentsAndGraduates.title": "Jobb för studenter och nyutexaminerade",
  "studentsAndGraduates.title.breadcrumb": "Studenter och nyutexaminerade",
  "summerJobs.description": "Hitta det perfekta sommarjobbet i Finland. Oavsett om du är student och söker säsongsarbete eller vill byta karriär över sommaren kan du upptäcka tjänster inom en rad olika branscher.",
  "summerJobs.tip": "💡 Tips: Sommarjobb i Finland pågår vanligtvis från maj till augusti, och många tjänster annonseras tidigt på våren. Börja söka i god tid för att säkra de bästa möjligheterna!",
  "summerJobs.title": "Sommarjobb i Finland",
  "summerJobs.title.breadcrumb": "Sommarjobb",
  "terms.acceptance.description": "Genom att använda vår webbplats och våra tjänster bekräftar du att du har läst, förstått och samtycker till att vara bunden av dessa användarvillkor, samt vår integritetspolicy. Om du inte godkänner någon del av dessa villkor bör du sluta använda våra tjänster.",
  "terms.acceptance.title": "1. Godkännande av villkor",
  "terms.changes.description": "Vi kan uppdatera dessa användarvillkor från tid till annan. När vi gör det kommer vi att publicera de reviderade villkoren på den här sidan. Din fortsatta användning av vår webbplats efter eventuella ändringar innebär att du accepterar de nya villkoren.",
  "terms.changes.title": "7. Ändringar av dessa villkor",
  "terms.contact.description": "Om du har några frågor om dessa användarvillkor, vänligen kontakta oss på:",
  "terms.contact.title": "8. Kontakta oss",
  "terms.intellectualProperty.description": "Allt innehåll, alla varumärken och all data på denna webbplats, inklusive text, grafik, bilder och programvara, ägs av JobCrawls eller dess licensgivare. Du får inte använda eller reproducera någon del av webbplatsens innehåll utan skriftligt tillstånd från oss.",
  "terms.intellectualProperty.title": "3. Immateriella rättigheter",
  "terms.intro": "Välkommen till JobCrawls! Genom att besöka och använda vår webbplats samtycker du till att vara bunden av dessa användarvillkor. Läs dem noggrant innan du använder vår plattform. Vi är ett finskt företag, och dessa villkor regleras av tillämplig finsk lag och EU-lagstiftning.",
  "terms.limitationOfLiability.description": "JobCrawls och dess närstående bolag ska inte hållas ansvariga för några indirekta, tillfälliga, särskilda eller följdskador som uppstår till följd av eller på något sätt är kopplade till användningen av vår webbplats eller våra tjänster. I samtliga fall är vårt ansvar begränsat i den utsträckning som är tillåten enligt finsk lag och EU-lagstiftning.",
  "terms.limitationOfLiability.title": "4. Ansvarsbegränsning",
  "terms.modifications.description": "Vi förbehåller oss rätten att när som helst, utan föregående meddelande, ändra, tillfälligt avbryta eller upphöra med någon del av vår tjänst. Vi ska inte hållas ansvariga om vi utövar denna rätt.",
  "terms.modifications.title": "5. Ändringar av tjänsten",
  "terms.termination.description": "Vi kan omedelbart avsluta eller stänga av din åtkomst till vår webbplats, utan föregående meddelande, om vi bedömer att du har brutit mot dessa användarvillkor eller av någon annan anledning som anses nödvändig.",
  "terms.termination.title": "6. Uppsägning",
  "terms.title": "Användarvillkor",
  "terms.userObligations.description": "Du samtycker till att använda JobCrawls i enlighet med alla tillämpliga lagar och förordningar. Du får inte använda vår webbplats på ett sätt som kränker andras rättigheter eller begränsar eller hindrar någon annans användning och möjlighet att nyttja webbplatsen.",
  "terms.userObligations.title": "2. Användarens skyldigheter",
  "tools.applicationState.applied": "Ansökt",
  "tools.applicationState.hidden": "Dold",
  "tools.applicationState.label": "Status:",
  "tools.applicationState.updated": "Status uppdaterad till {state}",
  "tools.appliedJobs": "Sökta jobb",
  "tools.appliedJobs.link": "Sökta jobb",
  "tools.hiddenJobs": "Dolda jobb",
  "tools.hiddenJobs.link": "Dolda jobb",
  "tools.hiredJobs": "Jobb där du blivit anställd",
  "tools.hiredJobs.link": "Jobb där du blivit anställd",
  "tools.interviewingJobs": "Jobb där du intervjuar",
  "tools.interviewingJobs.link": "Jobb där du intervjuar",
  "tools.jobFlow": "Jobbflöde",
  "tools.jobFlow.link": "Jobbflöde",
  "tools.jobFlowSankey.applied": "Ansökt",
  "tools.jobFlowSankey.browsed": "Bläddrat",
  "tools.jobFlowSankey.description": "Visualisera din jobbansökningsresa från bläddrat till ansökt",
  "tools.jobFlowSankey.hired": "Anställd",
  "tools.jobFlowSankey.interviewing": "Intervju",
  "tools.jobFlowSankey.offer": "Erbjudande",
  "tools.jobFlowSankey.rejected": "Avslagen",
  "tools.jobFlowSankey.saved": "Sparad",
  "tools.jobFlowSankey.title": "Flöde för jobbansökningar",
  "tools.jobFlowSankey.viewed": "Visad",
  "tools.offerJobs": "Erbjud jobb",
  "tools.offerJobs.link": "Erbjud jobb",
  "tools.recentSearches": "Senaste sökningar",
  "tools.recentSearches.link": "Senaste sökningar",
  "tools.rejectedJobs": "Avvisade jobb",
  "tools.rejectedJobs.link": "Avvisade jobb",
  "tools.savedJobs": "Sparade jobb",
  "tools.savedJobs.link": "Sparade jobb",
  "tools.title": "Verktyg",
  "tools.title.aria": "Verktyg",
  "tools.title.button": "Verktyg",
  "tools.viewedJobs": "Visade jobb",
  "tools.viewedJobs.link": "Visade jobb",
  "tooltip.allFilters": "Öppna alla filter för att förfina din jobbsökning efter plats, lön, anställningsform och mer",
  "tooltip.filter.category": "Filtrera jobb efter {category}",
  "tooltip.filter.english": "Filtrera för att bara visa jobb som kräver engelska",
  "tooltip.filter.highSalary": "Filtrera för att bara visa jobb med hög lön (5 000 €+/månad)",
  "tooltip.filter.remote": "Filtrera för att bara visa distans- eller hybridjobb",
  "tooltip.language": "Byt webbplatsens språk (engelska, finska, svenska)",
  "tooltip.logo": "Gå till startsidan och rensa sökningen",
  "tooltip.menu": "Öppna menyn för att komma åt sparade jobb, profil och inställningar",
  "tooltip.nav.home": "Återgå till startsidan",
  "tooltip.nav.locations": "Utforska arbetsmarknader efter stad och region",
  "tooltip.nav.resources": "Bläddra bland artiklar och guider om att arbeta i Finland",
  "tooltip.nav.search": "Sök och filtrera jobbannonser",
  "tooltip.toggleHeader": "Växla marknadsrubrik",
  "tooltip.tools": "Få tillgång till verktyg och hjälpmedel för jobbsökning",
  "tooltip.view.grid": "Växla till rutnätsvy för att se jobbkort i en rutnätslayout",
  "tooltip.view.list": "Växla till listvy för att se jobb i ett kompakt listformat",
  "tooltip.view.map": "Växla till kartvy för att se jobblägen på en karta",
  "usermenu.appliedJobs": "Sökta jobb",
  "usermenu.blog": "Resurser & blogg",
  "usermenu.blog.link": "Resurser",
  "usermenu.installPwa": "Installera appen",
  "usermenu.jobFlow": "Din aktivitet",
  "usermenu.login": "Logga in",
  "usermenu.logout": "Logga ut",
  "usermenu.profile": "Min profil",
  "usermenu.recentSearches": "Senaste sökningar",
  "usermenu.savedJobs": "Sparade jobb",
  "usermenu.theme": "Tema",
  "usermenu.theme.light": "Ljus",
  "usermenu.theme.dark": "Mörk",
  "usermenu.viewedJobs": "Visade jobb",
  "view.grid": "Rutnätsvy",
  "view.list": "Listvy",
  "view.map": "Kartvy",
  "translation.test": "Översättningstest: Svenska"
};

const messages_fi = {
  ...messages_en, // Use English as fallback
  "auth.signInPrompt.closeLabel": "Sulje",
  "auth.signInPrompt.description": "Luo ilmainen tili tallentaaksesi työpaikkoja, synkronoidaksesi edistymisesi ja jatkaaksesi hakua millä tahansa laitteella.",
  "auth.signInPrompt.primaryAction": "Kirjaudu sisään nyt",
  "auth.signInPrompt.secondaryAction": "Ehkä myöhemmin",
  "auth.signInPrompt.title": "Kirjaudu sisään tallentaaksesi työpaikkoja",
  "autocomplete.filters": "Suodatinvastaavuudet",
  "autocomplete.noMatches": "Suodatinvastaavuuksia ei löytynyt",
  "autocomplete.scrollHint": "Vieritä nähdäksesi lisää",
  "backoffice.architecture": "Arkkitehtuuri",
  "backoffice.dashboard": "Hallintapaneeli",
  "backoffice.testing": "Testaus",
  "blog.author": "Kirjoittaja",
  "blog.hubArticles": "Tämän hubin artikkelit:",
  "blog.keywords": "Avainsanat",
  "breadcrumb.benefits": "Edut",
  "breadcrumb.company": "Yritys",
  "breadcrumb.educationLevel": "Koulutus",
  "breadcrumb.industry": "Toimiala",
  "breadcrumb.isDriversLicenseRequired": "Ajokortti",
  "breadcrumb.isOpenApplication": "Avoin hakemus",
  "breadcrumb.isSummerJob": "Kesätyö",
  "breadcrumb.jobType": "Työsuhteen tyyppi",
  "breadcrumb.jobs": "Työpaikat",
  "breadcrumb.language": "Kieli",
  "breadcrumb.level": "Taso",
  "breadcrumb.location": "Sijainti",
  "breadcrumb.peopleManagementTier": "Esihenkilötyö",
  "breadcrumb.remote": "Etätyö",
  "breadcrumb.skillsAndTechnologies": "Osaaminen/teknologiat",
  "business.conclusion": "Kiitos, että luotat meihin työnhaussasi. Olemme innoissamme saadessamme olla mukana matkallasi kohti merkityksellistä työtä – ja lopulta kohti voimaantuneempaa tulevaisuutta meille kaikille.",
  "business.empowerment": "Uskomme, että työpaikat ovat voimakkain väline yksilön ja yhteiskunnan kasvuun. Kun ihmiset saavat voimaa ja mahdollisuuksia, heistä tulee myönteisiä muutoksentekijöitä omissa yhteisöissään – ja me haluamme nähdä paremman maailman kaikille.",
  "business.feedback.description": "Auta meitä parantamaan palveluamme jakamalla ajatuksesi ja ehdotuksesi.",
  "business.feedback.title": "Arvostamme palautettasi",
  "business.intro": "Tervetuloa Suomen eettiselle työpaikkasivustollemme, jonka omistaa ja jota ylläpitää ylpeänä TechTactics Oy. Tavoitteemme on yksinkertainen: auttaa ihmisiä löytämään merkityksellisiä työmahdollisuuksia, erityisesti työttömyyden tai urasiirtymän aikana.",
  "business.platform": "Alustamme on suunniteltu empatia ja saavutettavuus edellä. Pyrimme tekemään työnhaun prosessista läpinäkyvän ja reilun, jotta jokainen ilmoitettu työpaikka tarjoaa aidot mahdollisuudet kasvuun, turvaan ja vakauteen.",
  "business.proUnion": "Kannatamme ammattiliittoja ja vastustamme jyrkästi yrityksiä, jotka riistävät työntekijöitä tai vahingoittavat yhteisöjä. TechTactics Oy tekee yhteistyötä vain sellaisten organisaatioiden kanssa, jotka jakavat visiomme: panostaa ihmisiin, heidän hyvinvointiinsa ja yhteiseen hyvään.",
  "business.tagline": "TechTactics Oy:n rakentama – reilun ja läpinäkyvän rekrytoinnin vahvistamiseksi Suomessa.",
  "business.title": "Tietoa eettisestä alustastamme",
  "common.workInProgress": "Tämä sivu on vielä työn alla. Osa ominaisuuksista ei välttämättä vielä toimi täysin.",
  "company.logoAlt": "{company}-logo",
  "companyChart.caption.averaging": "keskimäärin {avg} työpaikkailmoitusta kuukaudessa",
  "companyChart.caption.fieldDistributionDouble": "{companyName} keskittyy pääasiassa aloihin {field1} ja {field2}.",
  "companyChart.caption.fieldDistributionSingle": "{companyName} keskittyy pääasiassa alaan {field}.",
  "companyChart.caption.fieldDistributionTriple": "{companyName} keskittyy pääasiassa aloihin {field1}, {field2} ja {field3}.",
  "companyChart.caption.hiringDeclining": "{companyName}:n rekrytointi on laskussa",
  "companyChart.caption.hiringGrowing": "{companyName}:n rekrytointi on kasvussa",
  "companyChart.caption.hiringRapidlyDeclining": "{companyName}:n rekrytointi laskee nopeasti",
  "companyChart.caption.hiringRapidlyGrowing": "{companyName}:n rekrytointi kasvaa nopeasti",
  "companyChart.caption.hiringStable": "{companyName}:n rekrytointi on vakaata",
  "companyChart.caption.languageRequirementsDouble": "{companyName} edellyttää tyypillisesti kieliä {language1} ja {language2}.",
  "companyChart.caption.languageRequirementsSingle": "{companyName} edellyttää yleensä {language}n osaamista.",
  "companyChart.caption.languageRequirementsTriple": "{companyName} edellyttää yleensä {language1}n, {language2}n ja {language3}n osaamista.",
  "companyChart.caption.levelDistributionDouble": "{companyName} palkkaa enimmäkseen {level1}- ja {level2}-tasolle.",
  "companyChart.caption.levelDistributionSingle": "{companyName} palkkaa enimmäkseen {level}-tasolle.",
  "companyChart.caption.levelDistributionTriple": "{companyName} palkkaa enimmäkseen {level1}-, {level2}- ja {level3}-tasolle.",
  "companyChart.caption.locationDistributionDouble": "{companyName} palkkaa enimmäkseen {location1}ssa ja {location2}ssa.",
  "companyChart.caption.locationDistributionSingle": "{companyName} palkkaa enimmäkseen {location}ssa.",
  "companyChart.caption.locationDistributionTriple": "{companyName} palkkaa enimmäkseen {location1}ssa, {location2}ssa ja {location3}ssa.",
  "companyChart.caption.margin": "ja voittomarginaali on {margin}",
  "companyChart.caption.marginOnly": "{companyName}n voittomarginaali oli {margin} vuonna 2024",
  "companyChart.caption.profitable": "{companyName} teki voittoa vuonna 2024",
  "companyChart.caption.remotenessHybrid": "{companyName} palkkaa enimmäkseen hybridityöhön.",
  "companyChart.caption.remotenessOnsite": "{companyName} palkkaa enimmäkseen lähityöhön.",
  "companyChart.caption.remotenessRemote": "{companyName} palkkaa enimmäkseen etätyöhön.",
  "companyChart.caption.revenue": "{companyName}n liikevaihto oli {revenue} vuonna 2024",
  "companyChart.caption.revenueWith": "liikevaihdolla {revenue}",
  "companyChart.caption.roleDistributionDouble": "{companyName} palkkaa enimmäkseen {role1}- ja {role2}-rooleihin.",
  "companyChart.caption.roleDistributionSingle": "{companyName} palkkaa enimmäkseen {role}-rooleihin.",
  "companyChart.caption.roleDistributionTriple": "{companyName} palkkaa enimmäkseen {role1}-, {role2}- ja {role3}-rooleihin.",
  "companyChart.caption.unprofitable": "{companyName} teki tappiota vuonna 2024",
  "companyChart.caption.workforceRate": "({rate} % heidän työvoimastaan)",
  "companyChart.financialOverview": "Taloudellinen yleiskatsaus (2024)",
  "companyChart.insufficientData": "Dataa on saatavilla rajoitetusti – trendit edellyttävät vähintään 3 kuukauden dataa",
  "companyChart.monthlyHiringTrends": "Kuukausittaiset rekrytointitrendit",
  "companyChart.profit": "Voitto",
  "companyChart.profitMargin": "Voittomarginaali",
  "companyChart.revenue": "Liikevaihto",
  "companyChart.trend.declining": "Laskeva",
  "companyChart.trend.growing": "Kasvava",
  "companyChart.trend.insufficientData": "Rajoitetusti dataa",
  "companyChart.trend.rapidlyDeclining": "Nopeasti laskeva",
  "companyChart.trend.rapidlyGrowing": "Nopeasti kasvava",
  "companyChart.trend.stable": "Vakaa",
  "companyChart.trendDescription.declining": "Palkataan keskimäärin {avg} työpaikkaa/kk ({rate}% työvoimasta)",
  "companyChart.trendDescription.growing": "Palkataan keskimäärin {avg} työpaikkaa/kk ({rate}% työvoimasta)",
  "companyChart.trendDescription.rapidlyDeclining": "Palkataan keskimäärin {avg} työpaikkaa/kk ({rate}% työvoimasta)",
  "companyChart.trendDescription.rapidlyGrowing": "Palkataan keskimäärin {avg} työpaikkaa/kk ({rate}% työvoimasta)",
  "companyChart.trendDescription.simpleDeclining": "Palkataan keskimäärin {avg} työpaikkaa/kk",
  "companyChart.trendDescription.simpleGrowing": "Palkataan keskimäärin {avg} työpaikkaa/kk",
  "companyChart.trendDescription.simpleStable": "Palkataan keskimäärin {avg} työpaikkaa/kk",
  "companyChart.trendDescription.stable": "Palkataan keskimäärin {avg} työpaikkaa/kk ({rate} % työvoimasta)",
  "companyHeader.jobCount": "{count, plural, one {# avoin työpaikka} other {# avointa työpaikkaa}}",
  "companyHeader.locationCount": "{count, plural, one {# sijainti} other {# sijaintia}}",
  "dashboard.actions": "Toiminnot",
  "dashboard.addComment": "Lisää kommentti",
  "dashboard.addComment.placeholder": "Lisää kommentti...",
  "dashboard.adding": "Lisätään...",
  "dashboard.address": "Osoite",
  "dashboard.algoliaIndexingErrors": "Algolia-indeksointivirheet ({count})",
  "dashboard.all": "Kaikki",
  "dashboard.allAts": "Kaikki ATS:t",
  "dashboard.allCompanies": "Kaikki yritykset",
  "dashboard.allStatus": "Kaikki tilat",
  "dashboard.atsSystem": "ATS-järjestelmä",
  "dashboard.businessId": "Y-tunnus",
  "dashboard.careersUrl": "Urasivu-URL",
  "dashboard.check": "Merkitse tarkistetuksi",
  "dashboard.clearDlq": "Tyhjennä DLQ",
  "dashboard.clearFilters": "Tyhjennä suodattimet",
  "dashboard.clearLogoFailures": "Tyhjennä logovirheet ({count})",
  "dashboard.comments": "Kommentit",
  "dashboard.companiesHeader": "Yritykset ({count} / {total})",
  "dashboard.companyAttributes": "Yrityksen attribuutit",
  "dashboard.companyBasic": "Yrityksen perustiedot",
  "dashboard.companyBasic.short": "Perustiedot",
  "dashboard.companyBusiness": "Liiketoimintatiedot",
  "dashboard.companyContact": "Yhteystiedot",
  "dashboard.companyCrawl": "Ryömintäasetukset",
  "dashboard.companyFinancial": "Taloustiedot",
  "dashboard.companyId": "Yritystunnus",
  "dashboard.companyIndustry": "Toimiala",
  "dashboard.companyInformation": "Yrityksen tiedot",
  "dashboard.companyLocation": "Sijainti",
  "dashboard.companyName": "Yrityksen nimi",
  "dashboard.companyRegistry": "Rekisteri",
  "dashboard.companySocial": "Sosiaalinen media",
  "dashboard.companyUrl": "Yrityksen URL-osoite",
  "dashboard.coordinates": "Koordinaatit",
  "dashboard.crawlKey": "Ryömintäavain",
  "dashboard.crawlRecords": "Ryömintätietueet",
  "dashboard.crawlStatistics": "Ryömintätilastot",
  "dashboard.crawlType": "Ryömintätyyppi",
  "dashboard.crawlingInformation": "Ryömintätiedot",
  "dashboard.deleteComment": "Poista kommentti",
  "dashboard.detailPages": "Yksityiskohtasivut",
  "dashboard.details": "Tiedot",
  "dashboard.dlqEmpty": "DLQ on tyhjä – ei epäonnistuneita viestejä",
  "dashboard.dlqMessageCount": "DLQ:ssa {count} {count, plural, one {viesti} other {viestiä}}",
  "dashboard.dlqViewer": "Dead Letter Queue -katselin",
  "dashboard.duration": "Kesto",
  "dashboard.enqueueUrlPattern": "Lisää jonoon URL-malli",
  "dashboard.error": "Virhe",
  "dashboard.failed": "Epäonnistuneet",
  "dashboard.failedToLoadCompanySettings": "Yrityksen asetusten lataaminen epäonnistui: {error}",
  "dashboard.filterByField": "Suodata kentän mukaan",
  "dashboard.filterValue": "Suodattimen arvo... (käytä __NOT_EMPTY__ ei-tyhjille)",
  "dashboard.filters": "Suodattimet",
  "dashboard.greenSuccess": "Vihreä (Onnistui)",
  "dashboard.groupBy": "Ryhmittele",
  "dashboard.groupCrawlCount": "Ryömintäkertojen määrä",
  "dashboard.groupJobsCount": "Työpaikkojen määrä",
  "dashboard.groupLogoFailed": "Logon tila",
  "dashboard.groupMetrics": "Mittarit",
  "dashboard.groupNone": "Ei mitään",
  "dashboard.groupPaginationIssue": "Sivutukseen liittyvät ongelmat",
  "dashboard.groupStatus": "Tila (punainen/keltainen/vihreä)",
  "dashboard.groupStatusIssues": "Tila ja ongelmat",
  "dashboard.groupSuccessRate": "Onnistumisprosentti",
  "dashboard.hasComments": "Sisältää kommentteja",
  "dashboard.hasCrawlData.label": "Crawlausdata",
  "dashboard.hasCrawlData.option": "Sisältää dataa",
  "dashboard.heroImage": "Hero-kuva",
  "dashboard.howToRunCrawl": "Näin suoritat crawlin",
  "dashboard.industry": "Toimiala",
  "dashboard.isChecked": "Tarkistettu",
  "dashboard.isSaved": "Tallennettu",
  "dashboard.issuesOnly": "Vain ongelmat",
  "dashboard.itemsPerPage": "Kohteita per sivu",
  "dashboard.jobsEnqueued": "{count} työpaikkaa lisätty jonoon",
  "dashboard.jobsExtracted": "Poimitut työpaikat",
  "dashboard.jobsFound": "Löydetyt työpaikat",
  "dashboard.listPages": "Listasivut",
  "dashboard.listPagesEnqueued": "{count} listasivua",
  "dashboard.loadAllCompanies": "Lataa kaikki yritykset (86k)",
  "dashboard.loadedCompanies": "Ladattu: {current}/{total} yritystä",
  "dashboard.loadedCompaniesUnknown": "Ladattu: {current} yritystä",
  "dashboard.loadingAllCompanies": "Ladataan kaikki yritykset – alkuvaiheen lataus on hitaampi",
  "dashboard.loadingBatch": "Käsitellään erää {current} noin {total}:stä",
  "dashboard.loadingCompanies": "Ladataan yritystietoja",
  "dashboard.loadingCompaniesWithUrls": "Ladataan vain yritykset, joilla on verkkosivuston URL-osoite – nopeammin",
  "dashboard.loadingNote": "Tämä voi kestää muutaman minuutin. Pidä tämä sivu auki.",
  "dashboard.logoFailed": "Logon lataus epäonnistui",
  "dashboard.logs": "Lokit",
  "dashboard.map": "Kartta",
  "dashboard.mostRecent": "Viimeisin",
  "dashboard.next": "Seuraava",
  "dashboard.noCrawlData.message": "Ryömintätietoja ei ole vielä saatavilla. Avaa yllä oleva \"How to Run a Crawl\" -osio saadaksesi ohjeet ryöminnän suorittamiseen ja tietojen viemiseen.",
  "dashboard.noCrawlData.option": "Ei tietoja",
  "dashboard.noFieldFilter": "Ei kenttäsuodatinta",
  "dashboard.noIssues": "Ei ongelmia",
  "dashboard.notSent": "Ei lähetetty",
  "dashboard.pageInfo": "Sivu {current} / {total}",
  "dashboard.pageType": "Sivutyyppi",
  "dashboard.paginationIssueDescription": "Tasan {count} työpaikkaa lähetetty – voi viitata puutteelliseen sivutukseen.",
  "dashboard.potentialPaginationIssue": "Mahdollinen sivutusongelma",
  "dashboard.previous": "Edellinen",
  "dashboard.processDlq": "Käsittele DLQ",
  "dashboard.recordCount": "{count} {count, plural, one {tietue} other {tietuetta}}",
  "dashboard.recrawl": "Uudelleencrawl",
  "dashboard.recrawlTriggered": "Uudelleencrawl käynnistetty yritykselle {companyName}",
  "dashboard.redFailed": "Punainen (Epäonnistunut)",
  "dashboard.refreshCompanies": "Päivitä yritykset",
  "dashboard.refreshCrawlData": "Päivitä crawl-data",
  "dashboard.refreshing": "Päivitetään...",
  "dashboard.registryInformation": "Rekisteritiedot",
  "dashboard.result": "Tulos",
  "dashboard.runMaintainer": "Suorita ylläpito",
  "dashboard.running": "Suoritetaan...",
  "dashboard.save": "Tallenna myöhempää varten",
  "dashboard.scanningDatabase": "Skannataan tietokantaa ja ladataan yrityksiä...",
  "dashboard.searchCompanies": "Hae yrityksiä...",
  "dashboard.sentForProcessing": "✓ Lähetetty käsiteltäväksi",
  "dashboard.sentToProcessor": "Lähetetty käsittelijälle",
  "dashboard.showing": "Näytetään {filtered}/{total} yritystä",
  "dashboard.skipped": "Ohitettu",
  "dashboard.skippedJobExists": "Ohitettu – työ on jo olemassa",
  "dashboard.socialMedia": "Sosiaalinen media",
  "dashboard.sortAscending": "Nouseva",
  "dashboard.sortBasic": "Perustiedot",
  "dashboard.sortBy": "Lajittele",
  "dashboard.sortCrawls": "Indeksoinnit",
  "dashboard.sortDescending": "Laskeva",
  "dashboard.sortDetailPages": "Tietosivut",
  "dashboard.sortDirection": "Lajittele {direction}",
  "dashboard.sortFailed": "Epäonnistuneet indeksoinnit",
  "dashboard.sortJobs": "Työpaikat",
  "dashboard.sortJobsExtracted": "Poimitut työpaikat yhteensä",
  "dashboard.sortJobsFound": "Löydetyt työpaikat yhteensä",
  "dashboard.sortJobsSent": "Käsittelijälle lähetetyt työpaikat",
  "dashboard.sortLastCrawl": "Viimeisin indeksointipäivä",
  "dashboard.sortListPages": "Listasivut",
  "dashboard.sortMostRecentJobs": "Viimeisimmät löydetyt työpaikat",
  "dashboard.sortName": "Yrityksen nimi",
  "dashboard.sortPages": "Sivut",
  "dashboard.sortStatus": "Tila",
  "dashboard.sortSuccessRate": "Onnistumisprosentti",
  "dashboard.sortSuccessful": "Onnistuneet indeksoinnit",
  "dashboard.status": "Tila",
  "dashboard.successRate": "Onnistumisprosentti",
  "dashboard.successful": "Onnistuneet",
  "dashboard.syncingCompanySettings": "Synkronoidaan yrityksen asetuksia...",
  "dashboard.time": "Aika",
  "dashboard.title": "Indeksoinnin hallintapaneeli",
  "dashboard.totalCrawls": "Indeksoinnit yhteensä",
  "dashboard.uncheck": "Poista valinta",
  "dashboard.unsave": "Poista tallennetuista",
  "dashboard.viewAttributes": "Näytä attribuutit",
  "dashboard.viewCloudWatchLogs": "Näytä tämän ajon CloudWatch-lokit",
  "dashboard.viewHtml": "Näytä HTML",
  "dashboard.viewJobs": "Näytä",
  "dashboard.viewMessageBody": "Näytä viestin runko",
  "dashboard.viewOnGoogleMaps": "Näytä Google Mapsissa",
  "dashboard.yellowNoJobs": "Keltainen (ei työpaikkoja)",
  "error.404.message": "Pahoittelut, emme löytäneet etsimääsi sivua. Se on saatettu siirtää tai poistaa, tai olet syöttänyt väärän URL-osoitteen.",
  "error.404.title": "Sivua ei löytynyt",
  "error.500.message": "Meillä on parhaillaan teknisiä ongelmia. Yritä myöhemmin uudelleen tai ota yhteyttä tukeen, jos ongelma jatkuu.",
  "error.500.title": "Jokin meni pieleen",
  "error.actions.goBack": "Palaa takaisin",
  "error.actions.goHome": "Siirry etusivulle",
  "error.actions.searchJobs": "Hae työpaikkoja",
  "error.jobNotFound.message": "Etsimääsi työpaikkaa ei ole olemassa tai se on poistettu.",
  "error.jobNotFound.title": "Työpaikkaa ei löytynyt",
  "facets.benefits": "Etu",
  "facets.company": "Yritys",
  "facets.companyIndustry": "Toimiala",
  "facets.education": "Koulutus",
  "facets.field": "Toimiala",
  "facets.jobType": "Työsuhteen tyyppi",
  "facets.language": "Kieli",
  "facets.location": "Sijainti",
  "facets.management": "Johtaminen",
  "facets.remoteness": "Työskentelytapa",
  "facets.role": "Rooli",
  "facets.roleLevel": "Roolitaso",
  "facets.skills": "Taito",
  "feedback.button.label": "Anna palautetta",
  "feedback.cancel": "Peruuta",
  "feedback.error": "Palautteen lähettäminen epäonnistui. Yritä uudelleen.",
  "feedback.label": "Palautteesi",
  "feedback.modal.close": "Sulje",
  "feedback.modal.description": "Haluaisimme kuulla ajatuksesi. Jaa palautteesi, jotta voimme parantaa.",
  "feedback.modal.title": "Lähetä palautetta",
  "feedback.page.anonymous": "Anonyymi",
  "feedback.page.delete": "Poista palaute",
  "feedback.page.deleteConfirm": "Haluatko varmasti poistaa tämän palautteen?",
  "feedback.page.deleteError": "Palautteen poistaminen epäonnistui. Yritä uudelleen.",
  "feedback.page.description": "Tarkastele ja hallinnoi käyttäjäpalautetta",
  "feedback.page.listTitle": "Kaikki palaute",
  "feedback.page.noFeedback": "Ei vielä palautetta",
  "feedback.page.refresh": "Päivitä",
  "feedback.page.submitTitle": "Lähetä palautetta",
  "feedback.page.title": "Palaute",
  "feedback.page.viewMetadata": "Näytä metatiedot",
  "feedback.placeholder": "Kerro, mitä meidän pitäisi muuttaa tai lisätä...",
  "feedback.submit": "Lähetä",
  "feedback.submitting": "Lähetetään...",
  "feedback.success": "Kiitos! Palautteesi on lähetetty.",
  "filters.allFilters.navigation": "Kaikki suodatinvaihtoehdot",
  "filters.connector.and": "JA",
  "filters.connector.or": "TAI",
  "filters.navigation": "Suodatinvaihtoehdot",
  "footer.aiTranslationDisclaimer": "Huom: Osa tämän verkkosivuston sisällöstä sisältää tekoälyn avulla tehtyjä konekäännöksiä ja saattaa sisältää virheitä.",
  "footer.business": "Työnantajille",
  "footer.copyright": "© 2025 {company} Kaikki oikeudet pidätetään.",
  "footer.fromTheBlog": "Blogista",
  "footer.jobcrawlsEn": "JobCrawls (englanniksi)",
  "footer.jobcrawlsFi": "JobCrawls (suomeksi)",
  "footer.jobcrawlsSv": "JobCrawls (ruotsiksi)",
  "footer.jobsInEspoo": "Työpaikat Espoossa",
  "footer.jobsInEurope": "Työpaikat Euroopassa",
  "footer.jobsInFinland": "Työpaikat Suomessa",
  "footer.jobsInHelsinki": "Työpaikat Helsingissä",
  "footer.jobsInJyvaskyla": "Työpaikat Jyväskylässä",
  "footer.jobsInKuopio": "Työpaikat Kuopiossa",
  "footer.jobsInLahti": "Työpaikat Lahdessa",
  "footer.jobsInLappeenranta": "Työpaikat Lappeenrannassa",
  "footer.jobsInOulu": "Työpaikat Oulussa",
  "footer.jobsInPori": "Työpaikat Porissa",
  "footer.jobsInTampere": "Työpaikat Tampereella",
  "footer.jobsInTurku": "Työpaikat Turussa",
  "footer.jobsInVaasa": "Työpaikat Vaasassa",
  "footer.jobsInVantaa": "Työpaikat Vantaalla",
  "footer.locationsHub": "Tutustu sijaintikeskuksiin",
  "footer.majorFinnishCities": "Suomen suurimmat kaupungit",
  "footer.moreFinnishCities": "Lisää suomalaisia kaupunkeja",
  "footer.privacy": "Tietosuojakäytäntö",
  "footer.remoteEuropeJobs": "Etätyöpaikat – Eurooppa",
  "footer.remoteGlobalJobs": "Etätyöpaikat – Maailmanlaajuisesti",
  "footer.remoteMENAJobs": "Etätyöpaikat – MENA",
  "footer.remoteWorkAndCountries": "Etätyö & maat",
  "footer.resources": "Resurssit",
  "footer.terms": "Käyttöehdot",
  "hit.applicationDeadline": "Hakuaika päättyy: {date}",
  "hit.applicationDeadline.detail": "Hakuaika päättyy: {date}",
  "hit.applied": "Haettu",
  "hit.companyLinkTitle": "Hae työpaikkoja yrityksessä {company}",
  "hit.driversLicenseRequired": "Voimassa oleva ajokortti vaaditaan",
  "hit.hidden": "Piilotettu",
  "hit.hide": "Piilota työpaikka",
  "hit.hide.button": "Piilota",
  "hit.hide.menu": "Piilota",
  "hit.jobTitle": "Työpaikka",
  "hit.jobTypeLinkAria": "Hae {jobType}-työpaikkoja",
  "hit.jobTypeLinkTitle": "Hae {jobType}-työpaikkoja",
  "hit.linkCopied": "Linkki kopioitu leikepöydälle!",
  "hit.locationLinkAria": "Hae työpaikkoja sijainnissa {location}",
  "hit.locationLinkTitle": "Hae työpaikkoja sijainnissa {location}",
  "hit.locationNotAvailable": "Sijainti ei ole saatavilla",
  "hit.markAsApplied": "Merkitse haetuksi",
  "hit.markAsApplied.menu": "Merkitse haetuksi",
  "hit.markAsState": "Merkitse tilaan {state}",
  "hit.moreLocations": "+{count} lisää",
  "hit.moreOptions": "Lisää vaihtoehtoja",
  "hit.noBenefitsBanner.login": "Kirjaudu sisään ja lisää nykyisen työsi tiedot nähdäksesi, miten palkkasi vertautuu",
  "hit.noBenefitsBanner.save": "Tallenna sinua kiinnostavat työpaikat, jotta voit vertailla palkkoja ja etuja rinnakkain.",
  "hit.openApplication": "Avoin hakemus",
  "hit.postedDate": "Julkaistu: {date}",
  "hit.postedDate.detail": "Julkaistu: {date}",
  "hit.remotenessLinkAria": "Hae {remoteness}-työpaikkoja",
  "hit.remotenessLinkTitle": "Hae {remoteness}-työpaikkoja",
  "hit.removeApplied": "Poista haetuista",
  "hit.roleLevelLinkAria": "Hae {roleLevel}-tason työpaikkoja",
  "hit.roleLevelLinkLabel": "{roleLevel}-tason työpaikat",
  "hit.roleLevelLinkTitle": "Hae {roleLevel}-tason työpaikkoja",
  "hit.salaryNotSpecified": "Palkkaa ei ilmoitettu",
  "hit.salaryNotSpecified.card": "Palkkaa ei ilmoitettu",
  "hit.save": "Tallenna",
  "hit.save.detail": "Tallenna",
  "hit.saved": "Tallennettu",
  "hit.saved.detail": "Tallennettu",
  "hit.seeAd": "Tiedot",
  "hit.share": "Jaa",
  "hit.share.detail": "Jaa",
  "hit.shareError": "Jotain meni pieleen, kun yritimme jakaa tämän työpaikan.",
  "hit.summerJob": "Kesätyö",
  "hit.toast.applied": "Merkitty haetuksi",
  "hit.toast.hidden": "Työpaikka piilotettu",
  "hit.toast.saved": "Työpaikka tallennettu",
  "hit.toast.shared": "Linkki kopioitu leikepöydälle",
  "hit.toast.unapplied": "Poistettu haetuista",
  "hit.toast.unhidden": "Työpaikka näytetään taas",
  "hit.toast.unsaved": "Työpaikka poistettu tallennetuista",
  "hit.toast.viewed": "Merkitty katsotuksi",
  "hit.tooltip.details": "Näytä työpaikan kaikki tiedot ja kuvaus",
  "hit.tooltip.filterByCompany": "Suodata työpaikat tämän yrityksen mukaan",
  "hit.tooltip.filterByJobType": "Suodata työpaikat tyypin mukaan: {jobType}",
  "hit.tooltip.filterByLanguages": "Suodata työpaikat vaadittujen kielten mukaan: {languages}",
  "hit.tooltip.filterByLevel": "Suodata työpaikat tason mukaan: {level}",
  "hit.tooltip.filterByLocation": "Suodata työpaikat sijainnissa: {locations}",
  "hit.tooltip.filterByRemoteness": "Suodata työpaikat etätyömahdollisuuden mukaan: {remoteness}",
  "hit.tooltip.moreOptions": "Lisää vaihtoehtoja",
  "hit.tooltip.save": "Tallenna tämä työpaikka, jotta voit verrata sitä muihin",
  "hit.tooltip.saved": "Poista tallennetuista työpaikoista",
  "hit.tooltip.share": "Jaa tämä työpaikka",
  "hit.tooltip.viewJob": "Näytä kaikki työpaikan tiedot",
  "hit.lastSeen.minutesAgo": "{value, plural, one {{value} minuutti sitten} other {{value} minuuttia sitten}}",
  "hit.lastSeen.hoursAgo": "{value, plural, one {{value} tunti sitten} other {{value} tuntia sitten}}",
  "hit.lastSeen.daysAgo": "{value, plural, one {{value} päivä sitten} other {{value} päivää sitten}}",
  "hit.unhide": "Näytä työpaikka",
  "instantsearch.searchBoxLink.placeholder": "Hae työpaikkoja",
  "instantsearch.searchbox.placeholder": "Hae työpaikkoja, kielen tai kaupungin mukaan",
  "job.copyCompanyName": "Kopioi yrityksen nimi",
  "job.viewDetails": "Näytä tiedot",
  "jobDetail.similarJobs.description": "Löydä lisää mahdollisuuksia, jotka vastaavat kiinnostuksenkohteitasi ja taitojasi",
  "jobDetail.similarJobs.title": "Aiheeseen liittyvät mahdollisuudet",
  "jobDetailPage.404.backHome": "Takaisin etusivulle",
  "jobDetailPage.404.description": "Pahoittelut, emme löytäneet tätä työpaikkaa. Se on saatettu poistaa tai linkki on virheellinen.",
  "jobDetailPage.404.heading": "Sivua ei löydy",
  "jobDetailPage.aboutCompany": "Tietoa",
  "jobDetailPage.applicationDeadline": "Hakemuksen määräaika",
  "jobDetailPage.applied": "Haettu ✓",
  "jobDetailPage.applyNavigation": "Hae työpaikkaa",
  "jobDetailPage.applyNow": "Hae yrityksen verkkosivustolla",
  "jobDetailPage.availableLanguages": "Saatavilla kielillä:",
  "jobDetailPage.breadcrumb": "Murupolkunavigointi",
  "jobDetailPage.businessId": "Y-tunnus",
  "jobDetailPage.byRemoteness": "Etätyömahdollisuuden mukaan",
  "jobDetailPage.chartsDataRange": "Näytetyt tiedot perustuvat tietokantamme aiempiin työpaikkailmoituksiin.",
  "jobDetailPage.collapseCompensation": "Piilota palkkaustiedot",
  "jobDetailPage.companiesHiringInLocation": "Yritykset, jotka rekrytoivat alueella {location}",
  "jobDetailPage.companyAge": "Yrityksen ikä",
  "jobDetailPage.companyDistributionDescription": "Näytetään {count} eniten työpaikkailmoituksia julkaissutta yritystä",
  "jobDetailPage.compensation": "Palkkaus",
  "jobDetailPage.contact": "Yhteystiedot:",
  "jobDetailPage.description": "Työtehtävän kuvaus",
  "jobDetailPage.estimatedExpiry": "Arvioitu päättymispäivä",
  "jobDetailPage.expandCompensation": "Näytä palkkaustiedot",
  "jobDetailPage.experience": "Kokemus",
  "jobDetailPage.field": "Toimiala",
  "jobDetailPage.headcount": "Henkilöstömäärä",
  "jobDetailPage.hideCharts": "Piilota kaaviot",
  "jobDetailPage.hideOriginalJobText": "Piilota",
  "jobDetailPage.jobActions": "Työpaikan toiminnot",
  "jobDetailPage.jobType": "Työsuhteen tyyppi",
  "jobDetailPage.languageNavigation": "Saatavilla olevat kielet",
  "jobDetailPage.languageRequirements": "Kielivaatimukset",
  "jobDetailPage.loadingMap": "Ladataan karttaa...",
  "jobDetailPage.location": "Sijainti",
  "jobDetailPage.locationAndRemotenessDistribution": "Sijainnin ja etätyön jakauma",
  "jobDetailPage.locationDistribution": "Sijaintijakauma",
  "jobDetailPage.mapError": "Karttaa ei voitu ladata",
  "jobDetailPage.matchBreakdown.benefits": "Edut",
  "jobDetailPage.matchBreakdown.jobType": "Työsuhteen tyyppi",
  "jobDetailPage.matchBreakdown.location": "Sijainti",
  "jobDetailPage.matchBreakdown.remoteness": "Etätyö",
  "jobDetailPage.matchBreakdown.roleLevel": "Tehtävätaso",
  "jobDetailPage.matchBreakdown.salary": "Palkka",
  "jobDetailPage.matchBreakdown.title": "Miten tämä työ vastaa profiiliasi",
  "jobDetailPage.matchBreakdown.titleMatch": "Otsikko",
  "jobDetailPage.matchBreakdown.vacation": "Loma",
  "jobDetailPage.minimumYearsOfExperience": "{years} {years, plural, one {vuosi} other {vuotta}}",
  "jobDetailPage.minimumYearsOfExperience.title": "Vähimmäistyökokemus vuosina",
  "jobDetailPage.minimumYearsOfExperience.value": "{years} {years, plural, one {vuosi} other {vuotta}}",
  "jobDetailPage.noItems": "Ei näytettäviä kohteita.",
  "jobDetailPage.noLocation": "Ei sijaintia",
  "jobDetailPage.noRemoteness": "Ei määritetty",
  "jobDetailPage.notFound.backHome": "Takaisin etusivulle",
  "jobDetailPage.notFound.description": "Emme löytäneet etsimääsi työpaikkaa. Se on saatettu poistaa tai URL-osoite voi olla virheellinen.",
  "jobDetailPage.notFound.title": "Työpaikkaa ei löytynyt",
  "jobDetailPage.optionalLanguages": "Valinnaiset kielet",
  "jobDetailPage.originalJobText": "Alkuperäinen työpaikkailmoituksen teksti",
  "jobDetailPage.originalLanguage": "Alkuperäinen",
  "jobDetailPage.peopleManagementTier": "Esihenkilötaso",
  "jobDetailPage.period.day": "päivä",
  "jobDetailPage.period.hour": "tunti",
  "jobDetailPage.period.month": "kuukausi",
  "jobDetailPage.period.year": "vuosi",
  "jobDetailPage.perks": "Edut",
  "jobDetailPage.remoteness": "Työskentelytapa",
  "jobDetailPage.remotenessDistribution": "Työskentelytapojen jakauma",
  "jobDetailPage.remotenessDistribution.short": "Työskentelytapa",
  "jobDetailPage.requiredLanguages": "Vaaditut kielet",
  "jobDetailPage.requirements": "Vaatimukset",
  "jobDetailPage.responsibilities": "Vastuut",
  "jobDetailPage.roleAndRoleLevelDistribution": "Roolin ja roolitason jakauma",
  "jobDetailPage.roleDistribution": "Roolijakauma",
  "jobDetailPage.roleLevel": "Roolitaso",
  "jobDetailPage.roleLevelDistribution": "Roolitasojen jakauma",
  "jobDetailPage.salaryDetails": "Palkkatiedot",
  "jobDetailPage.salaryStatistics": "Palkkatilastot",
  "jobDetailPage.section.company": "Yrityksen tiedot",
  "jobDetailPage.section.jobDetails": "Työn tiedot",
  "jobDetailPage.section.overview": "Yleiskatsaus",
  "jobDetailPage.seeLocation": "Näytä sijainti",
  "jobDetailPage.seeOriginal": "Näytä alkuperäinen",
  "jobDetailPage.showCharts": "Näytä kaaviot",
  "jobDetailPage.showCompanyContact": "Näytä yrityksen yhteystiedot",
  "jobDetailPage.showContact": "Näytä yhteyssähköposti",
  "jobDetailPage.showConverted": "Näytä EUR/kk",
  "jobDetailPage.showOriginalJobText": "Näytä alkuperäinen työpaikkailmoituksen teksti",
  "jobDetailPage.showingItemsAboveThreshold": "Näytetään vain kohteet, jotka ovat yli {percentage}%",
  "jobDetailPage.specialisations": "Erikoistumisalueet",
  "jobDetailPage.vacationWeeks": "Loma: {weeks} viikkoa",
  "jobDetailPage.viewBenefits": "Näytä edut",
  "jobDetailPage.visa": "Viisumi",
  "jobDetailPage.visaSponsor": "✓ Sponsorointi saatavilla",
  "jobDetailPage.visaSponsor.available": "✓ Viisumisponsorointi on saatavilla tähän tehtävään",
  "jobDetailPage.visaSponsor.title": "Viisumisponsorointi",
  "jobDetailPage.watchCompanyVideo": "Katso yritysvideo",
  "locationCharts.languages.description": "Kielet, joita yritykset {location}:ssa tyypillisesti edellyttävät",
  "locationCharts.languages.title": "Kielivaatimukset",
  "locationCharts.remoteness.description": "Etätyön tuki {location}:ssa",
  "locationCharts.remoteness.title": "Työjärjestelyt",
  "locationCharts.salary.allTitles": "Kaikki roolit",
  "locationCharts.salary.description": "Palkkahaarukat {location}:ssa ({sampleSize} palkan perusteella)",
  "locationCharts.salary.descriptionWithTitle": "Palkkahaarukat tehtävälle {title} {location}:ssa",
  "locationCharts.salary.max": "Maksimi",
  "locationCharts.salary.median": "Mediaani",
  "locationCharts.salary.min": "Minimi",
  "locationCharts.salary.title": "Palkkahaarukat",
  "locationCharts.topCompanies.description": "Yritykset, joilla on eniten työpaikkailmoituksia kohteessa {location} viimeisen vuoden aikana",
  "locationCharts.topCompanies.title": "Eniten rekrytoivat yritykset",
  "locationHeader.clearLocation": "Tyhjennä sijaintisuodatin",
  "locationHeader.companyCount": "{count, plural, one {# yritys} other {# yritystä}}",
  "locationHeader.industryCount": "{count, plural, one {# toimiala} other {# toimialaa}}",
  "locationHeader.title": "Avoimet työpaikat kohteessa {location}",
  "locationHeader.trends.loading": "Ladataan sijaintitietoja...",
  "locationHub.activeJobs": "Työpaikat",
  "locationHub.avgSalary": "Palkka",
  "locationHub.hero.description": "Tutustu Suomen suurimpiin kaupunkeihin reaaliaikaisilla työpaikkamäärillä, palkkatiedoilla ja markkinadatalla. Löydä seuraava mahdollisuutesi Suomen kukoistavasta teknologiaekosysteemistä.",
  "locationHub.hero.subtitle": "Kuratoidut kaupunkioppaat ja työpaikkahaut ympäri Suomen",
  "locationHub.hero.title": "Suomen työmarkkinat",
  "locationHub.hero.title.breadcrumb": "Selaa työpaikkoja sijainnin mukaan",
  "locationHub.languages": "Kielet",
  "locationHub.metropolitan.seo": "Helsingin seutu, mukaan lukien Espoo ja Vantaa, on Suomen ensisijainen talouden veturi, ja se tarjoaa suurimman tiheyden englanninkielisiä ja etärooleja sekä erinomaiset liikenneyhteydet (HSL).",
  "locationHub.overview.description": "Tutustu Suomen johtaviin teknologia- ja innovaatiokeskittymiin reaaliaikaisen työmarkkinadatan, palkkatietojen ja toimialatrendien avulla.",
  "locationHub.overview.title": "Tärkeimmät teknologiakeskittymät",
  "locationHub.quickJump.overview": "Yleiskatsaus",
  "locationHub.resourcesLink": "Tutustu työmarkkinanäkemyksiin ja uravinkkeihin",
  "locationHub.structuredData.collectionPage.description": "Löydä työmahdollisuuksia Suomen suurimmissa kaupungeissa sekä palkkatietoja ja markkinadataa",
  "locationHub.structuredData.collectionPage.name": "Suomen sijaintikeskus",
  "locationHub.structuredData.itemList.description": "Tutustu työmahdollisuuksiin Suomen suurimmissa kaupungeissa",
  "locationHub.structuredData.itemList.name": "Työpaikkasijainnit Suomessa",
  "locationHub.table.activeJobs": "Avoimet työpaikat",
  "locationHub.table.avgSalary": "Keskipalkka",
  "locationHub.table.city": "Kaupunki",
  "locationHub.table.specialty": "Erikoisala",
  "locationHub.workModel": "Työmalli",
  "map.jobs": "työpaikkaa",
  "map.jobsInView": "Näkymässä olevat työpaikat",
  "map.loading": "Ladataan karttaa...",
  "map.noJobs": "Ei työpaikkoja tällä alueella",
  "map.noLocations": "Kartalla ei ole näytettävissä työpaikkoja, joilla on sijaintitiedot",
  "map.tokenMissing": "Karttanäkymä edellyttää Mapboxin käyttöoikeustunnusta",
  "marketHeader.collapsed.subtitle": "Klikkaa laajentaaksesi ja nähdäksesi markkinatiedot sijainnista {location}",
  "marketHeader.filter.english": "Vain englanniksi",
  "marketHeader.filter.highSalary": "Korkea palkka",
  "marketHeader.filter.remote": "Etätyöpaikat",
  "marketHeader.filterNavigation": "Sijaintisuodattimet",
  "marketHeader.language.chartDescription": "Kielivaatimusten jakaumakaavio sijainnille {location}: {englishPercent}% englanti ja {localPercent}% paikallinen kieli.",
  "marketHeader.language.english": "Englanti",
  "marketHeader.language.finlandComparison": "Suomi: {finlandEnglish}% englanti",
  "marketHeader.language.label": "Kielikysyntä",
  "marketHeader.language.mixed": "Sekalainen",
  "marketHeader.qa.languageQuestion": "Mitä kieliä {location} edellyttää?",
  "marketHeader.qa.remoteAnswer": "Kyllä, {answer}",
  "marketHeader.qa.remoteQuestion": "Onko {location} etätyöystävällinen?",
  "marketHeader.qa.salaryQuestion": "Mikä on keskipalkka sijainnissa {location}?",
  "marketHeader.salary.finlandComparison": "Suomen keskiarvo: {finlandAvg}",
  "marketHeader.salary.label": "Palkkatrendit",
  "marketHeader.salary.range": "Palkkahaarukka",
  "marketHeader.salary.rangePercentile": "25.–75. prosenttipisteen vaihteluväli",
  "marketHeader.samples": "{count} otosta",
  "marketHeader.table.activeJobs": "Avoimet työpaikat",
  "marketHeader.table.avgSalary": "Keskipalkka",
  "marketHeader.table.englishLanguageRequirementPercent": "Englannin kielen vaatimus %",
  "marketHeader.table.location": "Sijainti",
  "marketHeader.table.metric": "Mittari",
  "marketHeader.table.remoteWorkPercent": "Etätyö %",
  "marketHeader.table.topHiringCompany": "Eniten rekrytoiva yritys",
  "marketHeader.table.value": "Arvo",
  "marketHeader.title": "Avoimet työpaikat sijainnissa {location}",
  "marketHeader.toggle": "Näytä/piilota markkinaotsikko",
  "marketHeader.updated": "Päivitetty:",
  "marketHeader.viewLocationHub": "Näytä sijaintikeskus",
  "marketHeader.workModel.breakdown.hybrid": "{percent}% hybridi",
  "marketHeader.workModel.breakdown.onsite": "{percent}% paikan päällä",
  "marketHeader.workModel.breakdown.remote": "{percent}% etänä",
  "marketHeader.workModel.chartDescription": "Työmallien jakaumakaavio sijainnille {location}: {onsitePercent}% toimistolla, {hybridPercent}% hybridi ja {remotePercent}% etätyöpaikkoja.",
  "marketHeader.workModel.finlandComparison": "Suomi: {finlandRemote}% etä/hybridi",
  "marketHeader.workModel.hybridPercent": "{percent}% Hybridi",
  "marketHeader.workModel.label": "Työmalli",
  "marketHeader.workModel.noData": "Joustava",
  "marketHeader.workModel.onsitePercent": "{percent}% Toimistolla",
  "marketHeader.workModel.remotePercent": "{percent}% Etä",
  "matchDonut.ariaLabel": "Vastaavuuspisteet: {score}%",
  "matchDonut.breakdown.benefits": "Edut",
  "matchDonut.breakdown.remoteness": "Etätyömahdollisuus",
  "matchDonut.breakdown.salary": "Palkka",
  "matchDonut.breakdown.title": "Sopivuuspisteiden erittely",
  "matchDonut.breakdown.vacation": "Loma",
  "matchDonut.loginPrompt.description": "Luo profiili ja lisää nykyisen työsi tiedot nähdäksesi, kuinka hyvin työpaikat vastaavat mieltymyksiäsi",
  "matchDonut.loginPrompt.title": "Kirjaudu sisään nähdäksesi sopivuuspisteesi",
  "matchDonut.loginPromptAria": "Kirjaudu sisään nähdäksesi sopivuuspisteesi",
  "modal.close": "Sulje",
  "navigation.blog": "Resurssit",
  "navigation.home": "Etusivu",
  "navigation.home.breadcrumb": "Etusivu",
  "navigation.language": "Kieli",
  "navigation.language.label": "Kieli",
  "navigation.locations": "Toimipisteet",
  "navigation.locations.menu": "Toimipisteiden keskus",
  "navigation.menu": "Valikko",
  "navigation.menu.heading": "Valikko",
  "navigation.search": "Hae työpaikkoja",
  "navigation.search.menu": "Etsi työpaikkoja",
  "numberSelector.any": "Mikä tahansa",
  "pagination.ariaLabel": "Työhaun tulosten sivutus",
  "pagination.first": "Ensimmäinen",
  "pagination.last": "Viimeinen",
  "pagination.next": "Seuraava",
  "pagination.previous": "Edellinen",
  "privacy.analytics.description": "Saatamme käyttää kolmansien osapuolten analytiikkatyökaluja kerätäksemme tietoa siitä, miten käytät verkkosivustoamme, mukaan lukien vierailemasi sivut ja niillä viettämäsi aika. Näitä tietoja käytetään ainoastaan palveluidemme parantamiseen.",
  "privacy.analytics.title": "Analytiikka",
  "privacy.changes.description": "Saatamme päivittää tätä tietosuojakäytäntöä ajoittain. Muutokset julkaistaan tällä sivulla ja tulevat voimaan välittömästi julkaisemisen jälkeen. Jos sinulla on kysyttävää tai huolenaiheita, ota meihin yhteyttä yllä olevaan sähköpostiosoitteeseen.",
  "privacy.changes.title": "Muutokset tähän käytäntöön",
  "privacy.dataCollection.description": "Tietojesi keräämisen ensisijainen tarkoitus on analytiikka, joka auttaa meitä ymmärtämään, miten käyttäjät ovat vuorovaikutuksessa sivustomme kanssa, jotta voimme parantaa käyttökokemustasi. Keräämme vain tietoja, jotka ovat tarpeen verkkosivustomme ja palveluidemme parantamiseksi.",
  "privacy.dataCollection.title": "Tietojen kerääminen ja käyttö",
  "privacy.dataProtection.description": "Otamme käyttöön asianmukaiset turvatoimet suojataksemme tietojasi luvattomalta käytöltä, muuttamiselta, luovuttamiselta tai tuhoamiselta. Säilytämme tietoja niin kauan kuin se on tarpeen tässä käytännössä kuvattujen tarkoitusten toteuttamiseksi tai lain edellyttämällä tavalla.",
  "privacy.dataProtection.title": "Tietosuoja ja säilytys",
  "privacy.intro": "Yksityisyytesi on meille tärkeää. Tämä käytäntö selittää, miten käsittelemme tietojasi.",
  "privacy.title": "Tietosuojakäytäntö",
  "privacy.yourRights.description": "EU:ssa asuvana käyttäjänä sinulla on oikeus pyytää pääsyä henkilötietoihisi sekä niiden oikaisua tai poistamista, ja lisäksi oikeus rajoittaa tai vastustaa tiettyjä käsittelytoimia. Lisätietoja tai näiden oikeuksien käyttämistä varten ota meihin yhteyttä osoitteessa",
  "privacy.yourRights.title": "Oikeutesi",
  "profile.aiPolish": "AI-viimeistely",
  "profile.benefits": "Edut",
  "profile.benefitsWeight": "Etujen painotus: {weight}%",
  "profile.company": "Yrityksen tiedot",
  "profile.companyIndustry": "Toimiala",
  "profile.companyName": "Yrityksen nimi",
  "profile.companyNamePlaceholder": "esim. Acme Inc.",
  "profile.currentJob": "Nykyinen työ",
  "profile.currentJobTooltip": "Kerro meille nykyisestä tehtävästäsi. Tämä auttaa meitä ymmärtämään taustaasi ja vertailemaan mahdollisuuksia.",
  "profile.cvUploadError": "Lataa PDF-tiedosto",
  "profile.cvUploadFailed": "CV:n lataaminen epäonnistui. Yritä uudelleen.",
  "profile.cvUploadSizeError": "Tiedoston koon on oltava alle 5 Mt",
  "profile.desiredBenefits": "Toivotut edut",
  "profile.desiredIndustries": "Yritysten toimialat",
  "profile.desiredJob": "Toivottu työ",
  "profile.desiredJobTooltip": "Kerro meille, mitä etsit. Voit valita useita vaihtoehtoja kussakin kentässä laajentaaksesi hakuasi.",
  "profile.desiredJobTypes": "Työtyypit",
  "profile.desiredLocations": "Sijainnit",
  "profile.desiredRemoteness": "Etätyövaihtoehdot",
  "profile.desiredRoleLevels": "Roolitasot",
  "profile.desiredSalaryMin": "Vähimmäispalkka",
  "profile.desiredTitles": "Tehtävänimikkeet",
  "profile.desiredVacationWeeks": "Vähimmäislomaviikot",
  "profile.exportCV": "Vie CV",
  "profile.jobType": "Työsuhteen tyyppi",
  "profile.loading": "Ladataan...",
  "profile.locations": "Sijainnit",
  "profile.matchPreferences": "Vastaavuusasetukset",
  "profile.matchPreferencesDescription": "Säädä eri tekijöiden painoarvoa, kun työpaikkavastaavuuspisteitäsi lasketaan. Yhteissumman on oltava 100 %.",
  "profile.monthlyEuros": "€/kk",
  "profile.preview": "Esikatsele",
  "profile.remoteness": "Etätyö",
  "profile.remotenessWeight": "Etätyön painoarvo: {weight}%",
  "profile.reset": "Palauta oletukset",
  "profile.roleLevel": "Roolitaso",
  "profile.salary": "Palkka",
  "profile.salaryWeight": "Palkan painotus: {weight}%",
  "profile.selectIndustry": "Valitse toimiala",
  "profile.selectJobType": "Valitse työsuhteen tyyppi",
  "profile.selectLocations": "Valitse sijainnit",
  "profile.selectMultipleIndustries": "Valitse yksi tai useampi toimiala",
  "profile.selectMultipleJobTypes": "Valitse yksi tai useampi työsuhteen tyyppi",
  "profile.selectMultipleLocations": "Valitse yksi tai useampi sijainti",
  "profile.selectMultipleRemoteness": "Valitse yksi tai useampi etätyövaihtoehto",
  "profile.selectMultipleRoleLevels": "Valitse yksi tai useampi roolitaso",
  "profile.selectMultipleTitles": "Valitse yksi tai useampi työnimike",
  "profile.selectRemoteness": "Valitse etätyömalli",
  "profile.selectRoleLevel": "Valitse roolitasosi",
  "profile.title": "Työnimike",
  "profile.titlePlaceholder": "esim. ohjelmistokehittäjä",
  "profile.totalWeight": "Yhteensä",
  "profile.vacationWeeks": "Lomaviikot",
  "profile.vacationWeight": "Loman painoarvo: {weight}%",
  "profile.weeks": "viikkoa",
  "recentSearches.delete": "Poista",
  "recentSearches.noSearches": "Et ole vielä tehnyt yhtään hakua.",
  "recentSearches.recentSearchesTitle": "Viimeisimmät haut",
  "recentSearches.savedSearchesTitle": "Tallennetut haut",
  "recentSearches.viewResults": "Näytä tulokset",
  "route.description.appliedJobs": "Täältä löydät kaikki työpaikat, joihin olet hakenut.",
  "route.description.hiddenJobs": "Täältä löydät kaikki työpaikat, jotka olet piilottanut.",
  "route.description.hiredJobs": "Täältä löydät kaikki työpaikat, joihin sinut on palkattu.",
  "route.description.interviewingJobs": "Täältä löydät kaikki työpaikat, joiden haastatteluprosessissa olet mukana.",
  "route.description.offerJobs": "Täältä löydät kaikki työpaikat, joista olet saanut tarjouksen.",
  "route.description.rejectedJobs": "Täältä löydät kaikki työpaikat, joista sinut on hylätty.",
  "route.description.savedJobs": "Täältä löydät kaikki työpaikat, jotka olet tallentanut myöhempää varten.",
  "route.description.viewedJobs": "Täältä löydät kaikki työpaikat, joita olet katsonut.",
  "route.title.appliedJobs": "Haetut työpaikat",
  "route.title.hiddenJobs": "Piilotetut työpaikat",
  "route.title.hiredJobs": "Työpaikat, joihin sinut on palkattu",
  "route.title.interviewingJobs": "Haastattelussa olevat työpaikat",
  "route.title.offerJobs": "Tarjotut työpaikat",
  "route.title.recentSearches": "Viimeisimmät haut",
  "route.title.rejectedJobs": "Hylätyt työpaikat",
  "route.title.savedJobs": "Tallennetut työpaikat",
  "route.title.viewedJobs": "Katsotut työpaikat",
  "salaryChart.companyLocation": "Yritys sijainnissa {location}",
  "salaryChart.estimatedOffer": "Arvioitu tarjous",
  "salaryChart.locationAverage": "Sijainnissa {location}: {title}",
  "salaryChart.marketAverage": "Markkinakeskiarvo: {title}",
  "salaryChart.marketAverageRoleLevel": "Markkinakeskiarvo: {roleLevel}-taso",
  "salaryChart.salaryContext": "Palkkakonteksti: {title}",
  "salaryChart.specificOffer": "Tämä tarjous ({roleLevel})",
  "salaryChart.specificOfferNoLevel": "Tämä tarjous",
  "salaryChart.thisRole": "tämä rooli",
  "salaryChart.thisRoleLevel": "tämä roolitaso",
  "salaryStats.aboveMarket": "Tämä palkka on markkinoiden mediaanin yläpuolella",
  "salaryStats.accuracy.exact": "Perustuu tämän yrityksen samankaltaisiin rooleihin",
  "salaryStats.accuracy.general": "Perustuu markkinadataan",
  "salaryStats.accuracy.location": "Perustuu palkkoihin sijainnissa {location}",
  "salaryStats.atMarket": "Tämä palkka on kilpailukykyinen markkinoiden mediaaniin nähden",
  "salaryStats.average": "Keskimääräinen",
  "salaryStats.belowMarket": "Tämä palkka on markkinoiden mediaanin alapuolella",
  "salaryStats.jobSalary": "Tämä työpaikka",
  "salaryStats.marketRange": "Markkina-alue: {min}–{max} (mediaani: {median})",
  "salaryStats.median": "Mediaani",
  "salaryStats.noJobSalary": "Tälle tehtävälle ei ole annettu palkkahaarukkaa. Kaavio näyttää markkinajakauman.",
  "salaryStats.noValidValues": "Palkkatilastot ovat saatavilla ({sampleSize} {samples}), mutta kaikki arvot ovat nollia. Tämä voi tarkoittaa, että data täytyy luoda uudelleen.",
  "salaryStats.perDay": "päivässä",
  "salaryStats.perHour": "tunnissa",
  "salaryStats.perMonth": "kuukaudessa",
  "salaryStats.perYear": "vuodessa",
  "salaryStats.percentiles": "25.–75. prosenttipiste",
  "salaryStats.samples": "havaintoa",
  "salaryStats.smallSampleWarning": "Huom: Perustuu pieneen otokseen ({sampleSize} {samples}). Tulokset eivät välttämättä ole edustavia.",
  "search.clear": "Tyhjennä haku",
  "search.controls.navigation": "Haun ohjaimet ja suodattimet",
  "search.noresults.browseAll": "Selaa kaikkia työpaikkoja",
  "search.noresults.clearAllParameters": "Tyhjennä kaikki hakuehdot",
  "search.noresults.clearSearch": "Tyhjennä haku",
  "search.noresults.description": "Kokeile muokata hakua tai suodattimia löytääksesi lisää mahdollisuuksia.",
  "search.noresults.filtersLabel": "Suodattimet:",
  "search.noresults.goToFirstPage": "Siirry sivulle 1",
  "search.noresults.industries": "Toimialat",
  "search.noresults.jobRoles": "Työtehtävät",
  "search.noresults.locations": "Sijainnit",
  "search.noresults.pageLabel": "Sivu:",
  "search.noresults.popularCategories": "Suositut kategoriat",
  "search.noresults.queryLabel": "Haku:",
  "search.noresults.removeQuery": "Poista",
  "search.noresults.searchParameters": "Hakuehtosi",
  "search.noresults.searchTips": "Hakuvinkit",
  "search.noresults.tip1": "Kokeile laajempia hakusanoja tai poista joitakin suodattimia",
  "search.noresults.tip2": "Tarkista oikeinkirjoitus tai kokeile vaihtoehtoisia hakusanoja",
  "search.noresults.tip3": "Selaa yllä olevia suosittuja kategorioita ja löydä uusia mahdollisuuksia",
  "search.noresults.title": "Ei tuloksia",
  "search.noresults.trySearches": "Kokeile näitä hakuja:",
  "search.refinements.allFilters": "Kaikki suodattimet",
  "search.refinements.allFilters.aria": "Kaikki suodattimet",
  "search.refinements.benefits": "Etuudet",
  "search.refinements.benefits.label": "Etuudet",
  "search.refinements.benefits.modal": "Etuudet",
  "search.refinements.company": "Yritys",
  "search.refinements.company.heading": "Yritys",
  "search.refinements.company.label": "Yritys",
  "search.refinements.company.modal": "Yritys",
  "search.refinements.company.searchPlaceholder": "Hae yrityksiä...",
  "search.refinements.company.section": "Yritys",
  "search.refinements.educationLevel": "Koulutustaso",
  "search.refinements.educationLevel.detail": "Koulutustaso",
  "search.refinements.educationLevel.heading": "Koulutustaso",
  "search.refinements.educationLevel.label": "Koulutustaso",
  "search.refinements.educationLevel.modal": "Koulutustaso",
  "search.refinements.excludeApplied.checkbox": "Sulje pois haetut työpaikat",
  "search.refinements.excludeApplied.label": "Sulje pois haetut työpaikat",
  "search.refinements.excludeSaved.checkbox": "Sulje pois tallennetut työpaikat",
  "search.refinements.excludeSaved.label": "Sulje pois tallennetut työpaikat",
  "search.refinements.excludeViewed.checkbox": "Sulje pois katsotut työpaikat",
  "search.refinements.excludeViewed.label": "Sulje pois katsotut työpaikat",
  "search.refinements.field": "Toimiala",
  "search.refinements.field.label": "Toimiala",
  "search.refinements.field.modal": "Toimiala",
  "search.refinements.headcount": "Yrityksen henkilöstömäärä (enintään)",
  "search.refinements.headcount.max": "Enimmäishenkilöstömäärä",
  "search.refinements.industry": "Toimiala",
  "search.refinements.industry.heading": "Toimiala",
  "search.refinements.industry.label": "Toimiala",
  "search.refinements.industry.modal": "Toimiala",
  "search.refinements.isDriversLicenseRequired.filter": "Ajokortti vaaditaan",
  "search.refinements.isDriversLicenseRequired.toggle": "Ajokortti vaaditaan",
  "search.refinements.isOpenApplication.filter": "Avoin hakemus",
  "search.refinements.isOpenApplication.toggle": "Avoin hakemus",
  "search.refinements.isSummerJob.filter": "Kesätyö",
  "search.refinements.isSummerJob.toggle": "Kesätyö",
  "search.refinements.job": "Työ",
  "search.refinements.job.modal": "Työsuodattimet",
  "search.refinements.job.section": "Työ",
  "search.refinements.jobTitle": "Työnimike",
  "search.refinements.jobType": "Työsuhteen tyyppi",
  "search.refinements.jobType.label": "Työsuhteen tyyppi",
  "search.refinements.jobType.modal": "Työsuhteen tyyppi",
  "search.refinements.languages": "Kielet",
  "search.refinements.languages.label": "Kielet",
  "search.refinements.languages.modal": "Kielet",
  "search.refinements.lastSeen": "Viimeksi nähty",
  "search.refinements.lastSeen.aria": "Viimeksi nähty",
  "search.refinements.lastSeen.all": "Kaikki",
  "search.refinements.lastSeen.past6Hours": "Viimeiset 6 tuntia",
  "search.refinements.lastSeen.past24Hours": "Viimeiset 24 tuntia",
  "search.refinements.lastSeen.past3Days": "Viimeiset 3 päivää",
  "search.refinements.lastSeen.past1Week": "Viimeinen viikko",
  "search.refinements.lastSeen.past2Weeks": "Viimeiset 2 viikkoa",
  "search.refinements.lastSeen.past1Month": "Viimeinen kuukausi",
  "search.refinements.location": "Sijainti",
  "search.refinements.location.finland": "Suomi",
  "search.refinements.location.modal": "Sijainti",
  "search.refinements.location.remote": "Etätyö",
  "search.refinements.location.searchPlaceholder": "Hae sijainteja...",
  "search.refinements.location.section": "Sijainti",
  "search.refinements.peopleManagementTier": "Henkilöstövastuun taso",
  "search.refinements.peopleManagementTier.label": "Henkilöstövastuun taso",
  "search.refinements.peopleManagementTier.modal": "Esihenkilövastuun taso",
  "search.refinements.remoteness.heading": "Etätyömahdollisuus",
  "search.refinements.remoteness.label": "Etätyömahdollisuus",
  "search.refinements.remoteness.modal": "Etätyömahdollisuus",
  "search.refinements.roleLevel": "Roolitaso",
  "search.refinements.roleLevel.label": "Roolitaso",
  "search.refinements.roleLevel.modal": "Roolitaso",
  "search.refinements.salary": "Palkka",
  "search.refinements.salary.heading": "Palkka",
  "search.refinements.salary.label": "Palkka",
  "search.refinements.salary.min": "Vähimmäispalkka",
  "search.refinements.salary.modal": "Palkka",
  "search.refinements.salary.section": "Palkka",
  "search.refinements.showJobsInFinlandOnly": "Näytä vain työpaikat Suomessa",
  "search.refinements.showLess": "Näytä vähemmän",
  "search.refinements.showMore": "Näytä lisää",
  "search.refinements.skillsAndTechnologies": "Taidot ja teknologiat",
  "search.refinements.skillsAndTechnologies.label": "Taidot ja teknologiat",
  "search.refinements.skillsAndTechnologies.modal": "Taidot ja teknologiat",
  "search.refinements.vacationWeeks": "Lomaviikot",
  "search.refinements.vacationWeeks.heading": "Lomaviikot",
  "search.refinements.vacationWeeks.label": "Lomaviikot",
  "search.refinements.vacationWeeks.modal": "Lomaviikot",
  "search.results.title": "Työnhaun tulokset",
  "search.save": "Tallenna haku",
  "search.signInCta.badge": "Synkronoi hakusi",
  "search.signInCta.button": "Kirjaudu sisään synkronoidaksesi edistymisen",
  "search.signInCta.description": "Kirjaudu sisään, jotta tallennetut työpaikat, haut ja edistyminen pysyvät synkronoituna kaikilla laitteillasi.",
  "search.signInCta.title": "Tallenna työnhakusi kaikkialle",
  "search.toast.saved": "Haku tallennettu",
  "search.toast.unsaved": "Haku poistettu",
  "search.unsave": "Poista tallennettu haku",
  "sort.ariaLabel": "Lajittele tulokset",
  "sort.newest": "Uusimmat",
  "sort.relevance": "Osuvuus",
  "sort.salary": "Korkein palkka",
  "stats.appliedJobs": "{count} haettua työpaikkaa",
  "stats.finlandJobsSubtitle": "Työpaikkoja saatavilla suomeksi tai etänä Suomessa asuville",
  "stats.savedJobs": "{count} tallennettua työpaikkaa",
  "stats.viewedJobs": "{count} katsottua työpaikkaa",
  "studentsAndGraduates.description": "Käynnistä urasi Suomessa tarjolla olevilla aloitustason työpaikoilla, harjoitteluilla ja vastavalmistuneiden ohjelmilla. Täydellinen opiskelijoille, vastavalmistuneille ja kaikille, jotka haluavat aloittaa ammatillisen matkansa.",
  "studentsAndGraduates.tip": "💡 Vinkki: Nämä tehtävät on suunniteltu erityisesti uransa alussa oleville. Etsi työpaikkojen nimikkeistä avainsanoja kuten 'intern', 'junior', 'graduate' tai 'trainee'.",
  "studentsAndGraduates.title": "Työpaikat opiskelijoille ja vastavalmistuneille",
  "studentsAndGraduates.title.breadcrumb": "Opiskelijat ja vastavalmistuneet",
  "summerJobs.description": "Löydä täydellinen kesätyömahdollisuus Suomessa. Olitpa opiskelija, joka etsii kausityötä, tai joku, joka hakee kesäksi uranvaihtoa, löydä paikkoja eri toimialoilta.",
  "summerJobs.tip": "💡 Vinkki: Kesätyöt Suomessa sijoittuvat tyypillisesti toukokuusta elokuuhun, ja monia paikkoja julkaistaan alkukeväästä. Aloita haku ajoissa varmistaaksesi parhaat mahdollisuudet!",
  "summerJobs.title": "Kesätyöt Suomessa",
  "summerJobs.title.breadcrumb": "Kesätyöt",
  "terms.acceptance.description": "Käyttämällä verkkosivustoamme ja palveluitamme vahvistat, että olet lukenut ja ymmärtänyt nämä käyttöehdot sekä tietosuojakäytäntömme ja sitoudut noudattamaan niitä. Jos et hyväksy mitään osaa näistä ehdoista, sinun tulee lopettaa palveluidemme käyttö.",
  "terms.acceptance.title": "1. Ehtojen hyväksyminen",
  "terms.changes.description": "Saatamme päivittää näitä käyttöehtoja ajoittain. Kun teemme niin, julkaisemme tarkistetut ehdot tällä sivulla. Sivustomme käytön jatkaminen muutosten jälkeen merkitsee, että hyväksyt uudet ehdot.",
  "terms.changes.title": "7. Muutokset näihin ehtoihin",
  "terms.contact.description": "Jos sinulla on kysyttävää näistä käyttöehdoista, ota meihin yhteyttä osoitteessa:",
  "terms.contact.title": "8. Ota yhteyttä",
  "terms.intellectualProperty.description": "Kaikki tämän sivuston sisältö, tavaramerkit ja data, mukaan lukien teksti, grafiikka, kuvat ja ohjelmistot, ovat JobCrawlsin tai sen lisenssinantajien omaisuutta. Et saa käyttää tai jäljentää mitään osaa sivuston sisällöstä ilman meiltä saatua kirjallista lupaa.",
  "terms.intellectualProperty.title": "3. Immateriaalioikeudet",
  "terms.intro": "Tervetuloa JobCrawlsiin! Käyttämällä verkkosivustoamme hyväksyt, että sinua sitovat nämä käyttöehdot. Lue ne huolellisesti ennen alustamme käyttöä. Olemme suomalainen yritys, ja näihin ehtoihin sovelletaan soveltuvaa Suomen ja EU:n lainsäädäntöä.",
  "terms.limitationOfLiability.description": "JobCrawls ja sen konserniyhtiöt eivät ole vastuussa mistään välillisistä, satunnaisista, erityisistä tai seuraamuksellisista vahingoista, jotka johtuvat verkkosivustomme tai palveluidemme käytöstä tai liittyvät siihen millään tavoin. Kaikissa tapauksissa vastuumme rajoittuu Suomen ja EU:n lainsäädännön sallimaan enimmäismäärään.",
  "terms.limitationOfLiability.title": "4. Vastuunrajoitus",
  "terms.modifications.description": "Pidätämme oikeuden muuttaa, keskeyttää tai lopettaa palvelumme minkä tahansa osan milloin tahansa ilman ennakkoilmoitusta. Emme ole vastuussa, jos käytämme tätä oikeutta.",
  "terms.modifications.title": "5. Palvelun muutokset",
  "terms.termination.description": "Voimme lopettaa tai keskeyttää pääsysi verkkosivustollemme välittömästi ilman ennakkoilmoitusta, jos toteamme, että olet rikkonut näitä käyttöehtoja, tai mistä tahansa muusta syystä, jonka katsomme tarpeelliseksi.",
  "terms.termination.title": "6. Irtisanominen",
  "terms.title": "Käyttöehdot",
  "terms.userObligations.description": "Sitoudut käyttämään JobCrawlsia kaikkien sovellettavien lakien ja määräysten mukaisesti. Et saa käyttää sivustoamme tavalla, joka loukkaa muiden oikeuksia tai rajoittaa tai estää kenenkään muun sivuston käyttöä ja siitä nauttimista.",
  "terms.userObligations.title": "2. Käyttäjän velvollisuudet",
  "tools.applicationState.applied": "Haettu",
  "tools.applicationState.hidden": "Piilotettu",
  "tools.applicationState.label": "Tila:",
  "tools.applicationState.updated": "Tila päivitetty: {state}",
  "tools.appliedJobs": "Haetut työpaikat",
  "tools.appliedJobs.link": "Haetut työpaikat",
  "tools.hiddenJobs": "Piilotetut työpaikat",
  "tools.hiddenJobs.link": "Piilotetut työpaikat",
  "tools.hiredJobs": "Palkatut työpaikat",
  "tools.hiredJobs.link": "Palkatut työpaikat",
  "tools.interviewingJobs": "Haastattelussa olevat työpaikat",
  "tools.interviewingJobs.link": "Haastattelussa olevat työpaikat",
  "tools.jobFlow": "Työnkulku",
  "tools.jobFlow.link": "Työnkulku",
  "tools.jobFlowSankey.applied": "Haettu",
  "tools.jobFlowSankey.browsed": "Selattu",
  "tools.jobFlowSankey.description": "Visualisoi työnhakumatkasi selailusta hakemiseen",
  "tools.jobFlowSankey.hired": "Palkattu",
  "tools.jobFlowSankey.interviewing": "Haastattelussa",
  "tools.jobFlowSankey.offer": "Tarjous",
  "tools.jobFlowSankey.rejected": "Hylätty",
  "tools.jobFlowSankey.saved": "Tallennettu",
  "tools.jobFlowSankey.title": "Työnhaun eteneminen",
  "tools.jobFlowSankey.viewed": "Katsottu",
  "tools.offerJobs": "Tarjoa työpaikkoja",
  "tools.offerJobs.link": "Tarjoa työpaikkoja",
  "tools.recentSearches": "Viimeisimmät haut",
  "tools.recentSearches.link": "Viimeisimmät haut",
  "tools.rejectedJobs": "Hylätyt työpaikat",
  "tools.rejectedJobs.link": "Hylätyt työpaikat",
  "tools.savedJobs": "Tallennetut työpaikat",
  "tools.savedJobs.link": "Tallennetut työpaikat",
  "tools.title": "Työkalut",
  "tools.title.aria": "Työkalut",
  "tools.title.button": "Työkalut",
  "tools.viewedJobs": "Katsotut työpaikat",
  "tools.viewedJobs.link": "Katsotut työpaikat",
  "tooltip.allFilters": "Avaa kaikki suodattimet ja tarkenna työnhakuasi sijainnin, palkan, työn tyypin ja muun mukaan",
  "tooltip.filter.category": "Suodata työpaikkoja kategorian {category} mukaan",
  "tooltip.filter.english": "Suodata näyttämään vain työpaikat, joissa vaaditaan englannin kieltä",
  "tooltip.filter.highSalary": "Suodata näyttämään vain korkean palkan työpaikat (5000 €+/kk)",
  "tooltip.filter.remote": "Suodata näyttämään vain etä- tai hybridityömahdollisuudet",
  "tooltip.language": "Vaihda sivuston kieli (englanti, suomi, ruotsi)",
  "tooltip.logo": "Siirry etusivulle ja tyhjennä haku",
  "tooltip.menu": "Avaa valikko, jotta pääset tallennettuihin työpaikkoihin, profiiliin ja asetuksiin",
  "tooltip.nav.home": "Palaa etusivulle",
  "tooltip.nav.locations": "Tutustu työmarkkinoihin kaupungeittain ja alueittain",
  "tooltip.nav.resources": "Selaa artikkeleita ja oppaita työskentelystä Suomessa",
  "tooltip.nav.search": "Hae ja suodata työpaikkailmoituksia",
  "tooltip.toggleHeader": "Näytä/piilota markkinaotsikko",
  "tooltip.tools": "Avaa työnhaun työkalut ja apuohjelmat",
  "tooltip.view.grid": "Vaihda ruudukkonäkymään nähdäksesi työpaikkakortit ruudukkoasettelussa",
  "tooltip.view.list": "Vaihda listanäkymään nähdäksesi työpaikat tiiviissä listamuodossa",
  "tooltip.view.map": "Vaihda karttanäkymään nähdäksesi työpaikkojen sijainnit kartalla",
  "usermenu.appliedJobs": "Haetut työpaikat",
  "usermenu.blog": "Resurssit ja blogi",
  "usermenu.blog.link": "Resurssit",
  "usermenu.installPwa": "Asenna sovellus",
  "usermenu.jobFlow": "Oma aktiivisuutesi",
  "usermenu.login": "Kirjaudu sisään",
  "usermenu.logout": "Kirjaudu ulos",
  "usermenu.profile": "Oma profiili",
  "usermenu.recentSearches": "Viimeisimmät haut",
  "usermenu.savedJobs": "Tallennetut työpaikat",
  "usermenu.theme": "Teema",
  "usermenu.theme.light": "Vaalea",
  "usermenu.theme.dark": "Tumma",
  "usermenu.theme.auto": "Automaattinen",
  "usermenu.viewedJobs": "Katsotut työpaikat",
  "view.grid": "Ruudukkonäkymä",
  "view.list": "Luettelonäkymä",
  "view.map": "Karttanäkymä",
  "translation.test": "Käännöstesti: Suomi"
};

export const messages = {
  en: messages_en,
  sv: messages_sv,
  fi: messages_fi,
};

// Option 1: Hardcode the list of locales
export const supportedLocales = ['en', 'fi', 'sv'];

// Option 2: Dynamically derive from messages keys
// (uncomment if you prefer dynamic retrieval)
// export const supportedLocales = Object.keys(messages);

export const defaultLocale = 'en';
